import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/components/selector/Selector.tsx
import { Grid as Grid6, useMediaQuery } from "@printdeal/ui-library";
import { useEffect as useEffect13, useMemo as useMemo7, useState as useState16 } from "react";
import clsx3 from "clsx";
import { trackExperimentVariation, useExperiment as useExperiment4, useFeatureConfig as useFeatureConfig3, useGetExperiment as useGetExperiment2 } from "@printdeal/feature-management/react";
import { useIntl as useIntl18 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry4 } from "@printdeal/data-layer-manager";

// src/helpers/sentry.ts
import { ErrorManagement } from "@printdeal/error-management/react";
var Sentry = {
  addTrace(breadcrumb) {
    try {
      ErrorManagement.addTrace(breadcrumb);
    } catch (error) {}
  },
  exception(exception) {
    try {
      ErrorManagement.exception(exception);
    } catch (error) {}
  }
};

// src/helpers/jsonLogic.ts
import { apply } from "json-logic-js";
var applyLogic = (rule, data) => apply(rule, data);

// src/helpers/prices.ts
import { dequal } from "dequal";
var pricePivotAttributes = ["Printing Process", "Printing", "PrintingProcess", "Delivery Type"];
var formatAttributes = attributes => attributes.map(_ref => {
  let [name, value] = _ref;
  return {
    name,
    value
  };
});
var getPricePivot = attributes => {
  const priceAttributes = pricePivotAttributes.map(pricePivotAttribute => attributes.find(attribute => attribute.name === pricePivotAttribute)).filter(Boolean);
  const sort = priceAttributes.map(attribute => {
    var _attribute$values;
    return {
      pivotAttribute: attribute.name,
      order: ((_attribute$values = attribute.values) === null || _attribute$values === void 0 ? void 0 : _attribute$values.map(_ref2 => {
        let {
          name
        } = _ref2;
        return name;
      })) || []
    };
  });
  return {
    priceAttributes,
    sort
  };
};
var getPriceGroups = groups => groups.map(group => ({
  attributes: formatAttributes(Object.entries(group.attributes)),
  quantity: Number(group.quantity)
}));
var getPriceAmount = (vatMode, price, discountedPrice) => {
  if (!discountedPrice) {
    return price[vatMode].centAmount;
  }
  if (price[vatMode].centAmount === discountedPrice[vatMode].centAmount) {
    return price[vatMode].centAmount;
  }
  return discountedPrice[vatMode].centAmount;
};
var getSelectedPriceAttributeValue = (priceAttributes, priceAttributeName) => {
  const lowerCasedKey = priceAttributeName.toLowerCase();
  const found = Object.entries(priceAttributes).find(_ref3 => {
    let [key2] = _ref3;
    return key2.toLowerCase().includes(lowerCasedKey);
  });
  const [key, value] = found || [];
  return key && value ? String(value) : void 0;
};
var getPriceByAttributes = (prices, attributes) => {
  const printingProcess = getSelectedPriceAttributeValue(attributes, "Printing");
  const printingProcessPrice = prices.find(process => {
    var _process$name;
    return ((_process$name = process.name) === null || _process$name === void 0 ? void 0 : _process$name.toLowerCase()) === (printingProcess === null || printingProcess === void 0 ? void 0 : printingProcess.toLowerCase());
  }) || prices[0];
  const quantityPrice = printingProcessPrice.quantities.find(quantityObject => {
    const quantity = typeof attributes.Quantity === "string" ? parseInt(attributes.Quantity, 10) : attributes.Quantity;
    return quantityObject.quantity === quantity;
  });
  if (quantityPrice) {
    const deliveryType = getSelectedPriceAttributeValue(attributes, "Delivery Type");
    const foundPrice = quantityPrice.deliveryTypes.find(delivery => delivery.name.toLowerCase() === (deliveryType === null || deliveryType === void 0 ? void 0 : deliveryType.toLowerCase()));
    if (foundPrice !== null && foundPrice !== void 0 && foundPrice.price) {
      return {
        price: foundPrice.price,
        discountedPrice: foundPrice.discountedPrice
      };
    }
  }
  return void 0;
};
var isSelectedPrice = (selectedPriceAttributes, priceAttributes) => dequal(Object.values(selectedPriceAttributes).map(value => String(value).toLowerCase()), Object.values(priceAttributes).map(value => String(value).toLowerCase()));
var hasDiscount = (vatMode, price, discountedPrice) => {
  if (discountedPrice) {
    return Boolean(price[vatMode].centAmount !== discountedPrice[vatMode].centAmount);
  }
  return false;
};
var getBadgeVariant = deliveryType => {
  switch (deliveryType) {
    case "Express":
      return "success-outline";
    case "Next Day":
      return "success";
    case "Normal":
    default:
      return "dim";
  }
};
var getTotalPrice = (price, servicePrice) => {
  if (price) {
    return _objectSpread(_objectSpread({}, price), {}, {
      totalNet: _objectSpread(_objectSpread({}, price.totalNet), {}, {
        centAmount: price.totalNet.centAmount + ((servicePrice === null || servicePrice === void 0 ? void 0 : servicePrice.totalNet.centAmount) || 0)
      }),
      totalGross: _objectSpread(_objectSpread({}, price.totalGross), {}, {
        centAmount: price.totalGross.centAmount + ((servicePrice === null || servicePrice === void 0 ? void 0 : servicePrice.totalGross.centAmount) || 0)
      })
    });
  }
  return price;
};
var getSelectedPriceAttributes = (attributes, selection) => {
  const {
    priceAttributes
  } = getPricePivot(attributes);
  return priceAttributes.reduce((acc, attribute) => {
    if (selection[attribute.name]) {
      acc[attribute.name] = selection[attribute.name];
    }
    return acc;
  }, {});
};
var getValue = (values, name) => values === null || values === void 0 ? void 0 : values.find(value => value.name === name);
var getPriceAttribute = (attributes, priceAttributeName) => {
  const productAttribue = attributes.find(_ref4 => {
    let {
      values
    } = _ref4;
    return getValue(values, priceAttributeName);
  });
  return _objectSpread({}, productAttribue && {
    [productAttribue.name]: priceAttributeName
  });
};
var generatePriceAttributesMap = (attributes, printingProcessName, deliveryTypes, quantity) => {
  const map = /* @__PURE__ */new Map();
  deliveryTypes.forEach(deliveryType => {
    const key = quantity ? "".concat(quantity, "-").concat(deliveryType.name) : deliveryType.name;
    const priceAttributes = _objectSpread(_objectSpread(_objectSpread({}, getPriceAttribute(attributes, printingProcessName)), getPriceAttribute(attributes, deliveryType.name)), quantity && {
      Quantity: quantity
    });
    map.set(key, priceAttributes);
  });
  return map;
};
var getPricePerQuantity = prices => prices.quantities.reduce((quantities, _ref5) => {
  let {
    quantity,
    deliveryTypes
  } = _ref5;
  const deliveryTypesPerQuantity = deliveryTypes.map(deliveryType => ({
    deliveryType,
    quantity
  }));
  if (deliveryTypesPerQuantity.length > 0) {
    return [...quantities, ...deliveryTypesPerQuantity];
  }
  return quantities;
}, []);
var getTotalQuantity = _ref6 => {
  let {
    quantity,
    quantityParam,
    urlSelection,
    defaultSelection
  } = _ref6;
  if (quantity) return quantity;
  if (Number(quantityParam)) return Number(quantityParam);
  if (Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.groupedQuantity)) return Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.groupedQuantity);
  if (Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.Quantity)) return Number(urlSelection === null || urlSelection === void 0 ? void 0 : urlSelection.Quantity);
  if (Number(defaultSelection === null || defaultSelection === void 0 ? void 0 : defaultSelection.groupedQuantity)) return Number(defaultSelection === null || defaultSelection === void 0 ? void 0 : defaultSelection.groupedQuantity);
  return 0;
};
var getDeliveryOption = (deliveryOptions, deliveryOptionId) => {
  const selectedDeliveryOption = deliveryOptions.find(deliveryOption => deliveryOption.id === deliveryOptionId);
  return selectedDeliveryOption;
};
var getExperimentPrices = (prices, isExpActive, expVariable) => {
  if (!isExpActive || !expVariable) {
    return {
      prices,
      expCustomQuantities: {}
    };
  }
  return prices.reduce((acc, price) => {
    if (price.name && Array.isArray(expVariable[price.name])) {
      const expQuantities = expVariable[price.name];
      const includedQuantities = price.quantities.filter(_ref7 => {
        let {
          quantity
        } = _ref7;
        return expQuantities.includes(quantity);
      });
      acc.prices.push(_objectSpread(_objectSpread({}, price), {}, {
        quantities: includedQuantities
      }));
      const excludedQuantities = price.quantities.map(_ref8 => {
        let {
          quantity
        } = _ref8;
        return quantity;
      }).filter(quantity => !expQuantities.includes(quantity));
      if (excludedQuantities.length) {
        acc.expCustomQuantities[price.name] = excludedQuantities;
      }
    } else {
      acc.prices.push(price);
    }
    return acc;
  }, {
    prices: [],
    expCustomQuantities: {}
  });
};
var findCheapestOption = function (attributeName, attributeValues) {
  let targetAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["Deco 1 Technology", "Printing Process"];
  if (!targetAttributes.includes(attributeName)) {
    return null;
  }
  const validOptionsWithCosts = attributeValues.filter(value => value.extraCosts !== void 0);
  if (validOptionsWithCosts.length < 2) {
    return null;
  }
  const cheapestOption = validOptionsWithCosts.reduce((cheapest, current) => current.extraCosts < cheapest.extraCosts ? current : cheapest);
  return cheapestOption.selectorAttributeValue.name;
};

// src/helpers/selection.ts
var getSelectedValue = (selection, attribute, productAttribute) => {
  var _attribute$values2, _productAttribute$val;
  if (attribute.type === "lor") {
    return {
      selectedValue: {
        name: selection[attribute.name]
      },
      selectedProductValue: void 0
    };
  }
  if (attribute.type === "group") {
    const attributes = attribute.attributes.filter(_ref9 => {
      let {
        template
      } = _ref9;
      return template !== "hidden";
    });
    return attributes.reduce((value, groupedAttribute) => {
      var _value$selectedValue, _groupedAttribute$ran3, _groupedAttribute$ran4;
      if (!selection[groupedAttribute.name]) {
        return value;
      }
      if ((_value$selectedValue = value.selectedValue) !== null && _value$selectedValue !== void 0 && _value$selectedValue.name) {
        var _groupedAttribute$ran, _groupedAttribute$ran2;
        return {
          selectedValue: {
            name: groupedAttribute.range && (_groupedAttribute$ran = groupedAttribute.range[0]) !== null && _groupedAttribute$ran !== void 0 && _groupedAttribute$ran.unitOfMeasure ? "".concat(value.selectedValue.name, " x ").concat(selection[groupedAttribute.name], " ").concat((_groupedAttribute$ran2 = groupedAttribute.range[0]) === null || _groupedAttribute$ran2 === void 0 ? void 0 : _groupedAttribute$ran2.unitOfMeasure) : "".concat(value.selectedValue.name, " x ").concat(selection[groupedAttribute.name])
          },
          selectedProductValue: void 0
        };
      }
      return {
        selectedValue: {
          name: groupedAttribute.range && (_groupedAttribute$ran3 = groupedAttribute.range[0]) !== null && _groupedAttribute$ran3 !== void 0 && _groupedAttribute$ran3.unitOfMeasure ? "".concat(selection[groupedAttribute.name], " ").concat((_groupedAttribute$ran4 = groupedAttribute.range[0]) === null || _groupedAttribute$ran4 === void 0 ? void 0 : _groupedAttribute$ran4.unitOfMeasure) : selection[groupedAttribute.name]
        },
        selectedProductValue: void 0
      };
    }, {});
  }
  const selected = selection[attribute.name];
  if (!selected) {
    return {
      selectedValue: void 0,
      selectedProductValue: void 0
    };
  }
  const selectedValue = (_attribute$values2 = attribute.values) === null || _attribute$values2 === void 0 ? void 0 : _attribute$values2.find(_ref10 => {
    let {
      name
    } = _ref10;
    return name === selected;
  });
  const selectedProductValue = productAttribute === null || productAttribute === void 0 || (_productAttribute$val = productAttribute.values) === null || _productAttribute$val === void 0 ? void 0 : _productAttribute$val.find(_ref11 => {
    let {
      pimAttributeValue
    } = _ref11;
    return pimAttributeValue === selected;
  });
  return {
    selectedValue,
    selectedProductValue
  };
};
var getDefaultSelection = attributes => attributes.reduce((defaultSelection, attribute) => {
  if (attribute.defaultValue) {
    return _objectSpread(_objectSpread({}, defaultSelection), {}, {
      [attribute.name]: attribute.defaultValue
    });
  }
  if (attribute.type === "group") {
    const groupedAttributeValues = attribute.attributes.reduce((groupedAttributes, groupAttribute) => {
      if (groupAttribute.defaultValue) {
        return _objectSpread(_objectSpread({}, groupedAttributes), {}, {
          [groupAttribute.name]: groupAttribute.defaultValue
        });
      }
      return groupedAttributes;
    }, {});
    return _objectSpread(_objectSpread({}, defaultSelection), groupedAttributeValues);
  }
  return defaultSelection;
}, {});
var filterAttributes = (attributes, remainingOptions, reviewPage, selectorSelection, selectionMode) => attributes.filter(_ref12 => {
  let {
    name,
    template,
    onReviewPage,
    invalidValuesVisibility,
    values,
    isConditionalAttribute,
    conditionalAttributeRules
  } = _ref12;
  const isPricePivot = pricePivotAttributes.includes(name);
  if (!remainingOptions.length) {
    return template !== "hidden";
  }
  try {
    const rule = conditionalAttributeRules ? JSON.parse(conditionalAttributeRules) : "";
    if (isConditionalAttribute && !applyLogic(rule, selectorSelection)) {
      return false;
    }
  } catch (error) {
    const message = "An unexpected error occurred while trying to parse the conditional attribute logic for ".concat(name);
    Sentry.exception({
      exception: error,
      tags: {
        fileLocation: "conditionalAttributes",
        featureFunction: "filterAttributes"
      },
      fingerprint: ["easy-selector"]
    });
    throw new Error(message);
  }
  const showOnReviewPage = reviewPage && onReviewPage || !reviewPage;
  return showOnReviewPage && remainingOptions.filter(_ref13 => {
    let {
      options
    } = _ref13;
    return options.length;
  }).some(remainingOption => {
    var _option$values$;
    const option = remainingOption.options.find(_ref14 => {
      let {
        key
      } = _ref14;
      return name === key;
    });
    const isRange = (option === null || option === void 0 || (_option$values$ = option.values[0]) === null || _option$values$ === void 0 ? void 0 : _option$values$.type) === "range";
    const foundValue = values === null || values === void 0 ? void 0 : values.find(value => {
      var _option$values$2;
      if ((option === null || option === void 0 || (_option$values$2 = option.values[0]) === null || _option$values$2 === void 0 ? void 0 : _option$values$2.type) === "stringLiteral") {
        return value.id === option.values[0].stringLiteral;
      }
      return true;
    });
    const isEnabled = (option === null || option === void 0 ? void 0 : option.values.length) === 1 && !isRange || (values === null || values === void 0 ? void 0 : values.length) === 1 ? (foundValue === null || foundValue === void 0 ? void 0 : foundValue.enabled) || (foundValue === null || foundValue === void 0 ? void 0 : foundValue.conditionalAttributeValueRules) : true;
    const notHidden = template !== "hidden";
    const oneOptionLeft = (option === null || option === void 0 ? void 0 : option.values.length) === 1 && !isPricePivot;
    if (selectionMode === "step-by-step") {
      return notHidden;
    }
    return notHidden && isEnabled && (oneOptionLeft && invalidValuesVisibility !== "hidden" || !oneOptionLeft);
  });
});
var hasGroupedQuantity = attributes => {
  const groupedQuantityAttribute = attributes.find(attribute => attribute.name === "groupedQuantity");
  return Boolean(groupedQuantityAttribute);
};
var formatPrefilledSelection = (attributes, payload) => {
  if (!payload || payload.length === 0) {
    const defaultValues = attributes.filter(attribute => attribute.defaultValue);
    if (defaultValues.length > 0) {
      return {
        selection: attributes.reduce((formattedSelection, attribute) => {
          if (attribute.defaultValue) {
            return _objectSpread(_objectSpread({}, formattedSelection), {}, {
              [attribute.name]: attribute.defaultValue
            });
          }
          return formattedSelection;
        }, {}),
        groupSelection: void 0
      };
    }
    return {
      selection: void 0,
      groupSelection: void 0
    };
  }
  const [attributeSelection] = Array.isArray(payload) ? payload : [payload];
  const selection = Object.keys(attributeSelection).reduce((formattedSelection, key) => _objectSpread(_objectSpread({}, formattedSelection), {}, {
    [key]: String(attributeSelection[key])
  }), {});
  if (Array.isArray(payload)) {
    const groupSelection = payload.map(item => {
      const attributesSelection = Object.keys(attributeSelection).reduce((formattedSelection, key) => {
        const attribute = attributes.find(contentAttribute => contentAttribute.name === key);
        if (!attribute) {
          return _objectSpread(_objectSpread({}, formattedSelection), {}, {
            [key]: item[key]
          });
        }
        return formattedSelection;
      }, {});
      return {
        attributes: attributesSelection,
        quantity: Number(item.Quantity)
      };
    });
    return {
      selection,
      groupSelection
    };
  }
  return {
    selection
  };
};
var getSelectionValue = (selection, value) => Object.values(selection).find(option => value === option);
var getSelectionAttributes = selection => Object.fromEntries(Object.entries(selection).filter(_ref15 => {
  let [name] = _ref15;
  return ![...pricePivotAttributes, "Quantity"].includes(name || "");
}));
var getEasyAndAdvancedFilteredAttributes = _ref16 => {
  let {
    excludeAttributes = [],
    filteredAttributes = [],
    hasEasyAndAdvancedOptions = false
  } = _ref16;
  if (!hasEasyAndAdvancedOptions) {
    return {
      filteredExcludedAttributes: filteredAttributes,
      filteredAdvancedAttributes: []
    };
  }
  const filteredExcludedAttributes = filteredAttributes.filter(attribute => excludeAttributes.includes(attribute.name));
  const filteredAdvancedAttributes = filteredAttributes.filter(attribute => !excludeAttributes.includes(attribute.name) && attribute.template !== "deliveryDate");
  return {
    filteredExcludedAttributes,
    filteredAdvancedAttributes
  };
};

// src/helpers/window.ts
var windowPresent = typeof window !== "undefined";
var getFromLocalStorage = key => {
  if (!windowPresent) {
    return void 0;
  }
  return window.localStorage.getItem(key);
};
var saveToLocalStorage = (key, value) => {
  if (!windowPresent) {
    return;
  }
  window.localStorage.setItem(key, value);
};
var getCurrentUrl = () => {
  if (!windowPresent) {
    return "";
  }
  if (window.top) {
    try {
      return window.top.location.href;
    } catch (error) {
      return window.location.href;
    }
  }
  return window.location.href;
};

// src/helpers/queryParams.ts
var generateSelectionParameters = _ref17 => {
  let {
    selectionParameter,
    comboSelectionParameter,
    quantityParameter,
    deliveryOptionIdParameter
  } = _ref17;
  const url = new URL(getCurrentUrl());
  if (selectionParameter) {
    url.searchParams.set("selection", decodeURIComponent(selectionParameter));
  }
  if (comboSelectionParameter) {
    url.searchParams.set("comboSelection", comboSelectionParameter);
  }
  if (quantityParameter) {
    url.searchParams.set("quantity", quantityParameter);
  }
  if (deliveryOptionIdParameter) {
    url.searchParams.set("deliveryOptionId", deliveryOptionIdParameter);
  }
  return url;
};
var setUrlParameters = _ref18 => {
  let {
    selectionParameter,
    comboSelectionParameter,
    quantityParameter,
    deliveryOptionIdParameter
  } = _ref18;
  if (selectionParameter || comboSelectionParameter || quantityParameter || deliveryOptionIdParameter) {
    const url = generateSelectionParameters({
      selectionParameter,
      comboSelectionParameter,
      quantityParameter,
      deliveryOptionIdParameter
    });
    if (window.top) {
      window.top.history.replaceState({
        state: url.href
      }, "", url.href);
    } else {
      window.history.replaceState({
        state: url.href
      }, "", url.href);
    }
  }
};
var deleteSearchParameter = searchParameter => {
  const url = new URL(getCurrentUrl());
  url.searchParams.delete(searchParameter);
  if (window.top) {
    window.top.history.replaceState({
      state: url.href
    }, "", url.href);
  } else {
    window.history.replaceState({
      state: url.href
    }, "", url.href);
  }
};
var getParamFromUrl = (url, param) => {
  if (!url) return void 0;
  const parsedUrl = new URL(url, window.location.origin);
  const value = parsedUrl.searchParams.get(param);
  if (!value) {
    return void 0;
  }
  return value;
};
var getSelectionFromUrl = (url, attributes) => {
  if (url === "") return void 0;
  const parsedUrl = new URL(url, window.location.origin);
  const selectionParam = parsedUrl.searchParams.get("selection");
  if (selectionParam && typeof selectionParam === "string") {
    try {
      const selection = Object.fromEntries(new URLSearchParams(selectionParam));
      const currentSelection = Object.entries(selection).reduce((correctSelectionObject, _ref19) => {
        let [key, value] = _ref19;
        const foundAttribute = attributes.find(attribute => attribute.pimAttributeName.toLowerCase() === key.toLowerCase());
        if (foundAttribute) {
          var _foundAttribute$value;
          const foundAttributeValue = (_foundAttribute$value = foundAttribute.values) === null || _foundAttribute$value === void 0 ? void 0 : _foundAttribute$value.find(attributeValue => attributeValue.pimAttributeValue.toLowerCase() === value.toLowerCase());
          if (foundAttributeValue) {
            return _objectSpread(_objectSpread({}, correctSelectionObject), {}, {
              [foundAttribute.pimAttributeName]: foundAttributeValue.pimAttributeValue
            });
          }
          return _objectSpread(_objectSpread({}, correctSelectionObject), {}, {
            [foundAttribute.pimAttributeName]: value
          });
        }
        if (key === "quantity") {
          return _objectSpread(_objectSpread({}, correctSelectionObject), {}, {
            Quantity: value
          });
        }
        return correctSelectionObject;
      }, {});
      if (Object.keys(currentSelection).length > 0) {
        return currentSelection;
      }
    } catch (error) {
      console.error("Error while parsing selection from url", error);
      return void 0;
    }
  }
  return void 0;
};
var getGroupFromUrl = url => {
  if (url === "") return [];
  const parsedUrl = new URL(url, window.location.origin);
  const comboSelectionParam = decodeURIComponent(parsedUrl.searchParams.get("comboSelection") || "");
  if (comboSelectionParam && typeof comboSelectionParam === "string") {
    const group = JSON.parse(comboSelectionParam);
    const currentGroup = group.map(entry => {
      const mappedGroup = Object.entries(entry).reduce((acc, _ref20) => {
        let [key, value] = _ref20;
        if (key === "quantity") {
          return _objectSpread(_objectSpread({}, acc), {}, {
            quantity: Number(value)
          });
        }
        return _objectSpread(_objectSpread({}, acc), {}, {
          attributes: _objectSpread(_objectSpread({}, acc.attributes), {}, {
            [key]: String(value)
          })
        });
      }, {});
      return mappedGroup;
    });
    return currentGroup;
  }
  return [];
};

// src/helpers/validation.ts
import { dequal as dequal2 } from "dequal";

// src/translations.ts
import { defineMessages } from "react-intl";
var translations = defineMessages({
  splitSizeAlert: {
    id: "selector.group.splitSizeAlertTitle",
    defaultMessage: "Your product is large, exceeding the width of {width}{widthUnit} and height of {height}{heightUnit}, and will be split up."
  },
  noQuantity: {
    id: "selector.grid.noquantity",
    defaultMessage: "Please fill in the quantity per size and hit the confirm button"
  },
  "number-of-sheets": {
    id: "selector.attribute.numberOfSheets",
    defaultMessage: "{value} Pages"
  },
  groupedquantity: {
    id: "selector.quantity.suffix",
    defaultMessage: "{value} pieces"
  },
  cm: {
    id: "unit.ofMeasure.cm",
    defaultMessage: "cm"
  },
  pcs: {
    id: "unit.ofMeasure.pcs",
    defaultMessage: "pcs"
  },
  mm: {
    id: "unit.ofMeasure.mm",
    defaultMessage: "mm"
  },
  "customQuantities.placeholder": {
    id: "pricetable.customQuantities.placeholder",
    defaultMessage: "Higher quantities"
  },
  printingType_none: {
    id: "pricetable.printingtype.title.none",
    defaultMessage: "None"
  },
  printingType_offset: {
    id: "pricetable.printingtype.title.offset",
    defaultMessage: "Offset"
  },
  printingType_digital: {
    id: "pricetable.printingtype.title.digital",
    defaultMessage: "Digital"
  },
  printingType_offsetordigital: {
    id: "pricetable.printingtype.title.offsetOrDigital",
    defaultMessage: "Offset or digital"
  },
  printingType_directtogarment: {
    id: "pricetable.printingtype.title.directToGarment",
    defaultMessage: "Direct to garment"
  },
  printingType_heattransfer: {
    id: "pricetable.printingtype.title.heatTransfer",
    defaultMessage: "Heat transfer"
  },
  printingType_laserengraving: {
    id: "pricetable.printingtype.title.laserEngraving",
    defaultMessage: "Laser engraving"
  },
  printingType_inkjet: {
    id: "pricetable.printingtype.title.inkJet",
    defaultMessage: "Ink jet"
  },
  printingType_inkjetuv: {
    id: "pricetable.printingtype.title.inkJetUV",
    defaultMessage: "Inkjet UV"
  },
  printingType_thermography: {
    id: "pricetable.printingtype.title.thermography",
    defaultMessage: "Thermography"
  },
  printingType_embroideryflat: {
    id: "pricetable.printingtype.title.embroideryFlat",
    defaultMessage: "Embroidery flat"
  },
  printingType_embroiderycylinder: {
    id: "pricetable.printingtype.title.embroideryCylinder",
    defaultMessage: "Embroidery cylinder"
  },
  printingType_sublimation: {
    id: "pricetable.printingtype.title.sublimation",
    defaultMessage: "Sublimation"
  },
  printingType_undefined: {
    id: "pricetable.printingtype.title.undefined",
    defaultMessage: "Undefined"
  },
  printingType_flexographic: {
    id: "pricetable.printingtype.title.flexoGraphic",
    defaultMessage: "Flexo Graphic"
  },
  printingType_flexography: {
    id: "pricetable.printingtype.title.flexoGraphic",
    defaultMessage: "Flexo Graphic"
  },
  printingType_screenprinting: {
    id: "pricetable.printingtype.title.screenPrinting",
    defaultMessage: "Screen Printing"
  },
  printingType_padprinting: {
    id: "pricetable.printingtype.title.padPrinting",
    defaultMessage: "Pad Printing"
  },
  printingType_engraving: {
    id: "pricetable.printingtype.title.engraving",
    defaultMessage: "Engraving"
  },
  printingType_fullcolorrotaryprint: {
    id: "pricetable.printingtype.title.fullcolorrotaryprint",
    defaultMessage: "Full Color Rotary Print"
  },
  printingType_embroidery: {
    id: "pricetable.printingtype.title.embroidery",
    defaultMessage: "Embroidery"
  },
  printingType_digitaltransfer: {
    id: "pricetable.printingtype.title.digitalTransfer",
    defaultMessage: "Digital Transfer"
  },
  printingType_screenprinttransfer: {
    id: "pricetable.printingtype.title.screenPrintTransfer",
    defaultMessage: "Screen Print Transfer"
  },
  printingType_unprinted: {
    id: "pricetable.printingtype.title.unprinted",
    defaultMessage: "Unprinted"
  },
  printingType_dyesublimation: {
    id: "pricetable.printingtype.title.dyeSublimation",
    defaultMessage: "Dye Sublimation"
  },
  description_none: {
    id: "pricetable.printingtype.description.none",
    defaultMessage: "None"
  },
  description_offset: {
    id: "pricetable.printingtype.description.offset",
    defaultMessage: "Offset"
  },
  description_digital: {
    id: "pricetable.printingtype.description.digital",
    defaultMessage: "Digital"
  },
  description_offsetordigital: {
    id: "pricetable.printingtype.description.offsetOrDigital",
    defaultMessage: "Offset or digital"
  },
  description_directtogarment: {
    id: "pricetable.printingtype.description.directToGarment",
    defaultMessage: "Direct to garment"
  },
  description_heattransfer: {
    id: "pricetable.printingtype.description.heatTransfer",
    defaultMessage: "Heat transfer"
  },
  description_laserengraving: {
    id: "pricetable.printingtype.description.laserEngraving",
    defaultMessage: "Laser engraving"
  },
  description_inkjet: {
    id: "pricetable.printingtype.description.inkJet",
    defaultMessage: "Ink jet"
  },
  description_inkjetuv: {
    id: "pricetable.printingtype.description.inkJetUV",
    defaultMessage: "Inkjet UV"
  },
  description_thermography: {
    id: "pricetable.printingtype.description.thermography",
    defaultMessage: "Thermography"
  },
  description_embroideryflat: {
    id: "pricetable.printingtype.description.embroideryFlat",
    defaultMessage: "Embroidery flat"
  },
  description_embroiderycylinder: {
    id: "pricetable.printingtype.description.embroideryCylinder",
    defaultMessage: "Embroidery cylinder"
  },
  description_sublimation: {
    id: "pricetable.printingtype.description.sublimation",
    defaultMessage: "Sublimation"
  },
  description_undefined: {
    id: "pricetable.printingtype.description.undefined",
    defaultMessage: "Undefined"
  },
  description_flexographic: {
    id: "pricetable.printingtype.description.flexoGraphic",
    defaultMessage: "Flexo Graphic"
  },
  description_screenprinting: {
    id: "pricetable.printingtype.description.screenPrinting",
    defaultMessage: "Screen Printing"
  },
  description_padprinting: {
    id: "pricetable.printingtype.description.padPrinting",
    defaultMessage: "Pad Printing"
  },
  description_engraving: {
    id: "pricetable.printingtype.description.engraving",
    defaultMessage: "Engraving"
  },
  description_fullcolorrotaryprint: {
    id: "pricetable.printingtype.description.fullcolorrotaryprint",
    defaultMessage: "Full Color Rotary Print"
  },
  description_embroidery: {
    id: "pricetable.printingtype.description.embroidery",
    defaultMessage: "Embroidery"
  },
  description_digitaltransfer: {
    id: "pricetable.printingtype.description.digitalTransfer",
    defaultMessage: "Digital Transfer"
  },
  description_screenprinttransfer: {
    id: "pricetable.printingtype.description.screenPrintTransfer",
    defaultMessage: "Screen Print Transfer"
  },
  description_unprinted: {
    id: "pricetable.printingtype.description.unprinted",
    defaultMessage: "Unprinted"
  },
  description_dyesublimation: {
    id: "pricetable.printingtype.description.dyeSublimation",
    defaultMessage: "Dye Sublimation"
  },
  description_flexography: {
    id: "pricetable.printingtype.description.flexography",
    defaultMessage: "Flexography"
  },
  headerFlag: {
    id: "pricetable.header.flag",
    defaultMessage: "Choose quantity and delivery"
  },
  showMoreQuantities: {
    id: "selector.quantity.showMore",
    defaultMessage: "Show more quantities"
  },
  showLessQuantities: {
    id: "selector.quantity.showLess",
    defaultMessage: "Show less quantities"
  },
  customQunatitySelectOptionText: {
    id: "pricetable.customQunatitySelectOption.text",
    defaultMessage: "Choose a quantity"
  },
  quantity: {
    id: "pricetable.header.quantity",
    defaultMessage: "Quantity"
  },
  totalGross: {
    id: "pricetable.pricemode.gross",
    defaultMessage: "Incl. VAT"
  },
  totalNet: {
    id: "pricetable.pricemode.net",
    defaultMessage: "Excl. VAT"
  },
  missingDeliveryType: {
    id: "selector.missing.deliverytype",
    defaultMessage: "Please choose sizes and genders so we can show the correct delivery date"
  },
  Normal: {
    id: "general.selector.pricetable.deliverymethod.normal",
    defaultMessage: "Normal"
  },
  "Next Day": {
    id: "general.selector.pricetable.deliverymethod.nextDay",
    defaultMessage: "Next Day"
  },
  Express: {
    id: "general.selector.pricetable.deliverymethod.express",
    defaultMessage: "Express"
  }
});

// src/helpers/validation.ts
var createNumberArrayFromRange = range => {
  const {
    minimum,
    maximum,
    increment
  } = range;
  const amountOfValues = Math.floor((maximum - minimum) / increment) + 1;
  const rangeValues = Array.from({
    length: amountOfValues
  }, (_, index) => minimum + index * increment);
  return rangeValues;
};
var hasResolvedValue = (remainingOptionsPerGroup, attributeKey, value) => {
  const enabled = remainingOptionsPerGroup.filter(group => group.state !== "unresolvable").some(group => {
    const attributeOption = group.options.find(_ref21 => {
      let {
        key
      } = _ref21;
      return key === attributeKey;
    });
    if (!attributeOption || attributeOption.type !== "string") {
      return false;
    }
    return attributeOption.values.some(option => option.stringLiteral === value);
  });
  return enabled;
};
var getResolvedAttribute = (remainingOptions, attributeName) => {
  const foundAttribute = remainingOptions.find(option => option.key === attributeName);
  return foundAttribute;
};
var getResolvedNumericAttribute = (remainingOptions, attributeName) => {
  const resolvedAttribute = getResolvedAttribute(remainingOptions, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "numeric") {
    return resolvedAttribute;
  }
  return void 0;
};
var getResolvedStringAttribute = (remainingOptions, attributeName) => {
  const resolvedAttribute = getResolvedAttribute(remainingOptions, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "string") {
    return resolvedAttribute;
  }
  return void 0;
};
var getResolvedAttributeFromGroup = (remainingOptionsPerGroup, attributeName) => {
  const resolvedOptions = remainingOptionsPerGroup.filter(groupResult => groupResult.state !== "unresolvable");
  const index = resolvedOptions.findIndex(_ref22 => {
    let {
      options
    } = _ref22;
    return options.some(remainingOptions => remainingOptions.key === attributeName);
  });
  if (index === -1) {
    return void 0;
  }
  return getResolvedAttribute(resolvedOptions[index].options, attributeName);
};
var getResolvedNumericAttributeFromGroup = (remainingOptionsPerGroup, attributeName) => {
  const resolvedAttribute = getResolvedAttributeFromGroup(remainingOptionsPerGroup, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "numeric") {
    return resolvedAttribute;
  }
  return void 0;
};
var getResolvedStringAttributeFromGroup = (remainingOptionsPerGroup, attributeName) => {
  const resolvedAttribute = getResolvedAttributeFromGroup(remainingOptionsPerGroup, attributeName);
  if (resolvedAttribute && resolvedAttribute.type === "string") {
    return resolvedAttribute;
  }
  return void 0;
};
var getRangeMaximum = function (remainingOptionsPerGroup, attributeName) {
  let maximum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  const resolvedAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeName);
  const firstResolvedValue = resolvedAttribute === null || resolvedAttribute === void 0 ? void 0 : resolvedAttribute.values[0];
  const attributeMaximum = (firstResolvedValue === null || firstResolvedValue === void 0 ? void 0 : firstResolvedValue.type) === "range" ? firstResolvedValue.range.maximum : maximum;
  return attributeMaximum > maximum ? maximum : attributeMaximum;
};
var getSplitSizePanelInfo = (remainingOptions, currentPanel) => {
  const substrateWidthOption = getResolvedNumericAttributeFromGroup(remainingOptions, "Substrate Width");
  const substrateHeightOption = getResolvedNumericAttributeFromGroup(remainingOptions, "Substrate Height");
  const isSinglePanelProduct = hasResolvedValue(remainingOptions, "Product has Multiple Panels", "No");
  if (!isSinglePanelProduct && substrateWidthOption && substrateHeightOption) {
    const widthValue = substrateWidthOption.values[0];
    const heightValue = substrateHeightOption.values[0];
    if (widthValue.type !== "numberLiteral" || heightValue.type !== "numberLiteral") {
      return currentPanel;
    }
    return {
      openPanel: true,
      showMessage: true,
      panelName: "group",
      message: translations.splitSizeAlert,
      variant: "info",
      values: {
        width: widthValue.numberLiteral,
        widthUnit: substrateWidthOption.unitOfMeasure,
        height: heightValue.numberLiteral,
        heightUnit: substrateHeightOption.unitOfMeasure
      }
    };
  }
  return _objectSpread(_objectSpread({}, currentPanel), {}, {
    openPanel: false,
    panelName: currentPanel.panelName,
    showMessage: false
  });
};
var isGridCellValid = (row, column, remainingOptionsPerGroup) => {
  const groupAttribute = {
    [row.name]: row.value,
    [column.name]: column.value
  };
  const foundRemainingOptions = remainingOptionsPerGroup.find(options => options.groupAttribute && dequal2(options.groupAttribute, groupAttribute));
  if (foundRemainingOptions) {
    if (foundRemainingOptions.state === "unresolvable") {
      return false;
    }
    const rowOptions = foundRemainingOptions.options.find(option => option.key === row.name);
    if (rowOptions !== void 0 && rowOptions.type === "string") {
      const rowValid = rowOptions.values.find(value => value.stringLiteral === row.value);
      if (rowValid) {
        const columnOptions = foundRemainingOptions.options.find(option => option.key === column.name);
        if (columnOptions !== void 0 && columnOptions.type === "string") {
          const columnValid = columnOptions.values.find(value => value.stringLiteral === column.value);
          return Boolean(columnValid !== void 0);
        }
        return false;
      }
      return false;
    }
    return false;
  }
  return true;
};
var getRemainingOptionsPerGroup = validationResults => validationResults.map(validation => ({
  options: validation.result.remainingOptions,
  groupAttribute: validation.groupAttribute,
  state: validation.result.state
}));
var updateAttributes = (attributes, remainingOptions) => {
  const mappedAttributes = attributes.map(attribute => {
    if (attribute.type === "group") {
      const updatedAttributes = attribute.attributes.map(groupAttribute => {
        const remainingAttribute = getResolvedNumericAttributeFromGroup(remainingOptions, groupAttribute.name);
        if (groupAttribute.type === "lor" && remainingAttribute) {
          var _groupAttribute$range;
          const hasRange = (_groupAttribute$range = groupAttribute.range) === null || _groupAttribute$range === void 0 ? void 0 : _groupAttribute$range.find(range => range.maximum && range.increment);
          const validationRanges = remainingAttribute.values.reduce((allRanges, value) => {
            if (value.type === "range") {
              return [...allRanges, _objectSpread(_objectSpread({}, value.range), {}, {
                unitOfMeasure: remainingAttribute.unitOfMeasure
              })];
            }
            return allRanges;
          }, []);
          if (hasRange) {
            return _objectSpread(_objectSpread({}, groupAttribute), {}, {
              range: validationRanges
            });
          }
        }
        return groupAttribute;
      });
      return _objectSpread(_objectSpread({}, attribute), {}, {
        attributes: updatedAttributes
      });
    }
    return attribute;
  });
  return mappedAttributes;
};

// src/helpers/product.ts
var getProductAttribute = (productAttributes, attributeName) => productAttributes.find(_ref23 => {
  let {
    pimAttributeName
  } = _ref23;
  return pimAttributeName === attributeName;
});
var getAttribute = (attributes, attributeName) => attributes.find(attribute => attribute.name === attributeName);
var getAttributeValue = (attributeValueName, attributeValues) => attributeValues === null || attributeValues === void 0 ? void 0 : attributeValues.find(value => value.pimAttributeValue === attributeValueName);
var getLockedAttributes = (selection, attributes, violatedAttributes) => violatedAttributes.map(attributeName => {
  const attribute = getAttribute(attributes, attributeName);
  return (attribute === null || attribute === void 0 ? void 0 : attribute.template) === "hidden" ? selection[attributeName] : void 0;
}).filter(Boolean);
var getRequiredAttributes = (attributes, arePriceAttributeRequired, selectorSelection) => {
  if (arePriceAttributeRequired) {
    return attributes;
  }
  return attributes.reduce((requiredAttributes, attribute) => {
    const rule = attribute.conditionalAttributeRules ? JSON.parse(attribute.conditionalAttributeRules) : "";
    if (attribute.type === "group") {
      const hasAppliedRule = attribute.isConditionalAttribute && applyLogic(rule, selectorSelection);
      const shouldIncludeGroupAttributes = hasAppliedRule || !attribute.isConditionalAttribute;
      if (shouldIncludeGroupAttributes) {
        return [...requiredAttributes, ...attribute.attributes];
      }
      return requiredAttributes;
    }
    if (!pricePivotAttributes.includes(attribute.name)) {
      return [...requiredAttributes, attribute];
    }
    return requiredAttributes;
  }, []);
};
var areRequiredAttributesSelected = _ref24 => {
  let {
    attributes,
    selection,
    arePriceAttributeRequired = false,
    group,
    includingGroup = false
  } = _ref24;
  const hasGroup = includingGroup && hasGroupedQuantity(attributes) && (group === null || group === void 0 ? void 0 : group.length);
  const requiredAttributes = getRequiredAttributes(attributes, arePriceAttributeRequired, selection);
  const requiredAttributeNames = requiredAttributes.map(attribute => attribute.name);
  if (hasGroup) {
    const requiredGroupedAttributes = attributes.reduce((requiredAttributesNames, attribute) => {
      if (attribute.grid) {
        return [...requiredAttributesNames, attribute.grid.column.name, attribute.grid.row.name];
      }
      return requiredAttributesNames;
    }, []);
    return [...requiredAttributeNames, ...requiredGroupedAttributes].every(attributeName => Boolean(selection[attributeName]) || Boolean(group.some(groupSelection => Object.keys(groupSelection.attributes).includes(attributeName))));
  }
  return requiredAttributeNames.every(attributeName => Boolean(selection[attributeName]));
};
var getTotalQuantity2 = groups => groups.reduce((partialSum, group) => partialSum + Number(group.quantity), 0);

// src/components/selector/Attribute.tsx
import { useState as useState10, memo, useMemo as useMemo4, useRef as useRef3, useEffect as useEffect9 } from "react";
import { FormattedMessage as FormattedMessage14, useIntl as useIntl10 } from "react-intl";
import { Alert as Alert3, Collapsible as Collapsible2, LinkAsButton as LinkAsButton5 } from "@printdeal/ui-library";
import { useFeatureConfig } from "@printdeal/feature-management/react";
import { klona } from "klona";
import { configurationProvider as configurationProvider10 } from "@printdeal/configuration";

// src/hooks/useCollapseLogic.ts
import { useEffect, useState } from "react";
import { useExperiment } from "@printdeal/feature-management/react";

// src/hooks/useMachine.ts
import { useContext } from "react";

// src/contexts/SelectorContext.tsx
import React, { createContext } from "react";
import { createActorContext } from "@xstate/react";

// src/statemachines/selector/selector.machine.ts
import { assertEvent, assign, setup } from "xstate";

// src/helpers/arrivalDates.ts
var hasInsufficientInventory = arrivalDates => arrivalDates.some(date => date.date === "INVENTORY_INSUFFICIENT");
var getArrivalDate = (dates, deliveryType, printingProcess) => {
  var _dates$find;
  return dates === null || dates === void 0 || (_dates$find = dates.find(date => {
    if (!printingProcess) return date.deliveryType === deliveryType;
    return date.deliveryType === deliveryType && date.printingProcess === printingProcess;
  })) === null || _dates$find === void 0 ? void 0 : _dates$find.date;
};

// src/statemachines/guards/selectorGuards.ts
var isConfigurationInvalid = _ref25 => {
  let {
    context
  } = _ref25;
  const {
    attributes
  } = context;
  const totalUniqueAttributes = new Set(attributes.map(attribute => attribute.id)).size;
  return totalUniqueAttributes < attributes.length;
};
var isUnresolvable = (_, params) => params.groupValidationResult.every(validation => validation.result.state === "unresolvable");
var canPreselectAttribute = (_ref26, params) => {
  let {
    context
  } = _ref26;
  const {
    selection,
    attributes,
    totalQuantity,
    selectionMode
  } = context;
  if (selectionMode === "step-by-step") {
    const remainingOptions = getRemainingOptionsPerGroup(params.groupValidationResult);
    return getRequiredAttributes(attributes, false, selection).some(attribute => {
      var _attributeValue$value, _attribute$values3;
      const attributeValue = getResolvedAttributeFromGroup(remainingOptions, attribute.name);
      const isAttributeRange = (attributeValue === null || attributeValue === void 0 || (_attributeValue$value = attributeValue.values[0]) === null || _attributeValue$value === void 0 ? void 0 : _attributeValue$value.type) === "range";
      return !selection[attribute.name] && ((attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.values.length) === 1 || ((_attribute$values3 = attribute.values) === null || _attribute$values3 === void 0 ? void 0 : _attribute$values3.length) === 1) && !isAttributeRange;
    });
  }
  const fullySelected = areRequiredAttributesSelected({
    attributes,
    selection,
    arePriceAttributeRequired: true
  });
  const defaultSelectionHasGroupedQuantity = !getDefaultSelection(attributes).groupedQuantity;
  return !fullySelected || !defaultSelectionHasGroupedQuantity && !totalQuantity;
};
var canUnset = (_ref27, params) => {
  let {
    context
  } = _ref27;
  return params.groupValidationResult.some(validation => validation.result.violatedAttributes.some(attributeName => {
    const attribute = getAttribute(context.attributes, attributeName);
    return attributeName && (attribute === null || attribute === void 0 ? void 0 : attribute.template) !== "hidden";
  }));
};
var cannotUnset = (_ref28, params) => {
  let {
    context
  } = _ref28;
  return params.groupValidationResult.some(validation => validation.result.violatedAttributes.some(attributeName => {
    const attribute = getAttribute(context.attributes, attributeName);
    return attributeName && (attribute === null || attribute === void 0 ? void 0 : attribute.template) === "hidden";
  }));
};
var areAllRequiredAttributesSelected = _ref29 => {
  let {
    context
  } = _ref29;
  const {
    attributes,
    selection,
    group
  } = context;
  return areRequiredAttributesSelected({
    attributes,
    selection,
    group,
    includingGroup: true
  });
};
var shouldFetchServicePrices = _ref30 => {
  let {
    context
  } = _ref30;
  return context.serviceKeys.length > 0 && context.servicePrices === void 0 && context.serviceError !== "ServicePricingError";
};
var isSelectionInvalid = _ref31 => {
  var _event$attributeSelec;
  let {
    context,
    event
  } = _ref31;
  return Boolean(!event.valid && ((_event$attributeSelec = event.attributeSelection) === null || _event$attributeSelec === void 0 ? void 0 : _event$attributeSelec.name) && context.selectionMode === "step-by-step" && !pricePivotAttributes.includes(event.attributeSelection.name));
};
var insufficientInventory = (_ref32, params) => {
  let {
    context
  } = _ref32;
  return hasResolvedValue(context.remainingOptionsPerGroup, "InventoryCheck", "Yes") && hasInsufficientInventory(params.arrivalDates);
};
var hasInsufficientInventoryWithoutGroup = (_ref33, params) => {
  let {
    context
  } = _ref33;
  return hasResolvedValue(context.remainingOptionsPerGroup, "InventoryCheck", "Yes") && hasInsufficientInventory(params.arrivalDates) && hasGroupedQuantity(context.attributes) && !context.group.length;
};
var isStepByStep = _ref34 => {
  let {
    context
  } = _ref34;
  return context.selectionMode === "step-by-step";
};

// src/statemachines/actions/selectorActions.ts
import { configurationProvider as configurationProvider2 } from "@printdeal/configuration";

// src/helpers/dataLayer.ts
import { addDataLayerEntry } from "@printdeal/data-layer-manager";
var dispatchDataLayerEntry = (eventName, actionName, changes) => {
  const GA4Event = ["click", "display"].includes(actionName) ? "".concat(eventName, "_").concat(actionName) : actionName;
  addDataLayerEntry(GA4Event, _objectSpread({}, changes));
};

// src/http-clients/productClient.ts
import axios from "axios";
import { authenticateHttpRequestInterceptor } from "@printdeal/authentication";
import { configurationProvider } from "@printdeal/configuration";

// src/helpers/merchantRules.ts
var findMatchedOutcomesOfType = (matchedOutcomes, typeToFind) => matchedOutcomes === null || matchedOutcomes === void 0 ? void 0 : matchedOutcomes.find(outcome => outcome.type.toLowerCase() === typeToFind.toLowerCase());
var getValueFromMatchedOutcome = function (matchedOutcome) {
  let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return matchedOutcome !== null && matchedOutcome !== void 0 && matchedOutcome.params.value ? matchedOutcome.params.value : defaultValue;
};
var formatAttributes2 = attributes => Object.entries(attributes).map(_ref35 => {
  let [key, value] = _ref35;
  return {
    key,
    value
  };
});
var getKeyValueObjectOfMatchedOutcomes = function (matchedOutcomes) {
  let typesToFind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return typesToFind.map(type => findMatchedOutcomesOfType(matchedOutcomes, type)).filter(outcome => outcome).reduce((object, outcome) => {
    const value = getValueFromMatchedOutcome(outcome);
    return outcome ? _objectSpread(_objectSpread({}, object), {}, {
      [outcome.type.toLowerCase()]: typeof value === "boolean" ? value : value.toLowerCase()
    }) : object;
  }, {});
};

// src/http-clients/productClient.ts
var getAttributes = function (selection) {
  let ignoreAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : pricePivotAttributes;
  return Object.entries(selection).reduce((priceAttributes, _ref36) => {
    let [name, value] = _ref36;
    const ignore = ignoreAttributes.includes(name || "");
    if (ignore) {
      return priceAttributes;
    }
    return [...priceAttributes, {
      name,
      value
    }];
  }, []);
};
var getRemainingValue = (key, remainingOption) => {
  if ((remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.type) !== "string") {
    return false;
  }
  return remainingOption.values.find(_ref37 => {
    let {
      stringLiteral
    } = _ref37;
    return stringLiteral === key;
  });
};
var getEnabledOptions = (attributes, attributeName) => {
  const attribute = attributes.find(attr => attr.name === attributeName);
  if (attribute && attribute.values) {
    const enabledValues = attribute.values.filter(value => value.enabled || value.conditionalAttributeValueRules);
    return enabledValues.length ? enabledValues : attribute.values;
  }
  return [];
};
var getResolvedAttributeOptions = (attributes, remainingOptions, attributeName) => {
  const resolvedPrintingColors = getResolvedAttributeFromGroup(remainingOptions, attributeName);
  const attributeRemainingOptions = resolvedPrintingColors === null || resolvedPrintingColors === void 0 ? void 0 : resolvedPrintingColors.values.map(value => value.type === "stringLiteral" && value.stringLiteral).filter(Boolean);
  const enabledOptions = getEnabledOptions(attributes, attributeName);
  return enabledOptions.filter(option => attributeRemainingOptions === null || attributeRemainingOptions === void 0 ? void 0 : attributeRemainingOptions.includes(option.id));
};
var ProductClient = class {
  constructor() {
    __publicField(this, "httpClient");
    __publicField(this, "getPrices", async _ref38 => {
      let {
        productKey,
        variableAttributes,
        address,
        quantity,
        mcpSku,
        customerGroupId,
        sort,
        group = [],
        customHeaders
      } = _ref38;
      const params = new URLSearchParams();
      params.append("storeKey", configurationProvider.getValue("STORE_KEY"));
      params.append("address", JSON.stringify(address));
      params.append("productKey", productKey);
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      params.append("quantityList", JSON.stringify(quantity));
      params.append("mcpSku", mcpSku);
      params.append("sort", JSON.stringify(sort));
      params.append("group", JSON.stringify(group));
      params.append("shouldCombineServicePrice", "true");
      if (customerGroupId) {
        params.append("customerGroupId", customerGroupId);
      }
      const path = sort.find(_ref39 => {
        let {
          pivotAttribute
        } = _ref39;
        return ["Printing Process", "Printing", "PrintingProcess"].includes(pivotAttribute);
      }) ? "getPrices" : "prices";
      const {
        data
      } = await this.client.get("/".concat(path, "?").concat(params), {
        headers: _objectSpread({
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        }, customHeaders)
      });
      return data || [];
    });
    __publicField(this, "getServicesPrice", async _ref40 => {
      let {
        serviceKeys,
        productKey,
        variableAttributes,
        customerGroupId,
        currencyCode = "EUR",
        country,
        postalCode
      } = _ref40;
      const filteredVariableAttributes = variableAttributes.filter(attribute => attribute.value);
      const params = new URLSearchParams();
      params.append("storeKey", configurationProvider.getValue("STORE_KEY"));
      params.append("serviceKeys", JSON.stringify(serviceKeys));
      params.append("productKey", productKey);
      params.append("variableAttributes", JSON.stringify(filteredVariableAttributes));
      params.append("currencyCode", currencyCode);
      params.append("country", country);
      params.append("postalCode", postalCode);
      if (customerGroupId) {
        params.append("customerGroupId", customerGroupId);
      }
      const {
        data
      } = await this.client.get("/getServicesPrice", {
        params
      });
      return data;
    });
    __publicField(this, "getAllPrices", async _ref41 => {
      var _attributes$find, _printingProcess$valu;
      let {
        productKey,
        variableAttributes,
        address,
        quantity,
        mcpSku,
        customerGroupId,
        attributes,
        remainingOptions,
        group = [],
        customHeaders = {}
      } = _ref41;
      const conflictingAttribute = (_attributes$find = attributes.find(attribute => !attribute.defaultValue)) === null || _attributes$find === void 0 ? void 0 : _attributes$find.name;
      const {
        sort,
        priceAttributes
      } = getPricePivot(attributes);
      const [printingProcess] = priceAttributes;
      const isUnprinted = variableAttributes["Print Area"] === "No Print";
      const enabledOptions = !isUnprinted && conflictingAttribute === printingProcess.name ? getResolvedAttributeOptions(attributes, remainingOptions, "Printing Colors") : getEnabledOptions(attributes, printingProcess.name);
      const pricingAttribute = !isUnprinted && conflictingAttribute === printingProcess.name ? "Printing Colors" : printingProcess.name;
      const remainingOption = getResolvedAttributeFromGroup(remainingOptions, printingProcess.name);
      const disabledOptions = (_printingProcess$valu = printingProcess.values) === null || _printingProcess$valu === void 0 ? void 0 : _printingProcess$valu.filter(value => !value.conditionalAttributeValueRules && !value.enabled);
      const hasOneRemainingOption = (remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.values.length) === 1;
      const remainingOptionIsDisabled = disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.some(option => {
        if ((remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.type) === "string") {
          var _remainingOption$valu;
          return option.id === ((_remainingOption$valu = remainingOption.values[0]) === null || _remainingOption$valu === void 0 ? void 0 : _remainingOption$valu.stringLiteral);
        }
        return false;
      });
      if (hasOneRemainingOption && remainingOptionIsDisabled) {
        return Promise.all([this.getPrices({
          productKey,
          variableAttributes: getAttributes(variableAttributes),
          address,
          quantity,
          group,
          customerGroupId,
          sort,
          mcpSku
        })]);
      }
      const hasOneOptionEnabled = enabledOptions.length === 1;
      const promises = enabledOptions.map(async attributeValue => {
        if (hasOneRemainingOption && hasOneOptionEnabled) {
          const pricesResponse2 = await this.getPrices({
            productKey,
            variableAttributes: getAttributes(variableAttributes),
            address,
            quantity,
            group,
            customerGroupId,
            sort,
            mcpSku,
            customHeaders: {
              "x-filename": "productClient.ts (@printdeal/product-selector)",
              "x-href": getCurrentUrl()
            }
          });
          return pricesResponse2.map(prices => _objectSpread(_objectSpread({}, prices), {}, {
            name: attributeValue.id
          }));
        }
        const selection = _objectSpread({}, variableAttributes);
        if (conflictingAttribute) {
          const remainingConflictOption = getResolvedAttributeFromGroup(remainingOptions, conflictingAttribute);
          try {
            delete selection[conflictingAttribute];
            const params = new URLSearchParams();
            params.append("variableAttributes", JSON.stringify(_objectSpread(_objectSpread({}, selection), {}, {
              [pricingAttribute]: attributeValue.id
            })));
            const {
              attributes: convertedAttributes
            } = await this.convertProduct(productKey, _objectSpread(_objectSpread({}, selection), {}, {
              [pricingAttribute]: attributeValue.id
            }), customHeaders);
            selection[pricingAttribute] = attributeValue.id;
            selection[conflictingAttribute] = getRemainingValue(variableAttributes[conflictingAttribute], remainingConflictOption) && getRemainingValue(convertedAttributes[conflictingAttribute], remainingConflictOption) ? variableAttributes[conflictingAttribute] : convertedAttributes[conflictingAttribute];
          } catch (error) {
            selection[conflictingAttribute] = variableAttributes[conflictingAttribute];
          }
        }
        const pricesResponse = await this.getPrices({
          productKey,
          variableAttributes: getAttributes(selection),
          address,
          quantity,
          group,
          customerGroupId,
          sort,
          mcpSku,
          customHeaders: {
            "x-filename": "productClient.ts (@printdeal/product-selector)",
            "x-href": getCurrentUrl()
          }
        });
        return pricesResponse.map(prices => _objectSpread(_objectSpread({}, prices), {}, {
          name: attributeValue.id
        }));
      });
      return Promise.all(promises);
    });
    __publicField(this, "getExpectedDeliveryDate", async _ref42 => {
      let {
        productKey,
        variableAttributes,
        shippingAddress,
        quantity,
        group = [],
        cutoffTime,
        hasServicePrice
      } = _ref42;
      const now = /* @__PURE__ */new Date();
      const formatter = new Intl.DateTimeFormat("nl-NL", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
      const currentTime = formatter.format(now);
      const params = new URLSearchParams();
      params.append("storeKey", configurationProvider.getValue("STORE_KEY"));
      params.append("address", JSON.stringify(shippingAddress));
      params.append("productKey", productKey);
      params.append("quantity", String(quantity));
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      if (cutoffTime) {
        params.append("cutoffTimeExpired", "".concat(currentTime > cutoffTime));
      }
      if (group.length > 0) {
        params.append("group", JSON.stringify(group));
      }
      if (hasServicePrice) {
        params.append("hasServicePrice", String(hasServicePrice));
      }
      const {
        data: date
      } = await this.client.get("/expectedDeliveryDate?".concat(params));
      return date;
    });
    /**
    * Get the arrival dates based on the selection and given attribute
    */
    __publicField(this, "getArrivalDates", async _ref43 => {
      let {
        quantity,
        productKey,
        selection,
        shippingAddress,
        groupSelection,
        configurationAttribute,
        remainingOptionsPerGroup,
        cutoffTime
      } = _ref43;
      const resolvedAttribute = getResolvedAttributeFromGroup(remainingOptionsPerGroup, configurationAttribute.name);
      const serviceKey = getResolvedAttributeFromGroup(remainingOptionsPerGroup, "Service Key");
      if ((resolvedAttribute === null || resolvedAttribute === void 0 ? void 0 : resolvedAttribute.type) !== "string") {
        return [];
      }
      const dateRequests = resolvedAttribute.values.map(async attributeValue => {
        try {
          const variableAttributes = Object.entries(selection).map(_ref44 => {
            let [name, value] = _ref44;
            if (name === configurationAttribute.name) {
              return {
                name,
                value: attributeValue.stringLiteral
              };
            }
            return {
              name,
              value
            };
          });
          const date = await this.getExpectedDeliveryDate({
            productKey,
            variableAttributes,
            shippingAddress,
            quantity,
            group: getPriceGroups(groupSelection),
            cutoffTime,
            hasServicePrice: Boolean((serviceKey === null || serviceKey === void 0 ? void 0 : serviceKey.values[0].type) === "stringLiteral" && serviceKey.values[0].stringLiteral)
          });
          return {
            deliveryType: attributeValue.stringLiteral,
            date
          };
        } catch (error) {
          return {
            deliveryType: attributeValue.stringLiteral,
            date: void 0
          };
        }
      });
      const dates = await Promise.all(dateRequests);
      return dates;
    });
    __publicField(this, "getInventory", async _ref45 => {
      let {
        productKey,
        selection,
        shippingAddress,
        quantity,
        group = []
      } = _ref45;
      const variableAttributes = Object.entries(selection).map(_ref46 => {
        let [name, value] = _ref46;
        return {
          name,
          value
        };
      });
      const params = new URLSearchParams();
      params.append("address", JSON.stringify(shippingAddress));
      params.append("productKey", productKey);
      params.append("quantity", String(quantity));
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      if (group.length > 0) {
        params.append("group", JSON.stringify(group));
      }
      const {
        data
      } = await this.client.get("/inventory?".concat(params));
      return data;
    });
    /**
    * Get a list of the first available delivery dates for a product-selection per printing process and delivery type
    */
    __publicField(this, "getExpectedDeliveryDates", async _ref47 => {
      let {
        prices,
        productKey,
        singleAttributes,
        shippingAddress,
        group,
        remainingOptionsPerGroup
      } = _ref47;
      const firstQuantities = prices.map(_ref48 => {
        let {
          quantities,
          name
        } = _ref48;
        const [firstQuantity] = quantities;
        return firstQuantity.deliveryTypes.map(deliveryType => ({
          deliveryType: deliveryType.name,
          printingProcess: name,
          quantity: firstQuantity.quantity
        }));
      }).flat();
      const serviceKey = getResolvedAttributeFromGroup(remainingOptionsPerGroup, "Service Key");
      const promises = firstQuantities.map(async priceAttributes => {
        const {
          printingProcess,
          deliveryType,
          quantity
        } = priceAttributes;
        const extraAttributes = printingProcess ? [{
          name: "Printing Process",
          value: printingProcess
        }, {
          name: "Delivery Type",
          value: deliveryType
        }] : [{
          name: "Delivery Type",
          value: deliveryType
        }];
        const variableAttributes = singleAttributes.concat(extraAttributes);
        const {
          cutofftime
        } = await this.getMerchantRules(productKey, variableAttributes.map(_ref49 => {
          let {
            name,
            value
          } = _ref49;
          return {
            key: name,
            value
          };
        }));
        const date = await this.getExpectedDeliveryDate({
          productKey,
          variableAttributes,
          shippingAddress,
          quantity,
          group,
          cutoffTime: cutofftime,
          hasServicePrice: Boolean((serviceKey === null || serviceKey === void 0 ? void 0 : serviceKey.values[0].type) === "stringLiteral" && serviceKey.values[0].stringLiteral)
        });
        return _objectSpread(_objectSpread({}, priceAttributes), {}, {
          date
        });
      });
      const dates = await Promise.all(promises);
      return dates;
    });
    __publicField(this, "convertProduct", async (productKey, variableAttributes, customHeaders) => {
      const params = new URLSearchParams();
      params.append("variableAttributes", JSON.stringify(variableAttributes));
      const {
        data: mcpProduct
      } = await this.client.get("/product/convert/".concat(productKey), {
        params,
        headers: customHeaders || {}
      });
      return Promise.resolve(mcpProduct);
    });
    __publicField(this, "fetchPricing", async _ref50 => {
      let {
        productKey,
        selection,
        quantityList,
        version,
        country,
        postalCode
      } = _ref50;
      const params = new URLSearchParams({
        productKey,
        selection: JSON.stringify(selection),
        quantityList: JSON.stringify(quantityList),
        version: String(version),
        country,
        postalCode
      });
      const {
        data
      } = await this.client.get("/pricing", {
        headers: {
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        },
        params
      });
      return Promise.resolve(data);
    });
    __publicField(this, "fetchPivotPrices", async _ref51 => {
      let {
        productKey,
        selection,
        quantity,
        version,
        country,
        postalCode,
        attributes,
        deliveryOptionId
      } = _ref51;
      const pivotSelections = attributes.reduce((acc, attribute) => {
        var _attribute$values4;
        const attributeName = attribute.name;
        const selectedValue = selection[attributeName];
        const filteredValues = (_attribute$values4 = attribute.values) === null || _attribute$values4 === void 0 ? void 0 : _attribute$values4.map(value => value.name).filter(value => value !== selectedValue).join(",");
        if (filteredValues) {
          acc[attributeName] = filteredValues;
        }
        return acc;
      }, {});
      const params = new URLSearchParams({
        productKey,
        selection: JSON.stringify(selection),
        pivotSelections: JSON.stringify(pivotSelections),
        quantity: String(quantity),
        version: String(version),
        country,
        postalCode,
        deliveryOptionId
      });
      const {
        data
      } = await this.client.get("/pivotPrices", {
        headers: {
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        },
        params
      });
      return Promise.resolve(data);
    });
    __publicField(this, "fetchDeliveryDates", async _ref52 => {
      let {
        selection,
        quantity,
        country,
        version,
        productKey,
        postalCode,
        groupSelection = []
      } = _ref52;
      const params = new URLSearchParams({
        selection: JSON.stringify(selection),
        quantity: quantity.toString(),
        country,
        version: version.toString(),
        productKey,
        postalCode,
        groupSelection: JSON.stringify(getPriceGroups(groupSelection))
      });
      const {
        data
      } = await this.client.get("/eCommerceDeliveryOptions", {
        headers: {
          "x-filename": "productClient.ts (@printdeal/product-selector)",
          "x-href": getCurrentUrl()
        },
        params
      });
      return Promise.resolve(data);
    });
  }
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider.getValue("PRODUCT_API_BASE_URL");
      this.httpClient = axios.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor);
    }
    return this.httpClient;
  }
  /**
  * Evaluate merchant rules with the givin facts
  * @param {string} productSku - Sku of the product to match the rules against
  * @param {array<object>} facts - Example,
  * if areAttributeLabels = false: [{ "key": "Printing_Colors___LOV", "value": "4/4 Full Color"}]
  * if areAttributeLabels = true: UserSelection
  * @param {bool} areAttributeLabels - To switch between facts format
  * @returns {Promise<*>}
  */
  async evaluateMerchantRules(productSku, facts) {
    let areAttributeLabels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    try {
      const params = new URLSearchParams();
      params.append("facts", JSON.stringify(facts));
      params.append("areAttributeLabels", String(areAttributeLabels));
      const {
        data: {
          matchedOutcomes
        }
      } = await this.client.get("/product/evaluateMerchantRules/".concat(productSku, "?").concat(params));
      return Promise.resolve(matchedOutcomes);
    } catch (e) {
      return Promise.resolve(null);
    }
  }
  /**
  * Get delivery tool settings
  * @param {string} productSku - Sku of the product to match the rules against
  * @param {array<object>} facts - Example,
  * if areAttributeLabels = false: [{ "key": "Printing_Colors___LOV", "value": "4/4 Full Color"}]
  * @param {boolean} areAttributeLabels
  */
  async getMerchantRules(productSku, facts) {
    let areAttributeLabels = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const defaults = {
      checkmate: "off",
      editor: "off",
      altuploadbeforeorder: "off"
    };
    try {
      const ruleOutcomes = await this.evaluateMerchantRules(productSku, facts, areAttributeLabels);
      return _objectSpread({
        deliveryTool: _objectSpread(_objectSpread({}, defaults), getKeyValueObjectOfMatchedOutcomes(ruleOutcomes, ["editor", "editorMode", "checkmate", "checkmateMode", "templateURL", "multipleDesigns", "ncolorcount", "assetTenant", "altUploadBeforeOrder", "EditorOverrides", "serviceKeys", "directupload"]))
      }, getKeyValueObjectOfMatchedOutcomes(ruleOutcomes, ["cutOffTime"]));
    } catch (e) {
      return {
        deliveryTool: defaults
      };
    }
  }
};
var productClient = new ProductClient();

// src/statemachines/actions/selectorActions.ts
var MAX_CUSTOM_QUANTITIES = 15;
var sendPreselectedAttributeToGA = payload => {
  const {
    template,
    name,
    value
  } = payload;
  dispatchDataLayerEntry("selector", "click", {
    "element-type": template,
    "element-content": "attribute_value",
    "attribute-name": name,
    "attribute-value": value,
    "attribute-preselected": true
  });
};
var preselectAttribute = _ref53 => {
  let {
    context,
    event
  } = _ref53;
  const selection = _objectSpread({}, context.selection);
  const selectionAttributes = Object.keys(selection);
  const remainingOptions = getRemainingOptionsPerGroup(event.output);
  const quantity = getResolvedNumericAttributeFromGroup(remainingOptions, "Quantity");
  if (context.selectionMode === "step-by-step") {
    const requiredAttributes = getRequiredAttributes(context.attributes, false, selection);
    const preSelectedAttributes = requiredAttributes.reduce((preSelectedSelection, attribute) => {
      var _attribute$values5;
      const attributeValue = getResolvedStringAttributeFromGroup(remainingOptions, attribute.name);
      const value = attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.values[0];
      if (((attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.values.length) === 1 || ((_attribute$values5 = attribute.values) === null || _attribute$values5 === void 0 ? void 0 : _attribute$values5.length) === 1) && (value === null || value === void 0 ? void 0 : value.type) === "stringLiteral") {
        var _attribute$values6;
        sendPreselectedAttributeToGA({
          template: attribute.template,
          name: attribute.name,
          value: value.stringLiteral
        });
        return _objectSpread(_objectSpread({}, preSelectedSelection), {}, {
          [attribute.name]: ((_attribute$values6 = attribute.values) === null || _attribute$values6 === void 0 ? void 0 : _attribute$values6.length) === 1 ? attribute.values[0].name : value.stringLiteral
        });
      }
      const attributeRange = getResolvedNumericAttributeFromGroup(remainingOptions, attribute.name);
      const number = attributeRange === null || attributeRange === void 0 ? void 0 : attributeRange.values[0];
      if ((attributeRange === null || attributeRange === void 0 ? void 0 : attributeRange.values.length) === 1 && (number === null || number === void 0 ? void 0 : number.type) === "numberLiteral") {
        sendPreselectedAttributeToGA({
          template: attribute.template,
          name: attribute.name,
          value: number.numberLiteral
        });
        return _objectSpread(_objectSpread({}, preSelectedSelection), {}, {
          [attribute.name]: number.numberLiteral
        });
      }
      return preSelectedSelection;
    }, {});
    return {
      selection: _objectSpread(_objectSpread({}, selection), preSelectedAttributes),
      touchedAttributes: [...context.touchedAttributes, ...Object.keys(preSelectedAttributes)]
    };
  }
  context.attributes.some(_ref54 => {
    let {
      name,
      defaultValue
    } = _ref54;
    if (!selectionAttributes.includes(name)) {
      var _remainingAttributeOp;
      const remainingAttributeOptions = getResolvedStringAttributeFromGroup(remainingOptions, name);
      const attributeValue = remainingAttributeOptions === null || remainingAttributeOptions === void 0 || (_remainingAttributeOp = remainingAttributeOptions.values[0]) === null || _remainingAttributeOp === void 0 ? void 0 : _remainingAttributeOp.stringLiteral;
      if (defaultValue && remainingAttributeOptions !== null && remainingAttributeOptions !== void 0 && remainingAttributeOptions.values.some(_ref55 => {
        let {
          stringLiteral
        } = _ref55;
        return stringLiteral === defaultValue;
      })) {
        selection[name] = defaultValue;
        return selection;
      }
      if (attributeValue) {
        selection[name] = attributeValue;
        return selection;
      }
    }
    return void 0;
  });
  if (!hasGroupedQuantity(context.attributes) && !context.totalQuantity) {
    var _context$product, _context$product$cust;
    const quantityValue = quantity === null || quantity === void 0 ? void 0 : quantity.values[0];
    const defaultQuantity = (_context$product = context.product) !== null && _context$product !== void 0 && _context$product.isPimProduct ? (_context$product$cust = context.product.customProductQuantities) === null || _context$product$cust === void 0 ? void 0 : _context$product$cust[0] : (quantityValue === null || quantityValue === void 0 ? void 0 : quantityValue.type) === "range" && quantityValue.range.minimum || (quantityValue === null || quantityValue === void 0 ? void 0 : quantityValue.type) === "numberLiteral" && parseInt(quantityValue.numberLiteral, 10) || void 0;
    return {
      selection: _objectSpread(_objectSpread({}, selection), {}, {
        Quantity: String(defaultQuantity)
      }),
      totalQuantity: defaultQuantity
    };
  }
  return {
    selection
  };
};
var unsetAttribute = _ref56 => {
  let {
    context,
    event
  } = _ref56;
  const violated = event.output.filter(validation => validation.result.violatedAttributes.length);
  const [updatedSelection] = violated.map(violatedValidation => violatedValidation.result.violatedAttributes.reduce((selection, attributeName) => {
    const attribute = getAttribute(context.attributes, attributeName);
    if ((attribute === null || attribute === void 0 ? void 0 : attribute.template) !== "hidden") {
      const touchedAttributes = context.touchedAttributes.filter(touchedAttribute => touchedAttribute !== attributeName);
      const unsetSelection = Object.keys(selection.selection).length ? selection.selection : _objectSpread({}, context.selection);
      if (attributeName === "groupedQuantity") {
        unsetSelection[attributeName] = "1";
        return {
          selection: unsetSelection,
          group: [],
          totalQuantity: 1,
          touchedAttributes
        };
      }
      delete unsetSelection[attributeName];
      if (context.group.some(group => Object.keys(group.attributes).includes(attributeName))) {
        return {
          selection: unsetSelection,
          group: [],
          totalQuantity: selection.totalQuantity,
          touchedAttributes
        };
      }
      return {
        selection: unsetSelection,
        group: context.group,
        totalQuantity: selection.totalQuantity,
        touchedAttributes
      };
    }
    return selection;
  }, {
    selection: {},
    group: [],
    totalQuantity: context.totalQuantity,
    touchedAttributes: context.touchedAttributes
  }));
  return {
    selection: updatedSelection.selection,
    group: updatedSelection.group,
    totalQuantity: updatedSelection.totalQuantity || context.totalQuantity,
    touchedAttributes: updatedSelection.touchedAttributes,
    invalidSelection: {}
  };
};
var storePrices = _ref57 => {
  let {
    context,
    event
  } = _ref57;
  const {
    attributes,
    totalQuantity,
    selection,
    servicePrice,
    remainingOptionsPerGroup,
    isExp1574,
    artworkRequired
  } = context;
  const prices = event.output;
  Sentry.addTrace({
    category: "product-selector",
    message: "Price selected",
    data: {
      prices
    },
    level: "debug"
  });
  const combinedPrices = prices.flat();
  const {
    priceAttributes
  } = getPricePivot(attributes);
  const [printingProcess, deliveryType] = priceAttributes;
  const pricingAttribute = isExp1574 && artworkRequired ? "Printing Colors" : printingProcess.name;
  const productPrice = combinedPrices.find(_ref58 => {
    let {
      name
    } = _ref58;
    return name === selection[pricingAttribute];
  });
  const pricesPerQuantity = productPrice === null || productPrice === void 0 ? void 0 : productPrice.quantities.reduce((quantities, _ref59) => {
    let {
      quantity,
      deliveryTypes
    } = _ref59;
    const deliveryTypesPerQuantity = deliveryTypes.filter(type => getSelectionValue(selection, type.name) && type.price);
    if (deliveryTypesPerQuantity.length > 0) {
      return [...quantities, {
        quantity,
        deliveryType: deliveryTypesPerQuantity[0]
      }];
    }
    return quantities;
  }, []);
  const selectedQuantity = productPrice === null || productPrice === void 0 ? void 0 : productPrice.quantities.find(_ref60 => {
    let {
      quantity
    } = _ref60;
    return quantity === (totalQuantity || (pricesPerQuantity === null || pricesPerQuantity === void 0 ? void 0 : pricesPerQuantity[0].quantity));
  });
  const updatedSelection = !totalQuantity && !hasGroupedQuantity(attributes) ? _objectSpread(_objectSpread({}, selection), {}, {
    Quantity: String(pricesPerQuantity === null || pricesPerQuantity === void 0 ? void 0 : pricesPerQuantity[0].quantity)
  }) : selection;
  const selectedPrice = selectedQuantity === null || selectedQuantity === void 0 ? void 0 : selectedQuantity.deliveryTypes.find(_ref61 => {
    let {
      name
    } = _ref61;
    return name === selection[deliveryType.name];
  });
  const allPriceAttributeValues = isExp1574 ? [...getResolvedAttributeOptions(attributes, remainingOptionsPerGroup, "Printing Colors"), ...getResolvedAttributeOptions(attributes, remainingOptionsPerGroup, "Delivery Type")] : priceAttributes.flatMap(attribute => attribute.values || []);
  const alternativePrices = allPriceAttributeValues.reduce((alternativePriceAttributeValues, value) => {
    var _alternativePrice$pri, _selectedPrice$price;
    if (value.name === selection[pricingAttribute]) {
      return [...alternativePriceAttributeValues, {
        [value.name]: 0
      }];
    }
    const price = combinedPrices.find(_ref62 => {
      let {
        name
      } = _ref62;
      return name === value.name;
    });
    const alternativePriceQuantity = price === null || price === void 0 ? void 0 : price.quantities.find(_ref63 => {
      let {
        quantity
      } = _ref63;
      return quantity === totalQuantity;
    });
    const alternativePrice = (alternativePriceQuantity === null || alternativePriceQuantity === void 0 ? void 0 : alternativePriceQuantity.deliveryTypes.find(_ref64 => {
      let {
        name
      } = _ref64;
      return name === selection[deliveryType.name];
    })) || (selectedQuantity === null || selectedQuantity === void 0 ? void 0 : selectedQuantity.deliveryTypes.find(_ref65 => {
      let {
        name
      } = _ref65;
      return name === value.name;
    }));
    if (alternativePrice !== null && alternativePrice !== void 0 && (_alternativePrice$pri = alternativePrice.price) !== null && _alternativePrice$pri !== void 0 && _alternativePrice$pri.totalNet.centAmount && selectedPrice !== null && selectedPrice !== void 0 && (_selectedPrice$price = selectedPrice.price) !== null && _selectedPrice$price !== void 0 && _selectedPrice$price.totalNet.centAmount) {
      return [...alternativePriceAttributeValues, {
        [value.name]: alternativePrice.price.totalNet.centAmount - selectedPrice.price.totalNet.centAmount
      }];
    }
    return [...alternativePriceAttributeValues, {
      [value.name]: void 0
    }];
  }, []);
  return {
    prices: combinedPrices,
    price: selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.price,
    totalPrice: getTotalPrice(selectedPrice === null || selectedPrice === void 0 ? void 0 : selectedPrice.price, servicePrice),
    alternativePrices,
    pricesPerQuantity,
    selection: updatedSelection,
    totalQuantity: updatedSelection.Quantity ? Number(updatedSelection.Quantity) : totalQuantity
  };
};
var storePricing = _ref66 => {
  var _pricesPerQuantity$fi, _pricesPerQuantity$, _pricesPerQuantity$2;
  let {
    context,
    event
  } = _ref66;
  const [prices] = event.output;
  const pricesPerQuantity = getPricePerQuantity(prices);
  const deliveryOptionName = context.selectedDeliveryOption.name;
  const hasDefaultValues = context.selectionMode === "default-values";
  const selectedPrice = context.totalQuantity ? (_pricesPerQuantity$fi = pricesPerQuantity.find(_ref67 => {
    let {
      quantity,
      deliveryType
    } = _ref67;
    return quantity === context.totalQuantity && deliveryType.name === deliveryOptionName;
  })) === null || _pricesPerQuantity$fi === void 0 ? void 0 : _pricesPerQuantity$fi.deliveryType.price : (_pricesPerQuantity$ = pricesPerQuantity[0]) === null || _pricesPerQuantity$ === void 0 ? void 0 : _pricesPerQuantity$.deliveryType.price;
  return _objectSpread({
    prices: event.output,
    pricesPerQuantity
  }, hasDefaultValues && {
    price: selectedPrice,
    totalPrice: getTotalPrice(selectedPrice, context.servicePrice),
    totalQuantity: context.totalQuantity || ((_pricesPerQuantity$2 = pricesPerQuantity[0]) === null || _pricesPerQuantity$2 === void 0 ? void 0 : _pricesPerQuantity$2.quantity)
  });
};
var storePivotPrices = _ref68 => {
  let {
    event
  } = _ref68;
  return {
    pivotPrices: event.output
  };
};
var storeDeliveryDates = _ref69 => {
  let {
    context,
    event
  } = _ref69;
  const deliveryOption = getDeliveryOption(event.output, context.selectedDeliveryOption.id);
  return _objectSpread({
    deliveryDates: event.output
  }, event.output.length > 0 && {
    selectedDeliveryOption: context.selectedDeliveryOption.id ? deliveryOption : event.output.find(_ref70 => {
      let {
        name
      } = _ref70;
      return name === "Normal";
    })
  });
};
var initializeContext = _ref71 => {
  let {
    event
  } = _ref71;
  return {
    attributes: event.attributes,
    attributesCount: event.attributes.length,
    selection: event.selection,
    group: event.group,
    groupAttributes: event.groupAttributes,
    totalQuantity: Number(event.totalQuantity),
    productKey: event.productKey,
    serviceKeys: event.serviceKeys,
    selectedService: void 0,
    mcpSku: event.mcpSku,
    shippingAddress: event.shippingAddress,
    customerGroupId: event.customerGroupId,
    invalidSelection: {},
    panel: event.panel,
    device: event.device,
    isReviewPage: event.isReviewPage,
    selectionMode: event.selectionMode,
    product: event.product,
    selectedDeliveryOption: {
      id: event.selectedDeliveryOptionId,
      name: "Normal"
    }
  };
};
var storeRemainingOptions = _ref72 => {
  let {
    context,
    event
  } = _ref72;
  const remainingOptionsPerGroup = getRemainingOptionsPerGroup(event.output);
  return {
    remainingOptionsPerGroup,
    artworkRequired: hasResolvedValue(remainingOptionsPerGroup, "Artwork Required", "Yes"),
    productAttributes: event.output[0].result.attributes,
    panel: getSplitSizePanelInfo(remainingOptionsPerGroup, context.panel),
    attributes: updateAttributes(context.attributes, remainingOptionsPerGroup)
  };
};
var updateSelection = _ref73 => {
  let {
    context,
    event
  } = _ref73;
  const {
    groupSelection,
    attributeSelection,
    groupedAttributes,
    valid,
    groupName
  } = event;
  const defaultValueNoPrintArea = 1;
  if (groupedAttributes) {
    return _objectSpread(_objectSpread({
      selection: _objectSpread(_objectSpread({}, context.selection), groupedAttributes)
    }, groupName && {
      touchedAttributes: [groupName, ...context.touchedAttributes]
    }), groupedAttributes.Quantity && {
      totalQuantity: Number(groupedAttributes.Quantity)
    });
  }
  if (groupSelection) {
    const totalQuantity = getTotalQuantity2(groupSelection);
    return {
      selection: _objectSpread(_objectSpread({}, context.selection), {}, {
        groupedQuantity: String(totalQuantity)
      }),
      group: groupSelection,
      totalQuantity,
      panel: {
        openPanel: false,
        panelName: "groupedQuantity"
      },
      touchedAttributes: [...context.touchedAttributes, "groupedQuantity"]
    };
  }
  if (attributeSelection) {
    var _conditionalAttribute;
    if (attributeSelection.name === "Print Area" && attributeSelection.value === "No Print") {
      return _objectSpread(_objectSpread({
        selection: _objectSpread(_objectSpread({}, context.selection), {}, {
          [attributeSelection.name]: attributeSelection.value,
          groupedQuantity: String(defaultValueNoPrintArea)
        }),
        totalQuantity: defaultValueNoPrintArea,
        group: []
      }, !valid && {
        invalidSelection: {
          [attributeSelection.name]: attributeSelection.value,
          groupedQuantity: String(defaultValueNoPrintArea)
        }
      }), {}, {
        touchedAttributes: [...context.touchedAttributes, attributeSelection.name]
      });
    }
    if (["groupedQuantity", "Quantity"].includes(attributeSelection.name)) {
      return {
        selection: _objectSpread(_objectSpread({}, context.selection), {}, {
          [attributeSelection.name]: attributeSelection.value
        }),
        totalQuantity: Number(attributeSelection.value),
        group: [],
        touchedAttributes: [...context.touchedAttributes, attributeSelection.name]
      };
    }
    const conditionalAttribute = context.attributes.find(attribute => attribute.isConditionalAttribute);
    const conditionChanged = conditionalAttribute === null || conditionalAttribute === void 0 || (_conditionalAttribute = conditionalAttribute.conditionalAttributeRules) === null || _conditionalAttribute === void 0 ? void 0 : _conditionalAttribute.includes(attributeSelection.name);
    if (conditionChanged && (conditionalAttribute === null || conditionalAttribute === void 0 ? void 0 : conditionalAttribute.type) === "group") {
      const conditionalAttributes = conditionalAttribute.attributes.map(attribute => attribute.name);
      const newSelection = _objectSpread({}, context.selection);
      conditionalAttributes.forEach(attributeName => {
        delete newSelection[attributeName];
      });
      return {
        selection: _objectSpread(_objectSpread({}, newSelection), {}, {
          [attributeSelection.name]: attributeSelection.value
        }),
        invalidSelection: valid ? {} : {
          [attributeSelection.name]: attributeSelection.value
        },
        touchedAttributes: [...context.touchedAttributes, attributeSelection.name],
        price: void 0
      };
    }
    return {
      selection: _objectSpread(_objectSpread({}, context.selection), {}, {
        [attributeSelection.name]: attributeSelection.value
      }),
      invalidSelection: valid ? {} : {
        [attributeSelection.name]: attributeSelection.value
      },
      touchedAttributes: [...context.touchedAttributes, attributeSelection.name],
      price: void 0
    };
  }
  return context;
};
var restoreDefaults = _ref74 => {
  let {
    context,
    event
  } = _ref74;
  Sentry.addTrace({
    category: "product-selector",
    message: "Restored to defaults",
    level: "debug",
    data: event
  });
  const attributes = event.attributes || context.attributes;
  return {
    selection: getDefaultSelection(attributes),
    attributes,
    group: [],
    totalQuantity: Number(getDefaultSelection(attributes).groupedQuantity) || 0,
    invalidSelection: {},
    touchedAttributes: [],
    device: context.device,
    merchantRules: {
      deliveryTool: {}
    },
    price: void 0,
    prices: [],
    totalPrice: void 0,
    selectedService: void 0,
    servicePrices: void 0,
    selectedDeliveryOption: {
      name: "Normal"
    },
    selectionMode: event.selectionMode || context.selectionMode,
    panel: {
      openPanel: false,
      showMessage: false,
      panelName: ""
    },
    productRouteClicked: false
  };
};
var storeInvalidSelection = _ref75 => {
  let {
    event
  } = _ref75;
  return _objectSpread({}, event.attributeSelection && {
    invalidSelection: {
      [event.attributeSelection.name]: event.attributeSelection.value
    }
  });
};
var replaceSelection = _ref76 => {
  let {
    event
  } = _ref76;
  Sentry.addTrace({
    category: "product-selector",
    message: "Product route selected",
    data: {
      selection: event.selection
    },
    level: "debug"
  });
  const {
    selection,
    groupSelection,
    totalQuantity,
    touchedAttributes
  } = event;
  if (groupSelection.length > 0) {
    const groupedQuantity = getTotalQuantity2(groupSelection);
    return {
      selection: _objectSpread(_objectSpread({}, selection), {}, {
        groupedQuantity: String(groupedQuantity)
      }),
      group: groupSelection,
      totalQuantity: groupedQuantity,
      panel: {
        openPanel: false,
        panelName: "groupedQuantity"
      },
      touchedAttributes: [...touchedAttributes, "groupedQuantity"]
    };
  }
  return {
    selection,
    group: groupSelection,
    totalQuantity,
    touchedAttributes,
    productRouteClicked: true
  };
};
var selectService = _ref77 => {
  var _context$servicePrice;
  let {
    context,
    event
  } = _ref77;
  return {
    selectedService: event.selectedService,
    totalPrice: getTotalPrice(context.price, (_context$servicePrice = context.servicePrices) === null || _context$servicePrice === void 0 ? void 0 : _context$servicePrice[event.selectedService])
  };
};
var togglePanel = _ref78 => {
  var _event$openPanel, _event$showMessage;
  let {
    context,
    event
  } = _ref78;
  return {
    panel: {
      panelName: event.panelName || context.panel.panelName,
      openPanel: (_event$openPanel = event.openPanel) !== null && _event$openPanel !== void 0 ? _event$openPanel : !context.panel.openPanel,
      showMessage: (_event$showMessage = event.showMessage) !== null && _event$showMessage !== void 0 ? _event$showMessage : context.panel.showMessage,
      values: event.values,
      variant: event.variant,
      message: event.message
    }
  };
};
var setPrice = _ref79 => {
  var _context$servicePrice2;
  let {
    context,
    event
  } = _ref79;
  const servicePrice = context.selectedService && ((_context$servicePrice2 = context.servicePrices) === null || _context$servicePrice2 === void 0 ? void 0 : _context$servicePrice2[context.selectedService]) || void 0;
  return {
    price: event.price,
    totalPrice: getTotalPrice(event.price, servicePrice),
    priceAttributes: event.priceAttributes
  };
};
var setQuantity = _ref80 => {
  let {
    context,
    event
  } = _ref80;
  return {
    totalQuantity: Number(event.quantity),
    touchedAttributes: [...context.touchedAttributes, "Quantity"]
  };
};
var setCustomQuantity = _ref81 => {
  var _context$product$cust2, _context$product$cust3, _context$product$cust4, _context$product$cust5;
  let {
    context,
    event
  } = _ref81;
  if (!context.product) {
    return {
      product: context.product,
      touchedAttributes: context.touchedAttributes
    };
  }
  return {
    product: _objectSpread(_objectSpread({}, context.product), {}, {
      customProductQuantities: context.customQuantity ? [...((_context$product$cust2 = (_context$product$cust3 = context.product.customProductQuantities) === null || _context$product$cust3 === void 0 ? void 0 : _context$product$cust3.slice(0, -1)) !== null && _context$product$cust2 !== void 0 ? _context$product$cust2 : []), event.customQuantity] : [...((_context$product$cust4 = (_context$product$cust5 = context.product.customProductQuantities) === null || _context$product$cust5 === void 0 ? void 0 : _context$product$cust5.slice(0, MAX_CUSTOM_QUANTITIES)) !== null && _context$product$cust4 !== void 0 ? _context$product$cust4 : []), event.customQuantity]
    }),
    totalQuantity: event.customQuantity,
    customQuantity: event.customQuantity,
    touchedAttributes: [...context.touchedAttributes, "Quantity"]
  };
};
var setDeliveryOption = _ref82 => {
  let {
    context,
    event
  } = _ref82;
  return {
    selectedDeliveryOption: event.deliveryOption,
    touchedAttributes: [...context.touchedAttributes, "Delivery Option"]
  };
};
var shouldLogViolationError = () => {
  try {
    return configurationProvider2.getValueAsBoolean("PRODUCT_SELECTOR_LOG_VIOLATION_ERRORS");
  } catch (error) {
    return true;
  }
};
var logViolationError = _ref83 => {
  let {
    context,
    event
  } = _ref83;
  if (!shouldLogViolationError()) {
    return;
  }
  const {
    selection,
    attributes
  } = context;
  const lockedAttributes = event.output.map(validation => getLockedAttributes(selection, attributes, validation.result.violatedAttributes));
  Sentry.exception({
    exception: "Attribute-revalidation expects unsetting locked attributes, but cannot.",
    tags: {
      component: "printdeal-selector",
      eventName: "FailedLockedAttributeRevalidation",
      fileLocation: "SelectorActions",
      featureFunction: "correctProductConfigToValid"
    },
    extra: {
      userSelection: JSON.stringify(selection),
      violatedAttributes: JSON.stringify(event.output.map(validation => validation.result.violatedAttributes)),
      correctionFailureLockedAttributes: JSON.stringify(lockedAttributes)
    },
    fingerprint: ["printdeal-selector-correct-product-config-to-valid-failed-locked-attribute-revalidation"]
  });
};
var logError = (data, selection, featureFunction, extra, error, fileLocation, fingerprint) => Sentry.exception({
  exception: error || ("error" in data && data.error instanceof Error ? data.error : "An error occurred in the selector machine"),
  tags: {
    component: "printdeal-selector",
    fileLocation: fileLocation || "SelectorActions",
    featureFunction
  },
  extra: _objectSpread({
    userSelection: JSON.stringify(selection),
    data: JSON.stringify(data)
  }, extra),
  fingerprint: [fingerprint || featureFunction]
});
var updateSelectionAndRemainingOptions = _ref84 => {
  var _context$attributes$f, _remainingPrintingCol;
  let {
    context,
    event
  } = _ref84;
  const exp1574RemainingOptions = getRemainingOptionsPerGroup(event.output);
  const defaultValue = (_context$attributes$f = context.attributes.find(attribute => attribute.name === "Printing Colors")) === null || _context$attributes$f === void 0 ? void 0 : _context$attributes$f.defaultValue;
  const remainingPrintingColorsOptions = getResolvedStringAttributeFromGroup(exp1574RemainingOptions, "Printing Colors");
  let printingColorsValue = remainingPrintingColorsOptions === null || remainingPrintingColorsOptions === void 0 || (_remainingPrintingCol = remainingPrintingColorsOptions.values[0]) === null || _remainingPrintingCol === void 0 ? void 0 : _remainingPrintingCol.stringLiteral;
  if (defaultValue && remainingPrintingColorsOptions !== null && remainingPrintingColorsOptions !== void 0 && remainingPrintingColorsOptions.values.some(_ref85 => {
    let {
      stringLiteral
    } = _ref85;
    return stringLiteral === defaultValue;
  })) {
    printingColorsValue = defaultValue;
  }
  if (remainingPrintingColorsOptions !== null && remainingPrintingColorsOptions !== void 0 && remainingPrintingColorsOptions.values.some(_ref86 => {
    let {
      stringLiteral
    } = _ref86;
    return stringLiteral === context.selection["Printing Colors"];
  })) {
    printingColorsValue = context.selection["Printing Colors"];
  }
  return {
    selection: _objectSpread(_objectSpread({}, context.selection), {}, {
      "Printing Colors": printingColorsValue
    }),
    remainingOptionsPerGroup: exp1574RemainingOptions
  };
};

// src/statemachines/actors/selectorActors.ts
import { fromPromise } from "xstate";

// src/http-clients/contentfulClient.ts
import axios2 from "axios";
import { configurationProvider as configurationProvider3 } from "@printdeal/configuration";
var getProductContentQuery = storeKey => "\n  query GetProductContent($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      ".concat(storeKey !== "drukwerkdeal-nl" ? "sharedSelector { sys { urn } }" : "", "\n      selectorCollection(limit: 1) {\n        items {\n          ... on ProductSelector {\n            productSelector: sys {\n              id\n            }\n          }\n        }\n      }\n      selectorExperiment {\n        ... on Experiment {\n          experiment: sys {\n              id\n          }\n          experimentId\n        }\n      }\n    }\n  }\n");
var productFragments = "\nfragment AttributeValue on AttributeValue {\n    sys {\n      id\n    }\n    pimAttributeValue\n    attributeValueAlias\n    attributeValueImage {\n      sys {\n        id\n      }\n      title\n      url\n      width\n      height\n    }\n    supportArticle {\n      sys {\n        id\n      }\n    }\n  }\n\n  fragment Attribute on Attribute {\n    sys {\n      id\n    }\n    attributeAlias\n    pimAttributeName\n    attributeValueCollection(limit: 140) {\n      items {\n        ...AttributeValue\n      }\n    }\n    supportArticle {\n      sys {\n        id\n      }\n    }\n  }\n\n  fragment Product on Product {\n    sys {\n      id\n    }\n    key\n    mcpSku\n    productName\n    isPimProduct\n    customProductQuantities\n    productVersion\n    attributesCollection(limit: 25) {\n      items {\n        ...Attribute\n      }\n    }\n  }\n";
var fragments = "\n  ".concat(productFragments, "\n  fragment ProductSelector on ProductSelector {\n    sys {\n      id\n    }\n    product {\n      ...Product\n    }\n    selectionMode\n    configuration\n  }\n\n  fragment SelectorOverrides on SelectorOverrides {\n    sys {\n      id\n    }\n    title\n    overrides\n  }\n");
var productSelectorQuery = "\n  ".concat(fragments, "\n\n  query Selector($selectorId: String!, $locale: String!) {\n    productSelector(id: $selectorId, locale: $locale) {\n      ...ProductSelector\n    }\n    selectorOverridesCollection {\n      items {\n        ...SelectorOverrides\n      }\n    }\n  }\n");
var supportArticleContentQuery = "\n  query($id: String!, $locale: String!) {\n    supportArticlePage(id: $id, locale: $locale) {\n      sys {\n        id\n      }\n      slug\n      title\n      category {\n        slug\n      }\n      gallery {\n        sys {\n          id\n        }\n        title\n        imagesCollection {\n          items {\n            sys {\n              id\n            }\n            title\n            url\n            width\n            height\n          }\n        }\n      }\n      heroImage {\n        sys {\n          id\n        }\n        title\n        url\n        width\n        height\n      }\n      summary\n      content\n      faqsCollection {\n        items {\n          sys {\n            id\n          }\n          title\n          content\n        }\n      }\n    }\n  }\n";
var systemPageContentQuery = "\n  query($pageSystemType: String!, $locale: String!) {\n    pageSystemCollection(\n      where: { pageSytemType: $pageSystemType }\n      locale: $locale\n    ) {\n      items {\n        slug\n      }\n    }\n  }\n";
var sizeTableContentQuery = "\n  query($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      productTabsCollection(where: { type: \"size-table\" }) {\n        items {\n          sys {\n            id\n          }\n          displayTitle\n          content\n        }\n      }\n    }\n  }\n";
var getExperimentContentQuery = variation => "\n  query($experimentContentId: String!, $locale: String!) {\n    experiment(id: $experimentContentId, locale: $locale) {\n      ".concat(variation, " {\n        ... on ProductSelector {\n          productSelector: sys {\n            id\n          }\n        }\n      }\n    }\n  }\n");
var useNewSelectorQuery = "\n  query($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      useNewSelector\n    }\n  }\n";
var ExperimentContentQuery = "\n  query($productPageId: String!, $locale: String!) {\n    productContent(id: $productPageId, locale: $locale) {\n      selectorExperiment {\n        ... on Experiment {\n          experiment: sys {\n              id\n          }\n          experimentId\n        }\n      }\n    }\n  }\n";
var productQuery = "\n  ".concat(productFragments, "\n\n  query Product($productKey: String!, $locale: String!) {\n    product (id: $productKey, locale: $locale) {\n      ...Product\n    }\n  }\n");
var mapConfigurationValueToAttribute = value => ({
  id: value.id,
  name: value.name,
  enabled: value.enabled,
  conditionalAttributeValueRules: value.conditionalAttributeValueRules
});
var mapProductAttributeValues = value => ({
  id: value.sys.id,
  pimAttributeValue: value.pimAttributeValue,
  attributeValueAlias: value.attributeValueAlias,
  attributeValueImage: value.attributeValueImage ? {
    id: value.attributeValueImage.sys.id,
    url: value.attributeValueImage.url,
    title: value.attributeValueImage.title,
    width: value.attributeValueImage.width,
    height: value.attributeValueImage.height
  } : void 0,
  supportArticle: value.supportArticle ? {
    id: value.supportArticle.sys.id
  } : void 0
});
var filterAndMapAttributeValues = (attributeValues, selectorOverrides, attributeName, mapFunction, getValueName) => {
  const attributeValuesOverrideArray = selectorOverrides.find(override => typeof override.overrides.disabledOptions[attributeName] !== "undefined");
  const attributeValuesToOverride = attributeValuesOverrideArray === null || attributeValuesOverrideArray === void 0 ? void 0 : attributeValuesOverrideArray.overrides.disabledOptions[attributeName];
  return attributeValues.filter(value => !(attributeValuesToOverride !== null && attributeValuesToOverride !== void 0 && attributeValuesToOverride.includes(getValueName(value)))).map(mapFunction);
};
var convertToSelectorContent = (contentfulSelector, selectorOverrides) => {
  var _contentfulSelector$p;
  return {
    id: contentfulSelector.sys.id,
    product: {
      id: contentfulSelector.product.sys.id,
      key: contentfulSelector.product.key,
      mcpSku: contentfulSelector.product.mcpSku,
      productName: contentfulSelector.product.productName,
      isPimProduct: contentfulSelector.product.isPimProduct,
      customProductQuantities: (_contentfulSelector$p = contentfulSelector.product.customProductQuantities) === null || _contentfulSelector$p === void 0 ? void 0 : _contentfulSelector$p.map(quantity => Number(quantity)),
      productVersion: contentfulSelector.product.productVersion,
      attributes: contentfulSelector.product.attributesCollection.items.map(item => ({
        id: item.sys.id,
        attributeAlias: item.attributeAlias,
        pimAttributeName: item.pimAttributeName,
        supportArticle: item.supportArticle ? {
          id: item.supportArticle.sys.id
        } : void 0,
        values: filterAndMapAttributeValues(item.attributeValueCollection.items, selectorOverrides, item.pimAttributeName, mapProductAttributeValues, value => value.pimAttributeValue)
      }))
    },
    selectionMode: contentfulSelector.selectionMode,
    configuration: {
      // @ts-expect-error - TODO: Fix prior to merge
      attributes: contentfulSelector.configuration.attributes.map(attribute => {
        var _attribute$values7, _attribute$grid$colum, _attribute$grid$row$v;
        return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
          id: attribute.id,
          name: attribute.name,
          type: attribute.type,
          pimName: attribute.pimName,
          template: attribute.template,
          defaultValue: attribute.defaultValue,
          disablePopularOptions: attribute.disablePopularOptions,
          invalidValuesVisibility: attribute.invalidValuesVisibility
        }, attribute.onReviewPage && {
          onReviewPage: attribute.onReviewPage
        }), attribute.hasSizesDiffer && {
          hasSizesDiffer: attribute.hasSizesDiffer
        }), ((_attribute$values7 = attribute.values) === null || _attribute$values7 === void 0 ? void 0 : _attribute$values7.length) && {
          values: filterAndMapAttributeValues(attribute.values, selectorOverrides, attribute.name, mapConfigurationValueToAttribute, value => value.name)
        }), attribute.groupTitle && {
          groupTitle: attribute.groupTitle
        }), attribute.isConditionalAttribute && {
          isConditionalAttribute: attribute.isConditionalAttribute
        }), attribute.conditionalAttributeRules && {
          conditionalAttributeRules: attribute.conditionalAttributeRules
        }), attribute.type === "group" && {
          attributes: attribute.attributes
        }), attribute.grid && {
          grid: {
            invalidValuesVisibility: attribute.grid.invalidValuesVisibility,
            column: {
              id: attribute.grid.column.id,
              name: attribute.grid.column.name,
              type: attribute.grid.column.type,
              pimName: attribute.grid.column.pimName,
              template: attribute.grid.column.template,
              defaultValue: attribute.grid.column.defaultValue,
              invalidValuesVisibility: attribute.grid.column.invalidValuesVisibility,
              values: (_attribute$grid$colum = attribute.grid.column.values) === null || _attribute$grid$colum === void 0 ? void 0 : _attribute$grid$colum.map(value => ({
                id: value.id,
                name: value.name,
                enabled: value.enabled
              }))
            },
            row: {
              id: attribute.grid.row.id,
              name: attribute.grid.row.name,
              type: attribute.grid.row.type,
              pimName: attribute.grid.row.pimName,
              template: attribute.grid.row.template,
              defaultValue: attribute.grid.row.defaultValue,
              invalidValuesVisibility: attribute.grid.row.invalidValuesVisibility,
              values: (_attribute$grid$row$v = attribute.grid.row.values) === null || _attribute$grid$row$v === void 0 ? void 0 : _attribute$grid$row$v.map(value => ({
                id: value.id,
                name: value.name,
                enabled: value.enabled
              }))
            }
          }
        });
      }),
      variantSku: contentfulSelector.configuration.variantSku
    }
  };
};
var convertToSupportArticleContent = contentfulSupportArticle => ({
  id: contentfulSupportArticle.sys.id,
  slug: contentfulSupportArticle.slug,
  title: contentfulSupportArticle.title,
  categorySlug: contentfulSupportArticle.category && contentfulSupportArticle.category.slug,
  gallery: contentfulSupportArticle.gallery && {
    id: contentfulSupportArticle.gallery.sys.id,
    title: contentfulSupportArticle.gallery.title,
    images: contentfulSupportArticle.gallery.imagesCollection.items.map(item => ({
      id: item.sys.id,
      title: item.title,
      url: item.url,
      width: item.width,
      height: item.height
    }))
  },
  heroImage: contentfulSupportArticle.heroImage && {
    id: contentfulSupportArticle.heroImage.sys.id,
    title: contentfulSupportArticle.heroImage.title,
    url: contentfulSupportArticle.heroImage.url,
    width: contentfulSupportArticle.heroImage.width,
    height: contentfulSupportArticle.heroImage.height
  },
  summary: contentfulSupportArticle.summary,
  content: contentfulSupportArticle.content,
  faqs: contentfulSupportArticle.faqsCollection.items.map(item => ({
    id: item.sys.id,
    title: item.title,
    content: item.content
  }))
});
var convertToSystemPage = systemPageData => ({
  slug: systemPageData.pageSystemCollection.items[0].slug
});
var convertToSizeTableContent = contentfulSizeTable => {
  if (!contentfulSizeTable.productContent.productTabsCollection.items.length) {
    return null;
  }
  const item = contentfulSizeTable.productContent.productTabsCollection.items[0];
  return {
    id: item.sys.id,
    title: item.displayTitle,
    content: item.content
  };
};
var getProductData = async (productKey, locale) => {
  const spaceId = configurationProvider3.getValue("CONTENTFUL_SPACE_ID");
  const accessToken = configurationProvider3.getValue("CONTENTFUL_ACCESS_TOKEN");
  const environment = configurationProvider3.getValue("CONTENTFUL_ENVIRONMENT");
  const client = axios2.create({
    baseURL: "https://graphql.contentful.com/content/v1/spaces/".concat(spaceId, "/environments/").concat(environment),
    headers: {
      Authorization: "Bearer ".concat(accessToken)
    }
  });
  const {
    data
  } = await client.post("/", {
    query: productQuery,
    variables: {
      productKey,
      locale
    }
  });
  return data.data;
};
var getSharedSelectorContent = async (selectorId, locale) => {
  if (!selectorId) {
    throw new Error("No selector id or locale provided");
  }
  try {
    const spaceId = configurationProvider3.getValue("CONTENTFUL_DWD_SPACE_ID");
    const accessToken = configurationProvider3.getValue("CONTENTFUL_DWD_ACCESS_TOKEN");
    const client = axios2.create({
      baseURL: "https://graphql.contentful.com/content/v1/spaces/".concat(spaceId, "/environments/master"),
      headers: {
        Authorization: "Bearer ".concat(accessToken)
      }
    });
    const {
      data
    } = await client.post("/", {
      query: productSelectorQuery,
      variables: {
        selectorId,
        locale: "nl-NL"
      }
    });
    const productKey = data.data.productSelector.product.key;
    const productData = await getProductData(productKey, locale);
    data.data.productSelector.product = productData.product;
    return convertToSelectorContent(data.data.productSelector, data.data.selectorOverridesCollection.items);
  } catch (error) {
    Sentry.exception({
      exception: error,
      tags: {
        fileLocation: "contentfulClient",
        featureFunction: "getSharedSelectorContent"
      },
      fingerprint: ["get-shared-selector-content"]
    });
    throw new Error("Something went wrong while fetching the shared selector content from Contentful ".concat(error));
  }
};
var ContentfulClient = class {
  constructor() {
    __publicField(this, "httpClient");
  }
  get client() {
    if (!this.httpClient) {
      const spaceId = configurationProvider3.getValue("CONTENTFUL_SPACE_ID");
      const environment = configurationProvider3.getValue("CONTENTFUL_ENVIRONMENT");
      const accessToken = configurationProvider3.getValue("CONTENTFUL_ACCESS_TOKEN");
      this.httpClient = axios2.create({
        baseURL: "https://graphql.contentful.com/content/v1/spaces/".concat(spaceId, "/environments/").concat(environment),
        headers: {
          Authorization: "Bearer ".concat(accessToken)
        }
      });
    }
    return this.httpClient;
  }
  async getProductPageContent(_ref87) {
    let {
      productPageId,
      locale,
      getExperiment
    } = _ref87;
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided");
    }
    const storeKey = configurationProvider3.getValue("STORE_KEY");
    try {
      const {
        data
      } = await this.client.post("/", {
        query: getProductContentQuery(storeKey),
        variables: {
          productPageId,
          locale
        }
      });
      const productDetailPage = data.data.productContent;
      if (productDetailPage.sharedSelector) {
        const sharedSelectorUrn = productDetailPage.sharedSelector.sys.urn;
        const splitUrn = sharedSelectorUrn.split("/");
        const sharedSelectorId = splitUrn[splitUrn.length - 1];
        const sharedSelector = await getSharedSelectorContent(sharedSelectorId, locale);
        return sharedSelector;
      }
      const {
        selectorExperiment,
        selectorCollection
      } = data.data.productContent;
      if (selectorExperiment) {
        const {
          experimentId,
          experiment: {
            id: experimentContentId
          }
        } = selectorExperiment;
        const {
          experiment
        } = getExperiment(experimentId);
        if (!experiment.variation) {
          const productSelectorId2 = selectorCollection.items[0].productSelector.id;
          const selector3 = await this.getSelectorContent(productSelectorId2, locale);
          return selector3;
        }
        const selectorId = await this.getExperimentSelector(experimentContentId, locale, experiment.variation);
        if (!selectorId) {
          throw new Error("No selector configured for experiment ".concat(experimentId, " on ").concat(experiment.variation));
        }
        const selector2 = await this.getSelectorContent(selectorId, locale);
        return selector2;
      }
      const productSelectorId = selectorCollection.items[0].productSelector.id;
      const selector = await this.getSelectorContent(productSelectorId, locale);
      return selector;
    } catch (error) {
      console.error("Something went wrong while fetching the product content from Contentful");
      throw error;
    }
  }
  async getSelectorContent(selectorId, locale) {
    if (!selectorId || !locale) {
      throw new Error("No selector id or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: productSelectorQuery,
        variables: {
          selectorId,
          locale
        }
      });
      return convertToSelectorContent(data.data.productSelector, data.data.selectorOverridesCollection.items);
    } catch (error) {
      console.error("Something went wrong while fetching the selector content from Contentful");
      throw error;
    }
  }
  async getSupportArticleContent(supportArticleId, locale) {
    if (!supportArticleId || !locale) {
      throw new Error("No article id or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: supportArticleContentQuery,
        variables: {
          id: supportArticleId,
          locale
        }
      });
      return convertToSupportArticleContent(data.data.supportArticlePage);
    } catch (error) {
      console.error("Something went wrong while fetching a support article from Contentful");
      throw error;
    }
  }
  async getSystemPageContent(pageSystemType, locale) {
    if (!pageSystemType || !locale) {
      throw new Error("No system page type or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: systemPageContentQuery,
        variables: {
          pageSystemType,
          locale
        }
      });
      return convertToSystemPage(data.data);
    } catch (error) {
      console.error("Something went wrong while fetching a system page from Contentful");
      throw error;
    }
  }
  /**
   * The size table is read from a product tab of a product page in Contentful.
   * TODO: Make the size table a separate content type in Contentful
   */
  async getSizeTableContent(productPageId, locale) {
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: sizeTableContentQuery,
        variables: {
          productPageId,
          locale
        }
      });
      return convertToSizeTableContent(data.data);
    } catch (error) {
      console.error("Something went wrong while fetching a size table from Contentful");
      throw error;
    }
  }
  /**
   * Retrieves the value of the "useNewSelector" property from Contentful for a given product page ID and locale.
   *
   * @param productPageId - The ID of the product page.
   * @param locale - The locale of the content.
   * @returns A Promise that resolves to a boolean indicating whether to use the new selector or not,
   * defaulting to false if no value is found.
   * @throws An error if no product page ID or locale is provided when fetching the "useNewSelector" value.
   */
  async getUseNewSelector(productPageId, locale) {
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided when fetching useNewSelector");
    }
    try {
      var _data$data$productCon, _data$data$productCon2;
      const {
        data
      } = await this.client.post("/", {
        query: useNewSelectorQuery,
        variables: {
          productPageId,
          locale
        }
      });
      return (_data$data$productCon = (_data$data$productCon2 = data.data.productContent) === null || _data$data$productCon2 === void 0 ? void 0 : _data$data$productCon2.useNewSelector) !== null && _data$data$productCon !== void 0 ? _data$data$productCon : false;
    } catch (error) {
      console.error("Something went wrong while fetching the useNewSelector value from Contentful");
      throw error;
    }
  }
  /**
   * Retrieves the value of the "selectorExperiment" property from Contentful for a given product page ID and locale.
   *
   * @param productPageId - The ID of the product page.
   * @param locale - The locale of the content.
   * @returns A Promise that resolves to a boolean indicating whether to selectorExperiment or not,
   * defaulting to false if no value is found.
   * @throws An error if no product page ID or locale is provided when fetching the "useSelectorExperiment" value.
   */
  async getExperimentContent(productPageId, locale) {
    if (!productPageId || !locale) {
      throw new Error("No product page id or locale provided when fetching useSelectorExperiment");
    }
    try {
      var _data$data$productCon3, _data$data$productCon4;
      const {
        data
      } = await this.client.post("/", {
        query: ExperimentContentQuery,
        variables: {
          productPageId,
          locale
        }
      });
      return (_data$data$productCon3 = (_data$data$productCon4 = data.data.productContent) === null || _data$data$productCon4 === void 0 ? void 0 : _data$data$productCon4.selectorExperiment) !== null && _data$data$productCon3 !== void 0 ? _data$data$productCon3 : null;
    } catch (error) {
      console.error("Something went wrong while fetching the useSelectorExperiment value from Contentful");
      throw error;
    }
  }
  async getExperimentSelector(experimentContentId, locale, variation) {
    if (!experimentContentId || !locale || !variation) {
      throw new Error("No experiment id or locale or variation provided");
    }
    try {
      const {
        data
      } = await this.client.post("/", {
        query: getExperimentContentQuery(variation),
        variables: {
          experimentContentId,
          locale
        }
      });
      return data.data.experiment[variation].productSelector.id;
    } catch (error) {
      console.error("Something went wrong while fetching a size table from Contentful");
      throw error;
    }
  }
};
var contentfulClient = new ContentfulClient();

// src/http-clients/validationClient.ts
import axios3 from "axios";
import { configurationProvider as configurationProvider4 } from "@printdeal/configuration";
import { dequal as dequal3 } from "dequal";
import { authenticationHttpClient } from "@printdeal/authentication";
import { jwtDecode } from "jwt-decode";

// src/helpers/customQuantities.ts
var getAllPossibleQuantities = remainingQuantityOption => {
  const rangeValues = remainingQuantityOption.values.filter(value => value.type === "range");
  const quantities = rangeValues.reduce((allQuantities, rangeValue) => {
    const {
      minimum,
      maximum,
      increment
    } = rangeValue.range;
    if (!minimum || !maximum) return allQuantities;
    if (!increment) {
      return [...allQuantities, minimum];
    }
    const rangeQuantities = createNumberArrayFromRange(rangeValue.range);
    return [...allQuantities, ...rangeQuantities];
  }, []);
  const set = new Set(quantities);
  const quantitiesArray = [...set];
  quantitiesArray.sort((a, b) => a - b);
  return quantitiesArray;
};

// src/http-clients/validationClient.ts
var STORAGE_KEY = "anonCoamIdentity";
var anonymousCoamIdentity;
var isDecodedTokenExpired = decodedToken => {
  if (!decodedToken.exp) {
    return true;
  }
  return Boolean(decodedToken.exp <= Math.floor(( /* @__PURE__ */new Date()).getTime() / 1e3));
};
var createAnonymousCOAMIdentity = async identity => {
  const {
    data: {
      token: printdealAuthToken
    }
  } = await authenticationHttpClient.createToken();
  const {
    data
  } = await axios3.post("".concat(configurationProvider4.getValue("AUTH_LAYER_API_BASE_URL"), "/anon-coam-identity"), identity, {
    headers: {
      Authorization: printdealAuthToken
    }
  });
  return data;
};
var loadAnonymousCoamIdentity = () => {
  if (anonymousCoamIdentity) {
    return anonymousCoamIdentity;
  }
  const identityFromStorage = getFromLocalStorage(STORAGE_KEY);
  if (identityFromStorage) {
    return JSON.parse(identityFromStorage);
  }
  return void 0;
};
var getAnonymousCOAMToken = async () => {
  const storedIdentity = loadAnonymousCoamIdentity();
  if (storedIdentity && storedIdentity.anonymousToken) {
    const decodedToken = jwtDecode(storedIdentity.anonymousToken);
    if (!isDecodedTokenExpired(decodedToken)) {
      return storedIdentity.anonymousToken;
    }
  }
  anonymousCoamIdentity = await createAnonymousCOAMIdentity(storedIdentity);
  saveToLocalStorage(STORAGE_KEY, JSON.stringify(anonymousCoamIdentity));
  return anonymousCoamIdentity.anonymousToken;
};
async function authenticateHttpRequestInterceptor2(config) {
  const token = await getAnonymousCOAMToken();
  const updatedConfig = config;
  if (!updatedConfig.headers) {
    updatedConfig.headers = {};
  }
  updatedConfig.headers.Authorization = token;
  return updatedConfig;
}
var ValidationClient = class {
  constructor() {
    var _this = this;
    __publicField(this, "httpClient");
    __publicField(this, "validate", async function (productKey, selections, invalidSelections, customHeaders) {
      let isPimProduct = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      let productVersion = arguments.length > 5 ? arguments[5] : undefined;
      let country = arguments.length > 6 ? arguments[6] : undefined;
      const environment = configurationProvider4.getValue("PRODUCT_VALIDATION_ENV");
      const isPimVersionedProduct = isPimProduct && productVersion;
      const validationUrl = isPimVersionedProduct ? "/v2/products/".concat(productKey, "/versions/").concat(productVersion, ":validate") : "/v1/products/Printdeal_".concat(environment, "_").concat(productKey, ":validate");
      const data = await _this.client.post(validationUrl, _objectSpread({
        selections,
        invalidSelections,
        includeBuckets: ["option", "property"]
      }, isPimVersionedProduct && {
        context: {
          Country: country || "NL",
          Merchant: "Printdeal"
        },
        includeConstraintTypes: ["TEMPORARILY_UNAVAILABLE"]
      }), {
        headers: customHeaders || {}
      });
      if (data.data.state === "unresolvable" && isPimVersionedProduct) {
        const validationData = {
          result: data.data
        };
        logError(validationData, selections, "validate", {
          productKey,
          productVersion,
          country
        }, "Selection is Unresolvable", "validationClient.ts", "selector-v2-api-unresolvable");
      }
      return data;
    });
    __publicField(this, "validateSelection", async function (productKey, selections, groupAttributes, invalidSelections, customHeaders, group) {
      let isPimProduct = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      let productVersion = arguments.length > 7 ? arguments[7] : undefined;
      let country = arguments.length > 8 ? arguments[8] : undefined;
      const selection = _objectSpread({}, selections);
      Object.keys(invalidSelections).map(attributeName => delete selection[attributeName]);
      if (groupAttributes.length) {
        return Promise.all(groupAttributes.map(async groupAttribute => {
          const selectedGroup = group === null || group === void 0 ? void 0 : group.find(_ref88 => {
            let {
              attributes
            } = _ref88;
            return dequal3(attributes, groupAttribute);
          });
          const {
            data: data2
          } = await _this.validate(productKey, _objectSpread(_objectSpread(_objectSpread({}, selection), groupAttribute), {}, {
            Quantity: selectedGroup ? String(selectedGroup.quantity) : "1"
          }), invalidSelections, customHeaders, isPimProduct, productVersion, country);
          return {
            groupAttribute,
            result: data2
          };
        }));
      }
      const {
        data
      } = await _this.validate(productKey, selection, invalidSelections, customHeaders, isPimProduct, productVersion, country);
      return [{
        result: data
      }];
    });
    __publicField(this, "getCustomQuantities", async (productKey, attributes, prices, productMerchandisedQuantities) => {
      const printingProcesses = prices.map(_ref89 => {
        let {
          name
        } = _ref89;
        return {
          printingProcess: name
        };
      });
      const results = await Promise.all(printingProcesses.map(async _ref90 => {
        let {
          printingProcess
        } = _ref90;
        const selection = attributes.reduce((selectorSelection, attribute) => _objectSpread(_objectSpread({}, selectorSelection), {}, {
          [attribute.name]: attribute.value
        }, printingProcess && {
          "Printing Process": printingProcess
        }), {});
        const {
          data: validationResult
        } = await this.validate(productKey, selection, {});
        const remainingQuantityOption = validationResult.remainingOptions.find(_ref91 => {
          let {
            key,
            type
          } = _ref91;
          return key === "Quantity" && type === "numeric";
        });
        if (remainingQuantityOption) {
          const allQuantities = getAllPossibleQuantities(remainingQuantityOption);
          const generatedMerchandisedQuantities = prices.reduce((quantities2, price) => {
            const merchandised = price.quantities.map(_ref92 => {
              let {
                quantity
              } = _ref92;
              return quantity;
            });
            return [...quantities2, ...merchandised];
          }, []);
          const merchandisedQuantities = productMerchandisedQuantities && productMerchandisedQuantities.length > 0 ? productMerchandisedQuantities : generatedMerchandisedQuantities;
          const uniqueMerchandisedQuantities = new Set(merchandisedQuantities);
          const customQuantities = allQuantities.filter(quantity => !uniqueMerchandisedQuantities.has(quantity));
          const quantities = customQuantities.slice(0, 100);
          if (printingProcess) {
            return {
              [printingProcess]: quantities
            };
          }
          return {
            quantities
          };
        }
        return {};
      }));
      const filteredResults = results.filter(Boolean);
      return filteredResults.reduce((acc, result) => _objectSpread(_objectSpread({}, acc), result), {});
    });
  }
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider4.getValue("PRODUCT_VALIDATION_BASE_URL");
      this.httpClient = axios3.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor2);
    }
    return this.httpClient;
  }
};
var validationClient = new ValidationClient();

// src/helpers/groupAttributes.ts
import { configurationProvider as configurationProvider5 } from "@printdeal/configuration";
var getGroupAttributes = attributes => {
  const gridAttributes = attributes.find(attribute => Boolean(attribute.grid));
  if (!gridAttributes) {
    return [];
  }
  const {
    grid
  } = gridAttributes;
  const row = grid && grid.row;
  const column = grid && grid.column;
  const rowValues = (row === null || row === void 0 ? void 0 : row.values) || [];
  const columnValues = (column === null || column === void 0 ? void 0 : column.values) || [];
  if (!row || !column) {
    return [];
  }
  if (rowValues.length === 0 || columnValues.length === 0) {
    return [];
  }
  return rowValues.flatMap(rowValue => columnValues.map(columnValue => ({
    [row.name]: rowValue.name,
    [column.name]: columnValue.name
  })));
};
var getDefaultGroup = function (attributes, quantity, isUnprinted, remainingOptionsPerGroup) {
  var _row$values, _defaultGroup$filter;
  let fullGroup = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  let target = arguments.length > 5 ? arguments[5] : undefined;
  const gridAttributes = attributes.find(attribute => Boolean(attribute.grid));
  if (!gridAttributes) {
    return [];
  }
  const {
    grid
  } = gridAttributes;
  const row = grid && grid.row;
  const column = grid && grid.column;
  const maximum = isUnprinted ? 1 : getRangeMaximum(remainingOptionsPerGroup, "groupedQuantity");
  let printIndex = 0;
  const isImpressto = configurationProvider5.getValue("STORE_KEY") === "impressto-fr";
  const defaultGroup = row === null || row === void 0 || (_row$values = row.values) === null || _row$values === void 0 ? void 0 : _row$values.flatMap((rowValue, index) => {
    var _column$values;
    const needToAddDefaultLine = isUnprinted ? index < quantity : true;
    return needToAddDefaultLine ? column === null || column === void 0 || (_column$values = column.values) === null || _column$values === void 0 ? void 0 : _column$values.map(columnValue => {
      const valid = isGridCellValid({
        name: row.name,
        value: rowValue.name
      }, {
        name: column.name,
        value: columnValue.name
      }, remainingOptionsPerGroup);
      if (!valid) {
        return false;
      }
      if (fullGroup) {
        return {
          attributes: {
            [row.name]: rowValue.name,
            [column.name]: columnValue.name
          },
          quantity: isUnprinted ? 1 : quantity
        };
      }
      const remainingQuantity = quantity - (printIndex + 1) * maximum;
      const currentQuantity = remainingQuantity > 0 ? maximum : quantity - printIndex * maximum;
      printIndex += 1;
      return currentQuantity > 0 && {
        attributes: {
          [row.name]: rowValue.name,
          [column.name]: columnValue.name
        },
        quantity: isUnprinted ? 1 : currentQuantity
      };
    }) : [];
  }).filter(currentValue => currentValue !== false);
  const targetGroup = (_defaultGroup$filter = defaultGroup === null || defaultGroup === void 0 ? void 0 : defaultGroup.filter(group => {
    if (!group) return false;
    if (isImpressto && target && row !== null && row !== void 0 && row.name) {
      const groupAttribute = group.attributes[row.name];
      return groupAttribute === target;
    }
    return false;
  })) !== null && _defaultGroup$filter !== void 0 ? _defaultGroup$filter : [];
  const targetGroupSelection = targetGroup.length === 0 ? [defaultGroup === null || defaultGroup === void 0 ? void 0 : defaultGroup[0]] : [targetGroup[0]];
  return targetGroup.length === 0 && !target ? defaultGroup : targetGroupSelection;
};

// src/statemachines/actors/selectorActors.ts
var validateSelection = fromPromise(async _ref93 => {
  let {
    input
  } = _ref93;
  return validationClient.validateSelection(input.productKey, input.selection, input.groupAttributes, input.invalidSelection, {
    "x-filename": "selectorActors.ts"
  }, input.group, input.isPimProduct, input.productVersion, input.country);
});
var getServicePrices = fromPromise(async _ref94 => {
  let {
    input
  } = _ref94;
  return productClient.getServicesPrice({
    variableAttributes: Object.entries(input.selection).map(_ref95 => {
      let [name, value] = _ref95;
      return {
        name,
        value
      };
    }),
    customerGroupId: input.customerGroupId,
    serviceKeys: input.serviceKeys,
    productKey: input.productKey,
    country: input.countryCode,
    postalCode: input.postalCode
  });
});
var fetchPricing = fromPromise(async _ref96 => {
  let {
    input
  } = _ref96;
  const customProductQuantities = input.quantityList;
  const quantitySet = new Set(customProductQuantities.slice(0, MAX_CUSTOM_QUANTITIES));
  if (input.customQuantity) {
    quantitySet.add(input.customQuantity);
  }
  if (input.totalQuantity && input.totalQuantity !== input.customQuantity) {
    quantitySet.add(input.totalQuantity);
  }
  const allQuantities = Array.from(quantitySet);
  return productClient.fetchPricing({
    selection: input.selection,
    productKey: input.productKey,
    quantityList: allQuantities,
    version: input.version,
    country: input.country,
    postalCode: input.postalCode
  });
});
var fetchPivotPrices = fromPromise(async _ref97 => {
  let {
    input
  } = _ref97;
  return productClient.fetchPivotPrices({
    selection: input.selection,
    attributes: input.attributes,
    productKey: input.productKey,
    quantity: input.quantity,
    version: input.version,
    country: input.country,
    postalCode: input.postalCode,
    deliveryOptionId: input.deliveryOptionId
  });
});
var fetchDeliveryDates = fromPromise(async _ref98 => {
  let {
    input
  } = _ref98;
  return productClient.fetchDeliveryDates({
    selection: input.selection,
    quantity: input.quantity,
    country: input.country,
    version: input.version,
    productKey: input.productKey,
    postalCode: input.postalCode,
    groupSelection: input.groupSelection
  });
});
var getPrices = fromPromise(async _ref99 => {
  let {
    input
  } = _ref99;
  if (!input.shippingAddress) return Promise.reject(new Error("No shipping address found"));
  const priceGroups = getPriceGroups(input.group);
  const defaultGroup = getDefaultGroup(input.attributes, input.totalQuantity, !input.artworkRequired, input.remainingOptionsPerGroup);
  const groupQuantity = hasGroupedQuantity(input.attributes) && input.totalQuantity ? [input.totalQuantity] : [];
  const quantity = priceGroups.length > 0 || input.totalQuantity === 0 ? [] : groupQuantity;
  return productClient.getAllPrices(_objectSpread(_objectSpread({
    // selection and alternative prices
    variableAttributes: input.selection,
    customerGroupId: input.customerGroupId,
    quantity,
    productKey: input.productKey,
    mcpSku: input.mcpSku,
    address: input.shippingAddress,
    attributes: input.attributes,
    remainingOptions: input.remainingOptionsPerGroup
  }, priceGroups.length ? {
    group: priceGroups
  } : {
    group: getPriceGroups(defaultGroup)
  }), {}, {
    customHeaders: {
      "x-filename": "selectorActors.ts",
      "x-href": window.location.href
    }
  }));
});
var getArrivalDates = fromPromise(async _ref100 => {
  let {
    input
  } = _ref100;
  const deliveryType = input.attributes.find(attribute => attribute.name === "Delivery Type");
  const quantity = getResolvedAttributeFromGroup(input.remainingOptionsPerGroup, "Quantity");
  const value = quantity === null || quantity === void 0 ? void 0 : quantity.values[0];
  const isRange = (value === null || value === void 0 ? void 0 : value.type) === "range";
  const isStringLiteral = (value === null || value === void 0 ? void 0 : value.type) === "stringLiteral";
  const isNumberLiteral = (value === null || value === void 0 ? void 0 : value.type) === "numberLiteral";
  const totalQuantity = !input.totalQuantity && isRange && value.range.minimum || !input.totalQuantity && isStringLiteral && parseInt(value.stringLiteral, 10) || !input.totalQuantity && isNumberLiteral && parseInt(value.numberLiteral, 10) || input.totalQuantity;
  if (!input.shippingAddress || !deliveryType || !totalQuantity) {
    return Promise.reject(new Error("No shipping address, quantity or delivery type found"));
  }
  const isUnprinted = !input.artworkRequired;
  const defaultGroup = getDefaultGroup(input.attributes, input.totalQuantity, isUnprinted, input.remainingOptionsPerGroup);
  return productClient.getArrivalDates({
    quantity: totalQuantity,
    productKey: input.productKey,
    selection: input.selection,
    groupSelection: input.group.length > 0 ? input.group : defaultGroup,
    shippingAddress: input.shippingAddress,
    configurationAttribute: deliveryType,
    remainingOptionsPerGroup: input.remainingOptionsPerGroup,
    cutoffTime: input.merchantRules.cutofftime
  });
});
var getInventory = fromPromise(async _ref101 => {
  let {
    input
  } = _ref101;
  if (!input.shippingAddress || !input.totalQuantity) {
    return Promise.reject(new Error("No shipping address or quantity found"));
  }
  const defaultGroup = getDefaultGroup(input.attributes, getRangeMaximum(input.remainingOptionsPerGroup, "groupedQuantity"), !input.artworkRequired, input.remainingOptionsPerGroup, true);
  return productClient.getInventory({
    quantity: input.totalQuantity,
    productKey: input.productKey,
    selection: input.selection,
    group: getPriceGroups(defaultGroup),
    shippingAddress: input.shippingAddress
  });
});
var getMerchantRules = fromPromise(async _ref102 => {
  let {
    input
  } = _ref102;
  return productClient.getMerchantRules(input.productKey, formatAttributes2(input.selection));
});
var convertProduct = fromPromise(async _ref103 => {
  let {
    input
  } = _ref103;
  return productClient.convertProduct(input.productKey, input.selection);
});

// src/statemachines/selector/selector.machine.ts
var initialContext = {
  attributes: [],
  selection: {},
  attributesCount: 0,
  productKey: "",
  serviceKeys: [],
  selectedService: void 0,
  mcpSku: "",
  prices: [],
  pivotPrices: {},
  servicePrices: void 0,
  alternativePrices: [],
  pricesPerQuantity: [],
  group: [],
  groupAttributes: [],
  customerGroupId: "",
  invalidSelection: {},
  remainingOptionsPerGroup: [],
  priceAttributes: {},
  totalQuantity: 0,
  arrivalDates: [],
  selectedDeliveryOption: {
    name: "Normal"
  },
  panel: {
    openPanel: false,
    showMessage: false,
    panelName: ""
  },
  touchedAttributes: [],
  device: "mobile",
  merchantRules: {
    deliveryTool: {}
  },
  productAttributes: [],
  artworkRequired: true,
  isReviewPage: false,
  selectionMode: "default-values",
  inventory: [],
  isExp1574: false,
  product: void 0,
  deliveryDates: [],
  productRouteClicked: false
};
var selectorMachine = setup({
  types: {
    context: {},
    events: {}
  },
  actors: {
    validateSelection,
    getServicePrices,
    getMerchantRules,
    getPrices,
    getArrivalDates,
    getInventory,
    convertProduct
  },
  actions: {},
  guards: {
    shouldValidate: _ref104 => {
      let {
        event
      } = _ref104;
      assertEvent(event, "Select attribute value");
      return event.shouldValidate;
    },
    shouldNotValidate: _ref105 => {
      let {
        event
      } = _ref105;
      assertEvent(event, "Select attribute value");
      return !event.shouldValidate;
    },
    isSelectionInvalid: _ref106 => {
      let {
        context,
        event
      } = _ref106;
      assertEvent(event, "Select attribute value");
      return isSelectionInvalid({
        context,
        event
      });
    },
    isConfigurationInvalid,
    isUnresolvable,
    canPreselectAttribute,
    canUnset,
    cannotUnset,
    areAllRequiredAttributesSelected,
    shouldFetchServicePrices,
    insufficientInventory,
    hasInsufficientInventoryWithoutGroup,
    isExp1574: _ref107 => {
      let {
        context
      } = _ref107;
      return Boolean(context.isExp1574);
    },
    isStepByStep
  }
}).createMachine({
  context: initialContext,
  id: "SelectorMachine",
  initial: "WAITING TO START",
  states: {
    "WAITING TO START": {
      on: {
        "Start machine": {
          actions: [assign(_ref108 => {
            let {
              event
            } = _ref108;
            return initializeContext({
              event
            });
          })],
          target: "STARTING"
        }
      }
    },
    STARTING: {
      always: {
        target: "STARTED"
      }
    },
    STARTED: {
      initial: "VALIDATING",
      states: {
        VALIDATING: {
          invoke: {
            src: "validateSelection",
            input: _ref109 => {
              var _context$product2, _context$product3;
              let {
                context
              } = _ref109;
              return {
                productKey: context.productKey,
                selection: context.selection,
                group: context.group,
                invalidSelection: context.invalidSelection,
                groupAttributes: context.groupAttributes,
                isPimProduct: Boolean((_context$product2 = context.product) === null || _context$product2 === void 0 ? void 0 : _context$product2.isPimProduct),
                productVersion: (_context$product3 = context.product) === null || _context$product3 === void 0 ? void 0 : _context$product3.productVersion
              };
            },
            onDone: [{
              actions: [_ref110 => {
                let {
                  context,
                  event
                } = _ref110;
                return logError(event.output, context.selection, "getAttributeConfiguration");
              }, assign(() => ({
                error: "ConfigurationError"
              }))],
              guard: "isConfigurationInvalid",
              target: "ERRORING"
            }, {
              guard: "isExp1574",
              target: "EXP1574 FETCH REMAINING OPTIONS"
            }, {
              guard: {
                type: "isUnresolvable",
                params: _ref111 => {
                  let {
                    event
                  } = _ref111;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [_ref112 => {
                let {
                  context,
                  event
                } = _ref112;
                return logViolationError({
                  context,
                  event
                });
              }, assign(() => ({
                error: "UnresolvedValidationError"
              }))],
              target: "ERRORING"
            }, {
              guard: {
                type: "canPreselectAttribute",
                params: _ref113 => {
                  let {
                    event
                  } = _ref113;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [assign(_ref114 => {
                let {
                  context,
                  event
                } = _ref114;
                return preselectAttribute({
                  context,
                  event
                });
              })],
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [assign(_ref115 => {
                let {
                  context,
                  event
                } = _ref115;
                return unsetAttribute({
                  context,
                  event
                });
              })],
              guard: {
                type: "canUnset",
                params: _ref116 => {
                  let {
                    event
                  } = _ref116;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [_ref117 => {
                let {
                  context,
                  event
                } = _ref117;
                return logViolationError({
                  context,
                  event
                });
              }, assign(() => ({
                error: "UnresolvedValidationError"
              }))],
              guard: {
                type: "cannotUnset",
                params: _ref118 => {
                  let {
                    event
                  } = _ref118;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "ERRORING"
            }, {
              guard: "isStepByStep",
              actions: [assign(_ref119 => {
                let {
                  context,
                  event
                } = _ref119;
                return storeRemainingOptions({
                  context,
                  event
                });
              })],
              target: "STEP BY STEP IDLE"
            }, {
              actions: [assign(_ref120 => {
                let {
                  context,
                  event
                } = _ref120;
                return storeRemainingOptions({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }],
            onError: [{
              actions: [_ref121 => {
                let {
                  context,
                  event
                } = _ref121;
                return logError(event, context.selection, "validateSelection");
              }, assign(() => ({
                error: "UnknownValidationError"
              }))],
              target: "ERRORING"
            }]
          }
        },
        "WAIT FOR USER CONFIRMATION": {
          on: {
            "Select attribute value": [{
              guard: "shouldValidate",
              actions: [assign(_ref122 => {
                let {
                  context,
                  event
                } = _ref122;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref123 => {
                let {
                  context,
                  event
                } = _ref123;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }],
            "Cancel unset": [{
              guard: "isStepByStep",
              target: "STEP BY STEP IDLE"
            }, {
              target: "VALIDATING"
            }]
          }
        },
        "STEP BY STEP IDLE": {
          always: {
            guard: "areAllRequiredAttributesSelected",
            target: "FETCHING MERCHANT RULES"
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref124 => {
                let {
                  event
                } = _ref124;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref125 => {
                let {
                  context,
                  event
                } = _ref125;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        },
        "SELECTION COMPLETE": {
          always: {
            guard: "shouldFetchServicePrices",
            target: "FETCHING SERVICE PRICES"
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref126 => {
                let {
                  event
                } = _ref126;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref127 => {
                let {
                  context,
                  event
                } = _ref127;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref128 => {
                let {
                  context,
                  event
                } = _ref128;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }]
          }
        },
        "FETCHING SERVICE PRICES": {
          exit: assign(() => ({
            serviceError: void 0
          })),
          invoke: {
            src: "getServicePrices",
            input: _ref129 => {
              var _context$shippingAddr, _context$shippingAddr2;
              let {
                context
              } = _ref129;
              return {
                productKey: context.productKey,
                selection: context.selection,
                customerGroupId: context.customerGroupId || "",
                serviceKeys: context.serviceKeys,
                countryCode: ((_context$shippingAddr = context.shippingAddress) === null || _context$shippingAddr === void 0 ? void 0 : _context$shippingAddr.CountryCode) || "",
                postalCode: ((_context$shippingAddr2 = context.shippingAddress) === null || _context$shippingAddr2 === void 0 ? void 0 : _context$shippingAddr2.PostalCode) || ""
              };
            },
            onDone: [{
              actions: [assign(_ref130 => {
                let {
                  event
                } = _ref130;
                return {
                  servicePrices: event.output
                };
              })],
              target: "SELECTION COMPLETE"
            }],
            onError: [{
              actions: [_ref131 => {
                let {
                  context,
                  event
                } = _ref131;
                return logError(event, context.selection, "getServicePrices", {
                  serviceKeys: context.serviceKeys
                });
              }, assign(() => ({
                servicePrices: void 0
              })), assign(() => ({
                serviceError: "ServicePricingError"
              }))],
              target: "SELECTION COMPLETE"
            }]
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref132 => {
                let {
                  event
                } = _ref132;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref133 => {
                let {
                  context,
                  event
                } = _ref133;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        },
        ERRORING: {
          exit: assign(() => ({
            error: void 0
          })),
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref134 => {
                let {
                  event
                } = _ref134;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref135 => {
                let {
                  context,
                  event
                } = _ref135;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref136 => {
                let {
                  context,
                  event
                } = _ref136;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "FETCHING MERCHANT RULES"
            }]
          }
        },
        "EXP1574 FETCH REMAINING OPTIONS": {
          invoke: {
            src: "validateSelection",
            input: _ref137 => {
              var _context$product4;
              let {
                context
              } = _ref137;
              const exp1574Selection = _objectSpread({}, context.selection);
              delete exp1574Selection["Printing Colors"];
              delete exp1574Selection["Printing Process"];
              return {
                productKey: context.productKey,
                selection: exp1574Selection,
                group: context.group,
                invalidSelection: context.invalidSelection,
                groupAttributes: context.groupAttributes,
                isPimProduct: Boolean((_context$product4 = context.product) === null || _context$product4 === void 0 ? void 0 : _context$product4.isPimProduct)
              };
            },
            onDone: [{
              actions: [assign(_ref138 => {
                let {
                  context,
                  event
                } = _ref138;
                return updateSelectionAndRemainingOptions({
                  context,
                  event
                });
              })],
              target: "EXP1574 FETCH REQUIRED ATTRIBUTES"
            }],
            onError: [{
              actions: [_ref139 => {
                let {
                  context,
                  event
                } = _ref139;
                return logError(event, context.selection, "exp1574-validateSelection");
              }, assign(() => ({
                error: "Exp1574GetRemainingOptionsPerGroupError"
              }))],
              target: "ERRORING"
            }]
          }
        },
        "EXP1574 FETCH REQUIRED ATTRIBUTES": {
          invoke: {
            src: "convertProduct",
            input: _ref140 => {
              let {
                context
              } = _ref140;
              const exp1574Selection = _objectSpread({}, context.selection);
              delete exp1574Selection["Printing Process"];
              return {
                productKey: context.productKey,
                selection: exp1574Selection
              };
            },
            onDone: [{
              actions: [assign(_ref141 => {
                let {
                  context,
                  event
                } = _ref141;
                return {
                  selection: _objectSpread(_objectSpread({}, context.selection), {}, {
                    "Printing Process": event.output.attributes["Printing Process"]
                  })
                };
              })],
              target: "FETCHING MERCHANT RULES"
            }],
            onError: [{
              actions: [_ref142 => {
                let {
                  context,
                  event
                } = _ref142;
                return logError(event, context.selection, "exp1574-convertProduct");
              }],
              target: "ERRORING"
            }]
          }
        },
        "FETCHING MERCHANT RULES": {
          invoke: {
            src: "getMerchantRules",
            input: _ref143 => {
              let {
                context
              } = _ref143;
              return {
                productKey: context.productKey,
                selection: context.selection
              };
            },
            onDone: [{
              guard: "isStepByStep",
              actions: [assign(_ref144 => {
                let {
                  event
                } = _ref144;
                return {
                  merchantRules: event.output
                };
              })],
              target: "SELECTION COMPLETE"
            }, {
              actions: [assign(_ref145 => {
                let {
                  event
                } = _ref145;
                return {
                  merchantRules: event.output
                };
              })],
              target: "FETCHING DATA"
            }],
            onError: [{
              actions: [_ref146 => {
                let {
                  context,
                  event
                } = _ref146;
                return logError(event, context.selection, "getMerchantRules");
              }, assign(() => ({
                error: "MerchantRulesError"
              }))],
              target: "ERRORING"
            }]
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref147 => {
                let {
                  event
                } = _ref147;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref148 => {
                let {
                  context,
                  event
                } = _ref148;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref149 => {
                let {
                  context,
                  event
                } = _ref149;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        },
        "FETCHING DATA": {
          type: "parallel",
          states: {
            PRICES: {
              initial: "FETCHING PRICES",
              states: {
                "FETCHING PRICES": {
                  invoke: {
                    src: "getPrices",
                    input: _ref150 => {
                      let {
                        context
                      } = _ref150;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        attributes: context.attributes,
                        totalQuantity: context.totalQuantity,
                        shippingAddress: context.shippingAddress,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        customerGroupId: context.customerGroupId,
                        mcpSku: context.mcpSku,
                        artworkRequired: context.artworkRequired,
                        group: context.group
                      };
                    },
                    onDone: [{
                      actions: [assign(_ref151 => {
                        let {
                          context,
                          event
                        } = _ref151;
                        return storePrices({
                          context,
                          event
                        });
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref152 => {
                        let {
                          context,
                          event
                        } = _ref152;
                        return logError(event, context.selection, "getPrices", {
                          selectedService: context.selectedService
                        });
                      }, assign(() => ({
                        error: "PricingError"
                      })), assign(() => ({
                        prices: [],
                        price: void 0,
                        alternativePrices: []
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                IDLE: {},
                ERRORING: {}
              }
            },
            "SERVICE PRICES": {
              initial: "STARTING",
              states: {
                STARTING: {
                  always: [{
                    guard: "shouldFetchServicePrices",
                    target: "FETCHING SERVICE PRICES"
                  }, {
                    target: "IDLE"
                  }]
                },
                "FETCHING SERVICE PRICES": {
                  exit: assign(() => ({
                    serviceError: void 0
                  })),
                  invoke: {
                    src: "getServicePrices",
                    input: _ref153 => {
                      var _context$shippingAddr3, _context$shippingAddr4;
                      let {
                        context
                      } = _ref153;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        customerGroupId: context.customerGroupId || "",
                        serviceKeys: context.serviceKeys,
                        countryCode: ((_context$shippingAddr3 = context.shippingAddress) === null || _context$shippingAddr3 === void 0 ? void 0 : _context$shippingAddr3.CountryCode) || "",
                        postalCode: ((_context$shippingAddr4 = context.shippingAddress) === null || _context$shippingAddr4 === void 0 ? void 0 : _context$shippingAddr4.PostalCode) || ""
                      };
                    },
                    onDone: [{
                      actions: [assign(_ref154 => {
                        let {
                          event
                        } = _ref154;
                        return {
                          servicePrices: event.output
                        };
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref155 => {
                        let {
                          context,
                          event
                        } = _ref155;
                        return logError(event, context.selection, "getServicePrices", {
                          serviceKeys: context.serviceKeys
                        });
                      }, assign(() => ({
                        servicePrices: void 0
                      })), assign(() => ({
                        serviceError: "ServicePricingError"
                      }))],
                      target: "IDLE"
                    }]
                  }
                },
                IDLE: {},
                ERRORING: {}
              }
            },
            "ARRIVAL DATES": {
              initial: "FETCHING ARRIVAL DATES",
              states: {
                IDLE: {},
                "FETCHING ARRIVAL DATES": {
                  invoke: {
                    src: "getArrivalDates",
                    input: _ref156 => {
                      let {
                        context
                      } = _ref156;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        customerGroupId: context.customerGroupId || "",
                        group: context.group,
                        totalQuantity: context.totalQuantity,
                        artworkRequired: context.artworkRequired,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        shippingAddress: context.shippingAddress,
                        attributes: context.attributes,
                        mcpSku: context.mcpSku,
                        merchantRules: context.merchantRules
                      };
                    },
                    onDone: [{
                      guard: {
                        type: "hasInsufficientInventoryWithoutGroup",
                        params: _ref157 => {
                          let {
                            event
                          } = _ref157;
                          return {
                            arrivalDates: event.output
                          };
                        }
                      },
                      actions: [assign(() => ({
                        panel: {
                          panelName: "Delivery Type",
                          openPanel: false,
                          showMessage: true,
                          variant: "warning",
                          message: translations.missingDeliveryType
                        },
                        arrivalDates: []
                      }))],
                      target: "IDLE"
                    }, {
                      guard: {
                        type: "insufficientInventory",
                        params: _ref158 => {
                          let {
                            event
                          } = _ref158;
                          return {
                            arrivalDates: event.output
                          };
                        }
                      },
                      target: "INSUFFICIENT INVENTORY"
                    }, {
                      actions: [assign(_ref159 => {
                        let {
                          event
                        } = _ref159;
                        return {
                          arrivalDates: event.output,
                          panel: {
                            openPanel: false,
                            showMessage: false,
                            panelName: ""
                          }
                          // remove missing delivery date message if it was shown
                        };
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref160 => {
                        let {
                          context,
                          event
                        } = _ref160;
                        return logError(event, context.selection, "getArrivalDates");
                      }, assign(() => ({
                        error: "ArrivalDateError"
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                ERRORING: {},
                "INSUFFICIENT INVENTORY": {}
              }
            },
            INVENTORY: {
              initial: "FETCHING INVENTORY",
              states: {
                IDLE: {},
                "FETCHING INVENTORY": {
                  invoke: {
                    src: "getInventory",
                    input: _ref161 => {
                      let {
                        context
                      } = _ref161;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        totalQuantity: context.totalQuantity,
                        artworkRequired: context.artworkRequired,
                        remainingOptionsPerGroup: context.remainingOptionsPerGroup,
                        shippingAddress: context.shippingAddress,
                        attributes: context.attributes
                      };
                    },
                    onDone: [{
                      actions: [assign(_ref162 => {
                        let {
                          event
                        } = _ref162;
                        return {
                          inventory: event.output
                        };
                      })],
                      target: "IDLE"
                    }],
                    onError: [{
                      actions: [_ref163 => {
                        let {
                          context,
                          event
                        } = _ref163;
                        return logError(event, context.selection, "getInventory", {
                          group: JSON.stringify(context.group)
                        });
                      }, assign(() => ({
                        error: "InventoryError"
                      }))],
                      target: "IDLE"
                    }]
                  }
                }
              }
            }
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign(_ref164 => {
                let {
                  event
                } = _ref164;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign(_ref165 => {
                let {
                  context,
                  event
                } = _ref165;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign(_ref166 => {
                let {
                  context,
                  event
                } = _ref166;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        }
      },
      on: {
        Exp1574: {
          actions: [assign(_ref167 => {
            let {
              event
            } = _ref167;
            return {
              isExp1574: event.isExp1574
            };
          })]
        },
        "Reset machine": {
          actions: [assign(_ref168 => {
            let {
              context,
              event
            } = _ref168;
            return restoreDefaults({
              context,
              event
            });
          })],
          target: "STARTING"
        },
        "Select product route": {
          actions: [assign(_ref169 => {
            let {
              event
            } = _ref169;
            return replaceSelection({
              event
            });
          })],
          target: "STARTING"
        },
        "Select service": {
          actions: [assign(_ref170 => {
            let {
              context,
              event
            } = _ref170;
            return selectService({
              context,
              event
            });
          })]
        },
        "Set device": {
          actions: [assign(_ref171 => {
            let {
              event
            } = _ref171;
            return {
              device: event.device
            };
          })]
        },
        "Toggle panel": {
          actions: [assign(_ref172 => {
            let {
              context,
              event
            } = _ref172;
            return togglePanel({
              context,
              event
            });
          })]
        },
        "Set price": {
          actions: [assign(_ref173 => {
            let {
              context,
              event
            } = _ref173;
            return setPrice({
              context,
              event
            });
          })]
        }
      }
    }
  }
});

// src/statemachines/selector/productSelector.machine.ts
import { assertEvent as assertEvent2, assign as assign2, setup as setup2 } from "xstate";
var initialContext2 = {
  attributes: [],
  selection: {},
  attributesCount: 0,
  productKey: "",
  serviceKeys: [],
  selectedService: void 0,
  mcpSku: "",
  prices: [],
  pivotPrices: {},
  servicePrices: void 0,
  alternativePrices: [],
  pricesPerQuantity: [],
  group: [],
  groupAttributes: [],
  customerGroupId: "",
  invalidSelection: {},
  remainingOptionsPerGroup: [],
  priceAttributes: {},
  totalQuantity: 0,
  selectedDeliveryOption: {
    name: "Normal"
  },
  arrivalDates: [],
  panel: {
    openPanel: false,
    showMessage: false,
    panelName: ""
  },
  touchedAttributes: [],
  device: "mobile",
  merchantRules: {
    deliveryTool: {}
  },
  productAttributes: [],
  artworkRequired: true,
  isReviewPage: false,
  selectionMode: "default-values",
  product: void 0,
  deliveryDates: [{
    name: "Normal"
  }]
};
var DEFAULT_DELIVERY_OPTION_ID = "d839b87f-3c85-4cf6-8cec-eed34707cea2";
var productSelectorMachine = setup2({
  types: {
    context: {},
    events: {}
  },
  actors: {
    validateSelection,
    getServicePrices,
    fetchPricing,
    fetchPivotPrices,
    fetchDeliveryDates,
    getMerchantRules
  },
  actions: {},
  guards: {
    shouldValidate: _ref174 => {
      let {
        event
      } = _ref174;
      assertEvent2(event, "Select attribute value");
      return event.shouldValidate;
    },
    shouldNotValidate: _ref175 => {
      let {
        event
      } = _ref175;
      assertEvent2(event, "Select attribute value");
      return !event.shouldValidate;
    },
    isSelectionInvalid: _ref176 => {
      let {
        context,
        event
      } = _ref176;
      assertEvent2(event, "Select attribute value");
      return isSelectionInvalid({
        context,
        event
      });
    },
    isConfigurationInvalid,
    isStepByStep,
    isUnresolvable,
    canPreselectAttribute,
    canUnset,
    cannotUnset,
    areAllRequiredAttributesSelected,
    shouldFetchServicePrices
  }
}).createMachine({
  context: initialContext2,
  id: "SelectorMachine",
  initial: "WAITING TO START",
  states: {
    "WAITING TO START": {
      on: {
        "Start machine": {
          actions: [assign2(_ref177 => {
            let {
              event
            } = _ref177;
            return initializeContext({
              event
            });
          })],
          target: "STARTING"
        }
      }
    },
    STARTING: {
      always: {
        target: "STARTED"
      }
    },
    STARTED: {
      initial: "VALIDATING",
      states: {
        VALIDATING: {
          invoke: {
            src: "validateSelection",
            input: _ref178 => {
              var _context$product5, _context$product6, _context$shippingAddr5;
              let {
                context
              } = _ref178;
              return {
                productKey: context.productKey,
                selection: context.selection,
                group: context.group,
                invalidSelection: context.invalidSelection,
                groupAttributes: context.groupAttributes,
                isPimProduct: Boolean((_context$product5 = context.product) === null || _context$product5 === void 0 ? void 0 : _context$product5.isPimProduct),
                productVersion: (_context$product6 = context.product) === null || _context$product6 === void 0 ? void 0 : _context$product6.productVersion,
                country: ((_context$shippingAddr5 = context.shippingAddress) === null || _context$shippingAddr5 === void 0 ? void 0 : _context$shippingAddr5.CountryCode) || "NL"
              };
            },
            onDone: [{
              actions: [_ref179 => {
                let {
                  context,
                  event
                } = _ref179;
                return logError(event.output, context.selection, "getAttributeConfiguration");
              }, assign2(() => ({
                error: "ConfigurationError"
              }))],
              guard: "isConfigurationInvalid",
              target: "ERRORING"
            }, {
              guard: {
                type: "isUnresolvable",
                params: _ref180 => {
                  let {
                    event
                  } = _ref180;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [_ref181 => {
                let {
                  context,
                  event
                } = _ref181;
                return logViolationError({
                  context,
                  event
                });
              }, assign2(() => ({
                error: "UnresolvedValidationError"
              }))],
              target: "ERRORING"
            }, {
              guard: {
                type: "canPreselectAttribute",
                params: _ref182 => {
                  let {
                    event
                  } = _ref182;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              actions: [assign2(_ref183 => {
                let {
                  context,
                  event
                } = _ref183;
                return preselectAttribute({
                  context,
                  event
                });
              })],
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [assign2(_ref184 => {
                let {
                  context,
                  event
                } = _ref184;
                return unsetAttribute({
                  context,
                  event
                });
              })],
              guard: {
                type: "canUnset",
                params: _ref185 => {
                  let {
                    event
                  } = _ref185;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "VALIDATING",
              reenter: true
            }, {
              actions: [_ref186 => {
                let {
                  context,
                  event
                } = _ref186;
                return logViolationError({
                  context,
                  event
                });
              }, assign2(() => ({
                error: "UnresolvedValidationError"
              }))],
              guard: {
                type: "cannotUnset",
                params: _ref187 => {
                  let {
                    event
                  } = _ref187;
                  return {
                    groupValidationResult: event.output
                  };
                }
              },
              target: "ERRORING"
            }, {
              actions: [assign2(_ref188 => {
                let {
                  context,
                  event
                } = _ref188;
                return storeRemainingOptions({
                  context,
                  event
                });
              })],
              target: "IDLE"
            }],
            onError: [{
              actions: [_ref189 => {
                let {
                  context,
                  event
                } = _ref189;
                return logError(event, context.selection, "validateSelection");
              }, assign2(() => ({
                error: "UnknownValidationError"
              }))],
              target: "ERRORING"
            }]
          }
        },
        IDLE: {
          always: {
            guard: "areAllRequiredAttributesSelected",
            target: "FETCHING DATA"
          },
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref190 => {
                let {
                  event
                } = _ref190;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref191 => {
                let {
                  context,
                  event
                } = _ref191;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        },
        "SELECTION COMPLETE": {
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref192 => {
                let {
                  event
                } = _ref192;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref193 => {
                let {
                  context,
                  event
                } = _ref193;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign2(_ref194 => {
                let {
                  context,
                  event
                } = _ref194;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        },
        "FETCHING DATA": {
          type: "parallel",
          states: {
            PRICES: {
              initial: "FETCHING PRICES",
              states: {
                "FETCHING PRICES": {
                  invoke: {
                    src: "fetchPricing",
                    input: _ref195 => {
                      var _context$product7, _context$product8, _context$shippingAddr6, _context$shippingAddr7;
                      let {
                        context
                      } = _ref195;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        quantityList: ((_context$product7 = context.product) === null || _context$product7 === void 0 ? void 0 : _context$product7.customProductQuantities) || [],
                        version: Number((_context$product8 = context.product) === null || _context$product8 === void 0 ? void 0 : _context$product8.productVersion),
                        country: ((_context$shippingAddr6 = context.shippingAddress) === null || _context$shippingAddr6 === void 0 ? void 0 : _context$shippingAddr6.CountryCode) || "",
                        postalCode: ((_context$shippingAddr7 = context.shippingAddress) === null || _context$shippingAddr7 === void 0 ? void 0 : _context$shippingAddr7.PostalCode) || "",
                        attributes: context.attributes,
                        totalQuantity: context.totalQuantity,
                        customQuantity: context.customQuantity || 0
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref196 => {
                        let {
                          context,
                          event
                        } = _ref196;
                        return storePricing({
                          context,
                          event
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref197 => {
                        let {
                          context,
                          event
                        } = _ref197;
                        return logError(event, context.selection, "pricing", {
                          selectedService: context.selectedService
                        });
                      }, assign2(() => ({
                        error: "PricingError"
                      })), assign2(() => ({
                        prices: [],
                        price: void 0
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            "MERCHANT RULES": {
              initial: "FETCHING MERCHANT RULES",
              states: {
                "FETCHING MERCHANT RULES": {
                  invoke: {
                    src: "getMerchantRules",
                    input: _ref198 => {
                      let {
                        context
                      } = _ref198;
                      return {
                        productKey: context.productKey,
                        selection: context.selection
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref199 => {
                        let {
                          event
                        } = _ref199;
                        return {
                          merchantRules: event.output
                        };
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref200 => {
                        let {
                          context,
                          event
                        } = _ref200;
                        return logError(event, context.selection, "getMerchantRules");
                      }, assign2(() => ({
                        error: "MerchantRulesError"
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            "PIVOT PRICES": {
              initial: "START",
              states: {
                START: {
                  always: [{
                    guard: "isStepByStep",
                    target: "DONE"
                  }, {
                    target: "FETCHING PIVOT PRICES"
                  }]
                },
                "FETCHING PIVOT PRICES": {
                  invoke: {
                    src: "fetchPivotPrices",
                    input: _ref201 => {
                      var _context$product9, _context$product10, _context$shippingAddr8, _context$shippingAddr9;
                      let {
                        context
                      } = _ref201;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        quantity: context.totalQuantity || ((_context$product9 = context.product) === null || _context$product9 === void 0 || (_context$product9 = _context$product9.customProductQuantities) === null || _context$product9 === void 0 ? void 0 : _context$product9[0]) || 1,
                        version: Number((_context$product10 = context.product) === null || _context$product10 === void 0 ? void 0 : _context$product10.productVersion),
                        country: ((_context$shippingAddr8 = context.shippingAddress) === null || _context$shippingAddr8 === void 0 ? void 0 : _context$shippingAddr8.CountryCode) || "",
                        postalCode: ((_context$shippingAddr9 = context.shippingAddress) === null || _context$shippingAddr9 === void 0 ? void 0 : _context$shippingAddr9.PostalCode) || "",
                        attributes: context.attributes,
                        deliveryOptionId: context.selectedDeliveryOption.id || DEFAULT_DELIVERY_OPTION_ID
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref202 => {
                        let {
                          event
                        } = _ref202;
                        return storePivotPrices({
                          event
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref203 => {
                        let {
                          context,
                          event
                        } = _ref203;
                        return logError(event, context.selection, "pivotPrices");
                      }, assign2(() => ({
                        error: "PivotPricesError"
                      })), assign2(() => ({
                        pivotPrices: {}
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {
                  type: "final"
                }
              }
            },
            "SERVICE PRICES": {
              initial: "STARTING",
              states: {
                STARTING: {
                  always: [{
                    guard: "shouldFetchServicePrices",
                    target: "FETCHING SERVICE PRICES"
                  }, {
                    target: "DONE"
                  }]
                },
                "FETCHING SERVICE PRICES": {
                  exit: assign2(() => ({
                    serviceError: void 0
                  })),
                  invoke: {
                    src: "getServicePrices",
                    input: _ref204 => {
                      var _context$shippingAddr10, _context$shippingAddr11;
                      let {
                        context
                      } = _ref204;
                      return {
                        productKey: context.productKey,
                        selection: context.selection,
                        customerGroupId: context.customerGroupId || "",
                        serviceKeys: context.serviceKeys,
                        countryCode: ((_context$shippingAddr10 = context.shippingAddress) === null || _context$shippingAddr10 === void 0 ? void 0 : _context$shippingAddr10.CountryCode) || "",
                        postalCode: ((_context$shippingAddr11 = context.shippingAddress) === null || _context$shippingAddr11 === void 0 ? void 0 : _context$shippingAddr11.PostalCode) || ""
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref205 => {
                        let {
                          event
                        } = _ref205;
                        return {
                          servicePrices: event.output
                        };
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref206 => {
                        let {
                          context,
                          event
                        } = _ref206;
                        return logError(event, context.selection, "getServicePrices", {
                          serviceKeys: context.serviceKeys
                        });
                      }, assign2(() => ({
                        servicePrices: void 0
                      })), assign2(() => ({
                        serviceError: "ServicePricingError"
                      }))],
                      target: "DONE"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            },
            "FETCH DELIVERY DATES": {
              initial: "FETCHING DELIVERY DATES",
              states: {
                "FETCHING DELIVERY DATES": {
                  invoke: {
                    src: "fetchDeliveryDates",
                    input: _ref207 => {
                      var _context$product11, _context$shippingAddr12, _context$product12, _context$shippingAddr13;
                      let {
                        context
                      } = _ref207;
                      return {
                        selection: context.selection,
                        quantity: context.totalQuantity || ((_context$product11 = context.product) === null || _context$product11 === void 0 || (_context$product11 = _context$product11.customProductQuantities) === null || _context$product11 === void 0 ? void 0 : _context$product11[0]) || 1,
                        country: ((_context$shippingAddr12 = context.shippingAddress) === null || _context$shippingAddr12 === void 0 ? void 0 : _context$shippingAddr12.CountryCode) || "",
                        version: Number((_context$product12 = context.product) === null || _context$product12 === void 0 ? void 0 : _context$product12.productVersion),
                        productKey: context.productKey,
                        postalCode: ((_context$shippingAddr13 = context.shippingAddress) === null || _context$shippingAddr13 === void 0 ? void 0 : _context$shippingAddr13.PostalCode) || "",
                        groupSelection: context.group
                      };
                    },
                    onDone: [{
                      actions: [assign2(_ref208 => {
                        let {
                          context,
                          event
                        } = _ref208;
                        return storeDeliveryDates({
                          context,
                          event
                        });
                      })],
                      target: "DONE"
                    }],
                    onError: [{
                      actions: [_ref209 => {
                        let {
                          context,
                          event
                        } = _ref209;
                        return logError(event, context.selection, "deliveryDates");
                      }, assign2(() => ({
                        error: "DeliveryDateError"
                      }))],
                      target: "ERRORING"
                    }]
                  }
                },
                DONE: {
                  type: "final"
                },
                ERRORING: {}
              }
            }
          },
          onDone: "SELECTION COMPLETE",
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref210 => {
                let {
                  event
                } = _ref210;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref211 => {
                let {
                  context,
                  event
                } = _ref211;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }, {
              guard: "shouldNotValidate",
              actions: [assign2(_ref212 => {
                let {
                  context,
                  event
                } = _ref212;
                return updateSelection({
                  context,
                  event
                });
              })]
            }]
          }
        },
        "WAIT FOR USER CONFIRMATION": {
          on: {
            "Select attribute value": [{
              guard: "shouldValidate",
              actions: [assign2(_ref213 => {
                let {
                  context,
                  event
                } = _ref213;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }],
            "Cancel unset": [{
              target: "IDLE"
            }]
          }
        },
        ERRORING: {
          exit: assign2(() => ({
            error: void 0
          })),
          on: {
            "Select attribute value": [{
              guard: "isSelectionInvalid",
              actions: [assign2(_ref214 => {
                let {
                  event
                } = _ref214;
                return storeInvalidSelection({
                  event
                });
              })],
              target: "WAIT FOR USER CONFIRMATION"
            }, {
              guard: "shouldValidate",
              actions: [assign2(_ref215 => {
                let {
                  context,
                  event
                } = _ref215;
                return updateSelection({
                  context,
                  event
                });
              })],
              target: "VALIDATING"
            }]
          }
        }
      },
      on: {
        "Reset machine": {
          actions: [assign2(_ref216 => {
            let {
              context,
              event
            } = _ref216;
            return restoreDefaults({
              context,
              event
            });
          })],
          target: "STARTING"
        },
        "Select product route": {
          actions: [assign2(_ref217 => {
            let {
              event
            } = _ref217;
            return replaceSelection({
              event
            });
          })],
          target: "STARTING"
        },
        "Select service": {
          actions: [assign2(_ref218 => {
            let {
              context,
              event
            } = _ref218;
            return selectService({
              context,
              event
            });
          })]
        },
        "Set device": {
          actions: [assign2(_ref219 => {
            let {
              event
            } = _ref219;
            return {
              device: event.device
            };
          })]
        },
        "Set price": {
          actions: [assign2(_ref220 => {
            let {
              context,
              event
            } = _ref220;
            return setPrice({
              context,
              event
            });
          })]
        },
        "Toggle panel": {
          actions: [assign2(_ref221 => {
            let {
              context,
              event
            } = _ref221;
            return togglePanel({
              context,
              event
            });
          })]
        },
        "Set quantity": [{
          guard: "isStepByStep",
          actions: [assign2(_ref222 => {
            let {
              context,
              event
            } = _ref222;
            return setQuantity({
              context,
              event
            });
          })]
        }, {
          actions: [assign2(_ref223 => {
            let {
              context,
              event
            } = _ref223;
            return setQuantity({
              context,
              event
            });
          })],
          target: "STARTED.FETCHING DATA.PIVOT PRICES.FETCHING PIVOT PRICES"
          // Transition to the fetching state for pivot prices
        }],
        "Set delivery option": [{
          guard: "isStepByStep",
          actions: [assign2(_ref224 => {
            let {
              context,
              event
            } = _ref224;
            return setDeliveryOption({
              context,
              event
            });
          })]
        }, {
          actions: [assign2(_ref225 => {
            let {
              context,
              event
            } = _ref225;
            return setDeliveryOption({
              context,
              event
            });
          })],
          target: "STARTED.FETCHING DATA.PIVOT PRICES.FETCHING PIVOT PRICES"
          // Transition to the fetching state for pivot prices
        }],
        "Set custom quantity": {
          actions: [assign2(_ref226 => {
            let {
              context,
              event
            } = _ref226;
            return setCustomQuantity({
              context,
              event
            });
          })],
          target: "STARTED.FETCHING DATA.PRICES.FETCHING PRICES"
          // Transition to the fetching state for prices
        }
      }
    }
  }
});

// src/contexts/SelectorContext.tsx
import { jsx } from "react/jsx-runtime";
var SelectorContext = createContext(null);
var SelectorContextProvider = _ref227 => {
  let {
    children,
    isPimProduct = false
  } = _ref227;
  const ActorContext = React.useMemo(() => isPimProduct ? createActorContext(productSelectorMachine) : createActorContext(selectorMachine), [isPimProduct]);
  return /* @__PURE__ */jsx(ActorContext.Provider, {
    children: /* @__PURE__ */jsx(SelectorContext.Provider, {
      value: ActorContext,
      children
    })
  });
};

// src/contexts/PricesContext.tsx
import { createActorContext as createActorContext2 } from "@xstate/react";

// src/statemachines/prices/prices.machine.ts
import { assertEvent as assertEvent3, assign as assign3, setup as setup3 } from "xstate";

// src/statemachines/actors/priceActors.ts
import { fromPromise as fromPromise2 } from "xstate";
var fetchPrices = fromPromise2(async _ref228 => {
  let {
    input
  } = _ref228;
  if (!input.shippingAddress) {
    return Promise.reject(new Error("No shipping address while fetching prices"));
  }
  return productClient.getPrices({
    variableAttributes: input.selectionAttributes,
    quantity: input.quantity,
    productKey: input.productKey,
    mcpSku: input.mcpSku,
    address: input.shippingAddress,
    group: input.group,
    customerGroupId: input.customerGroupId,
    sort: input.sort,
    customHeaders: {
      "x-filename": "priceGuards.ts",
      "x-href": getCurrentUrl()
    }
  });
});
var fetchArrivalDates = fromPromise2(async _ref229 => {
  let {
    input
  } = _ref229;
  if (!input.selectionAttributes || !input.shippingAddress || !input.group || !input.prices || !input.remainingOptionsPerGroup) {
    return Promise.reject(new Error("Missing data while fetching arrival dates"));
  }
  return productClient.getExpectedDeliveryDates({
    prices: input.prices,
    productKey: input.productKey,
    singleAttributes: input.selectionAttributes,
    shippingAddress: input.shippingAddress,
    group: input.group,
    remainingOptionsPerGroup: input.remainingOptionsPerGroup
  });
});
var fetchCustomQuantities = fromPromise2(_ref230 => {
  let {
    input
  } = _ref230;
  if (!input.selectionAttributes || !input.prices) {
    return Promise.reject(new Error("No selection attributes while fetching custom quantities"));
  }
  return validationClient.getCustomQuantities(input.productKey, input.selectionAttributes, input.prices, input.merchandisedQuantities);
});
var fetchCustomQuantitiesPrices = fromPromise2(_ref231 => {
  let {
    input
  } = _ref231;
  if (!input.selectionAttributes || !input.shippingAddress) {
    return Promise.reject(new Error("No selection attribute or shipping address while fetching custom quantity prices"));
  }
  return productClient.getPrices({
    productKey: input.productKey,
    mcpSku: input.mcpSku,
    customerGroupId: input.customerGroupId,
    sort: input.sort,
    group: input.group,
    variableAttributes: input.selectionAttributes,
    quantity: input.quantity,
    address: input.shippingAddress,
    customHeaders: {
      "x-filename": "priceGuards.ts",
      "x-href": getCurrentUrl()
    }
  });
});

// src/statemachines/actions/priceActions.ts
var initializeContext2 = _ref232 => {
  let {
    event
  } = _ref232;
  return {
    quantity: event.quantity,
    productKey: event.productKey,
    mcpSku: event.mcpSku,
    selectionAttributes: event.selectionAttributes,
    shippingAddress: event.shippingAddress,
    group: event.group,
    sort: event.sort,
    customerGroupId: event.customerGroupId,
    selectedPriceAttributes: event.preselectedPriceAttributes,
    inventoryCheckEnabled: event.inventoryCheckEnabled,
    merchandisedQuantities: event.merchandisedQuantities,
    remainingOptions: event.remainingOptions
  };
};
var storePrices2 = _ref233 => {
  let {
    context,
    event
  } = _ref233;
  if (context.selectedPriceAttributes) {
    const preselectedPrice = getPriceByAttributes(event.output, context.selectedPriceAttributes);
    return {
      prices: event.output,
      selectedPrice: preselectedPrice
    };
  }
  return {
    prices: event.output
  };
};
var storeArrivalDates = _ref234 => {
  let {
    context,
    event
  } = _ref234;
  if (context.selectedPriceAttributes) {
    const deliveryType = getSelectedPriceAttributeValue(context.selectedPriceAttributes, "Delivery Type");
    const printingProcess = getSelectedPriceAttributeValue(context.selectedPriceAttributes, "Printing");
    const selectedArrivalDate = getArrivalDate(event.output, deliveryType, printingProcess);
    return {
      arrivalDates: event.output,
      selectedArrivalDate
    };
  }
  return {
    arrivalDates: event.output
  };
};
var storeCustomQuantities = _ref235 => {
  let {
    event
  } = _ref235;
  return {
    customQuantities: event.output
  };
};
var storeCustomQuantityPrices = _ref236 => {
  let {
    context,
    event
  } = _ref236;
  if (context.selectedPriceAttributes) {
    const selectedPrice = getPriceByAttributes(event.output, context.selectedPriceAttributes);
    return {
      customQuantityPrices: event.output,
      selectedPrice
    };
  }
  return {
    customQuantityPrices: event.output
  };
};
var storeSelectedPriceAndAttributes = _ref237 => {
  let {
    context,
    event
  } = _ref237;
  const deliveryType = getSelectedPriceAttributeValue(event.selectedPriceAttributes, "Delivery Type");
  const printingProcess = getSelectedPriceAttributeValue(event.selectedPriceAttributes, "Printing");
  const selectedArrivalDate = getArrivalDate(context.arrivalDates, deliveryType, printingProcess);
  return {
    selectedPrice: event.selectedPrice,
    selectedPriceAttributes: event.selectedPriceAttributes,
    selectedArrivalDate
  };
};
var logError2 = _ref238 => {
  let {
    context,
    event
  } = _ref238;
  Sentry.exception({
    exception: event.error instanceof Error ? event.error : "An error occurred in the prices machine",
    extra: {
      mcpSku: context.mcpSku,
      productKey: context.productKey,
      selectedAttributes: JSON.stringify(context.selectionAttributes),
      arrivalDates: JSON.stringify(context.arrivalDates),
      selectedArrivalDate: context.selectedArrivalDate,
      selectedPriceAttributes: JSON.stringify(context.selectedPriceAttributes),
      selectedPrice: JSON.stringify(context.selectedPrice),
      customQuantities: JSON.stringify(context.customQuantities),
      inventoryCheckEnabled: context.inventoryCheckEnabled,
      group: JSON.stringify(context.group),
      response: JSON.stringify(event)
    },
    tags: {
      fileLocation: "pricesMachine",
      productKey: context.productKey,
      mcpSku: context.mcpSku
    },
    // Group the errors by the originating state
    fingerprint: ["pricesMachine", event.actorId]
  });
};
var logEmptyPricesError = _ref239 => {
  let {
    context,
    event
  } = _ref239;
  Sentry.exception({
    exception: "Attributes Resulted in Empty Price Table",
    extra: {
      mcpSku: context.mcpSku,
      productKey: context.productKey,
      selectedAttributes: JSON.stringify(context.selectionAttributes),
      response: JSON.stringify(event)
    },
    tags: {
      eventName: "EmptyPriceTable",
      fileLocation: "pricesMachine",
      productKey: context.productKey,
      mcpSku: context.mcpSku
    },
    fingerprint: ["printdeal-selector-show-prices"]
  });
};
var InsufficientInventoryError = _ref240 => {
  let {
    context,
    event
  } = _ref240;
  Sentry.exception({
    exception: "InsufficientInventoryError",
    extra: {
      mcpSku: context.mcpSku,
      productKey: context.productKey,
      selectedAttributes: JSON.stringify(context.selectionAttributes),
      response: JSON.stringify(event)
    },
    tags: {
      eventName: "InsufficientInventoryError",
      fileLocation: "pricesMachine",
      productKey: context.productKey,
      mcpSku: context.mcpSku
    },
    fingerprint: ["printdeal-selector-Insufficient-inventory"]
  });
};

// src/statemachines/guards/priceGuards.ts
var hasPrices = (_, params) => params.prices.length > 0;
var hasNoPrices = (_, params) => {
  if (Array.isArray(params.data)) {
    return true;
  }
  if (params.data && "response" in params.data) {
    return params.data.response.data.message === "No prices found";
  }
  return false;
};
var hasInsufficientInventoryResponse = (_ref241, params) => {
  let {
    context
  } = _ref241;
  return Boolean(hasInsufficientInventory(params.arrivalDates) && context.inventoryCheckEnabled);
};

// src/statemachines/prices/prices.machine.ts
var initialContext3 = {
  productKey: "",
  mcpSku: "",
  prices: [],
  arrivalDates: [],
  quantity: [],
  sort: [],
  inventoryCheckEnabled: true,
  merchandisedQuantities: [],
  remainingOptions: []
};
var pricesMachine = setup3({
  types: {},
  actors: {
    fetchPrices,
    fetchArrivalDates,
    fetchCustomQuantities,
    fetchCustomQuantitiesPrices
  },
  actions: {
    "Store selection": assign3(_ref242 => {
      let {
        event
      } = _ref242;
      assertEvent3(event, "Get prices");
      return {
        selectionAttributes: event.selectionAttributes
      };
    }),
    "Clear prices": assign3({
      prices: [],
      arrivalDates: [],
      customQuantities: void 0,
      customQuantityPrices: [],
      selectedPrice: void 0,
      selectedPriceAttributes: void 0
    }),
    "Deselect price": assign3({
      selectedPrice: void 0,
      selectedPriceAttributes: void 0
    }),
    "Reset custom quantity prices": assign3({
      customQuantityPrices: []
    })
  },
  guards: {
    hasPrices,
    hasNoPrices,
    hasInsufficientInventoryResponse
  }
}).createMachine({
  context: initialContext3,
  id: "Prices Machine",
  initial: "Initial",
  states: {
    "Showing Prices": {
      type: "parallel",
      states: {
        "Custom quantities": {
          initial: "Loading custom quantities",
          states: {
            "Loading custom quantities": {
              invoke: {
                src: "fetchCustomQuantities",
                input: _ref243 => {
                  let {
                    context
                  } = _ref243;
                  return {
                    productKey: context.productKey,
                    selectionAttributes: context.selectionAttributes,
                    prices: context.prices,
                    merchandisedQuantities: context.merchandisedQuantities
                  };
                },
                onDone: [{
                  actions: [assign3(_ref244 => {
                    let {
                      event
                    } = _ref244;
                    return storeCustomQuantities({
                      event
                    });
                  })],
                  target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities"
                }],
                onError: [{
                  actions: [_ref245 => {
                    let {
                      context,
                      event
                    } = _ref245;
                    return logError2({
                      context,
                      event
                    });
                  }],
                  target: "#Prices Machine.Showing Prices.Custom quantities.Hiding custom quantities"
                }]
              }
            },
            "Showing custom quantities": {
              exit: "Reset custom quantity prices",
              initial: "Waiting for quantity selection",
              states: {
                "Loading custom quantity prices": {
                  invoke: {
                    src: "fetchCustomQuantitiesPrices",
                    input: _ref246 => {
                      let {
                        context,
                        event
                      } = _ref246;
                      assertEvent3(event, "Select custom quantity");
                      return {
                        shippingAddress: context.shippingAddress,
                        selectionAttributes: context.selectionAttributes,
                        quantity: event.quantity,
                        productKey: context.productKey,
                        mcpSku: context.mcpSku,
                        customerGroupId: context.customerGroupId,
                        group: context.group,
                        sort: context.sort
                      };
                    },
                    onDone: [{
                      actions: [assign3(_ref247 => {
                        let {
                          context,
                          event
                        } = _ref247;
                        return storeCustomQuantityPrices({
                          context,
                          event
                        });
                      })],
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Showing custom quantity prices"
                    }],
                    onError: [{
                      actions: [_ref248 => {
                        let {
                          context,
                          event
                        } = _ref248;
                        return logError2({
                          context,
                          event
                        });
                      }],
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Hiding custom quantity prices"
                    }]
                  }
                },
                "Showing custom quantity prices": {
                  on: {
                    "Select custom quantity": {
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Loading custom quantity prices"
                    }
                  }
                },
                "Hiding custom quantity prices": {
                  on: {
                    "Select custom quantity": {
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Loading custom quantity prices"
                    }
                  }
                },
                "Waiting for quantity selection": {
                  on: {
                    "Select custom quantity": {
                      target: "#Prices Machine.Showing Prices.Custom quantities.Showing custom quantities.Loading custom quantity prices"
                    }
                  }
                }
              }
            },
            "Hiding custom quantities": {}
          }
        },
        "Arrival dates": {
          initial: "Loading arrival dates",
          states: {
            "Loading arrival dates": {
              invoke: {
                src: "fetchArrivalDates",
                input: _ref249 => {
                  let {
                    context
                  } = _ref249;
                  return {
                    prices: context.prices,
                    productKey: context.productKey,
                    selectionAttributes: context.selectionAttributes,
                    shippingAddress: context.shippingAddress,
                    group: context.group,
                    remainingOptionsPerGroup: context.remainingOptions
                  };
                },
                onDone: [{
                  guard: {
                    type: "hasInsufficientInventoryResponse",
                    params: _ref250 => {
                      let {
                        event
                      } = _ref250;
                      return {
                        arrivalDates: event.output
                      };
                    }
                  },
                  actions: [assign3(_ref251 => {
                    let {
                      context,
                      event
                    } = _ref251;
                    return storeArrivalDates({
                      context,
                      event
                    });
                  }), _ref252 => {
                    let {
                      context,
                      event
                    } = _ref252;
                    return InsufficientInventoryError({
                      context,
                      event
                    });
                  }],
                  target: "#Prices Machine.Showing request quote"
                }, {
                  actions: [assign3(_ref253 => {
                    let {
                      context,
                      event
                    } = _ref253;
                    return storeArrivalDates({
                      context,
                      event
                    });
                  })],
                  target: "#Prices Machine.Showing Prices.Arrival dates.Showing arrival dates"
                }],
                onError: [{
                  actions: [_ref254 => {
                    let {
                      context,
                      event
                    } = _ref254;
                    return logError2({
                      context,
                      event
                    });
                  }],
                  target: "#Prices Machine.Showing Prices.Arrival dates.Hiding arrival dates"
                }]
              }
            },
            "Showing arrival dates": {},
            "Hiding arrival dates": {}
          }
        },
        "Waiting for price selection": {
          on: {
            "Select price": {
              actions: [assign3(_ref255 => {
                let {
                  context,
                  event
                } = _ref255;
                return storeSelectedPriceAndAttributes({
                  context,
                  event
                });
              })],
              target: "#Prices Machine.Showing Prices.Waiting for price selection"
            }
          }
        }
      },
      on: {
        Reset: {
          actions: "Clear prices",
          target: "#Prices Machine.Initial"
        },
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        },
        "Clear selected price": {
          actions: "Deselect price"
        }
      }
    },
    "Loading prices": {
      entry: "Store selection",
      invoke: {
        src: "fetchPrices",
        input: _ref256 => {
          let {
            context,
            event
          } = _ref256;
          assertEvent3(event, "Get prices");
          return {
            shippingAddress: context.shippingAddress,
            selectionAttributes: event.selectionAttributes,
            quantity: event.quantity,
            productKey: context.productKey,
            mcpSku: context.mcpSku,
            customerGroupId: event.customerGroupId,
            group: event.group,
            sort: context.sort
          };
        },
        onDone: [{
          actions: [assign3(_ref257 => {
            let {
              context,
              event
            } = _ref257;
            return storePrices2({
              context,
              event
            });
          })],
          guard: {
            type: "hasPrices",
            params: _ref258 => {
              let {
                event
              } = _ref258;
              return {
                prices: event.output
              };
            }
          },
          target: "#Prices Machine.Showing Prices"
        }, {
          guard: {
            type: "hasNoPrices",
            params: _ref259 => {
              let {
                event
              } = _ref259;
              return {
                data: event.output
              };
            }
          },
          target: "#Prices Machine.Erroring"
        }],
        onError: [{
          actions: [_ref260 => {
            let {
              context,
              event
            } = _ref260;
            return logEmptyPricesError({
              context,
              event
            });
          }],
          guard: {
            type: "hasNoPrices",
            params: _ref261 => {
              let {
                event
              } = _ref261;
              return {
                data: event
              };
            }
          },
          target: "#Prices Machine.Erroring"
        }, {
          actions: [_ref262 => {
            let {
              context,
              event
            } = _ref262;
            return logError2({
              context,
              event
            });
          }],
          target: "#Prices Machine.Erroring"
        }]
      }
    },
    "Hiding prices": {
      on: {
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        }
      }
    },
    Erroring: {
      on: {
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        }
      }
    },
    Initial: {
      on: {
        "Start machine": {
          actions: [assign3(_ref263 => {
            let {
              event
            } = _ref263;
            return initializeContext2({
              event
            });
          })],
          target: "#Prices Machine.Hiding prices"
        }
      }
    },
    "Showing request quote": {
      exit: "Clear prices",
      on: {
        Reset: {
          target: "#Prices Machine.Initial"
        },
        "Get prices": {
          target: "#Prices Machine.Loading prices"
        }
      }
    }
  }
});

// src/contexts/PricesContext.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var PricesContext = createActorContext2(pricesMachine);
var PricesContextProvider = _ref264 => {
  let {
    children
  } = _ref264;
  return /* @__PURE__ */jsx2(PricesContext.Provider, {
    children
  });
};

// src/hooks/useMachine.ts
var useSelectorMachineContext = selector => {
  const selectorContext = useContext(SelectorContext);
  if (!selectorContext) {
    throw new Error("useSelectorMachineContext must be used within a SelectorContextProvider");
  }
  return selectorContext.useSelector(selector);
};
var usePricesMachineContext = selector => PricesContext.useSelector(selector);
var useSelectorMachineSend = () => {
  const selectorContext = useContext(SelectorContext);
  if (!selectorContext) {
    throw new Error("useSelectorMachineSend must be used within a SelectorContextProvider");
  }
  const actor = selectorContext.useActorRef();
  return actor.send;
};
var usePricesMachineSend = () => {
  const actor = PricesContext.useActorRef();
  return actor.send;
};

// src/hooks/useCollapseLogic.ts
var useCollapseLogic = _ref265 => {
  let {
    filteredAttributes,
    attributeName,
    attributeIndex,
    selectedValue,
    hasPrefilledSelection
  } = _ref265;
  const {
    isInitialized,
    experiment
  } = useExperiment("exp1916_stay_at_the_top_of_selector_instead_of_jump_to_bottom");
  const device = useSelectorMachineContext(state => state.context.device);
  const productRouteClicked = useSelectorMachineContext(state => state.context.productRouteClicked);
  const isReviewPage = useSelectorMachineContext(state => state.context.isReviewPage);
  const {
    panelName,
    openPanel
  } = useSelectorMachineContext(state => state.context.panel);
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const touched = touchedAttributes.includes(attributeName);
  const [open, setOpen] = useState(selectionMode === "default-values");
  const groupAttribute = filteredAttributes.find(attribute => attribute.type === attributeName);
  const isExp1916Enabled = Boolean(isInitialized && experiment.variation === "variant");
  useEffect(() => {
    if (isExp1916Enabled && productRouteClicked && selectionMode === "step-by-step" && device === "desktop") {
      setOpen(true);
      return;
    }
    if (isReviewPage) {
      setOpen(true);
    } else if (touched && !selectedValue) {
      setOpen(true);
    } else if (attributeName === panelName && openPanel) {
      setOpen(true);
    } else if (hasPrefilledSelection) {
      if ((groupAttribute === null || groupAttribute === void 0 ? void 0 : groupAttribute.type) === "group" && groupAttribute.attributes.some(_ref266 => {
        let {
          name
        } = _ref266;
        return !selection[name];
      })) {
        setOpen(true);
      } else {
        setOpen(false);
      }
    } else if (device === "mobile" && touched) {
      setOpen(false);
    } else if (selectionMode === "default-values" && device === "mobile" && !touched) {
      setOpen(true);
    } else if (selectionMode === "step-by-step") {
      const firstUntouchedIndex = filteredAttributes.findIndex(_ref267 => {
        let {
          name,
          defaultValue
        } = _ref267;
        return !touchedAttributes.includes(name) && !defaultValue;
      });
      const nextToOpen = attributeIndex === firstUntouchedIndex;
      if ((groupAttribute === null || groupAttribute === void 0 ? void 0 : groupAttribute.type) === "group") {
        if (nextToOpen) {
          setOpen(true);
        } else if (!groupAttribute.attributes.every(_ref268 => {
          let {
            name
          } = _ref268;
          return selection[name];
        }) && touched) {
          setOpen(true);
        } else {
          setOpen(false);
        }
      } else {
        setOpen(nextToOpen);
      }
    }
  }, [JSON.stringify(touchedAttributes), touched, device, panelName, openPanel, attributeIndex]);
  return {
    open,
    setOpen
  };
};

// src/helpers/range.ts
var calculateRange = (attributeKey, remainingOptionsPerGroup, configurationAttribute) => {
  const resolvedNumericAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeKey);
  const ranges = (resolvedNumericAttribute === null || resolvedNumericAttribute === void 0 ? void 0 : resolvedNumericAttribute.values.reduce((items, item) => {
    if (item.type === "range") {
      items.push(item.range);
    } else {
      items.push({
        minimum: Number(item.numberLiteral),
        maximum: Number(item.numberLiteral),
        increment: Number(item.numberLiteral)
      });
    }
    return items;
  }, [])) || (configurationAttribute === null || configurationAttribute === void 0 ? void 0 : configurationAttribute.range);
  return ranges === null || ranges === void 0 ? void 0 : ranges.reduce((activeRange, currentRange) => {
    if (!Object.keys(activeRange).length) {
      return currentRange;
    }
    if (activeRange.minimum > currentRange.minimum) {
      return _objectSpread(_objectSpread({}, activeRange), {}, {
        minimum: currentRange.minimum
      });
    }
    if (activeRange.maximum < currentRange.maximum) {
      return _objectSpread(_objectSpread({}, activeRange), {}, {
        maximum: currentRange.maximum
      });
    }
    return activeRange;
  }, {});
};
var isRangeValid = (attributeKey, remainingOptionsPerGroup, value) => {
  const resolvedNumericAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeKey);
  if (!(resolvedNumericAttribute !== null && resolvedNumericAttribute !== void 0 && resolvedNumericAttribute.values)) {
    return true;
  }
  return resolvedNumericAttribute.values.some(item => {
    if (value && item.type === "range") {
      const allowDecimals = item.range.increment - Math.floor(item.range.increment) !== 0;
      const isDecimalValue = value - Math.floor(value) !== 0;
      return value >= item.range.minimum && value <= item.range.maximum && (allowDecimals || !isDecimalValue);
    }
    if (value && item.type === "numberLiteral") {
      return Number(item.numberLiteral) === value;
    }
    return true;
  });
};

// src/hooks/useSelectorAttribute.ts
var useSelectorAttribute = (configurationAttribute, contentAttribute) => {
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const alternativePrices = useSelectorMachineContext(state => state.context.alternativePrices);
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const isExp1574 = useSelectorMachineContext(state => state.context.isExp1574);
  const send = useSelectorMachineSend();
  const getGrid = () => {
    const {
      grid
    } = configurationAttribute;
    if (grid && grid.invalidValuesVisibility === "hidden") {
      var _grid$row$values, _grid$column$values;
      return _objectSpread(_objectSpread({}, grid), {}, {
        row: _objectSpread(_objectSpread({}, grid.row), {}, {
          values: (_grid$row$values = grid.row.values) === null || _grid$row$values === void 0 ? void 0 : _grid$row$values.filter(rowValue => hasResolvedValue(remainingOptionsPerGroup, grid.row.name, rowValue.name))
        }),
        column: _objectSpread(_objectSpread({}, grid.column), {}, {
          values: (_grid$column$values = grid.column.values) === null || _grid$column$values === void 0 ? void 0 : _grid$column$values.filter(columnValue => hasResolvedValue(remainingOptionsPerGroup, grid.column.name, columnValue.name))
        })
      });
    }
    return grid;
  };
  const generateValues = function () {
    let attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : configurationAttribute.name;
    const resolvedNumericAttribute = getResolvedNumericAttributeFromGroup(remainingOptionsPerGroup, attributeKey);
    if (!(resolvedNumericAttribute !== null && resolvedNumericAttribute !== void 0 && resolvedNumericAttribute.values)) {
      return void 0;
    }
    const values = resolvedNumericAttribute.values.flatMap(item => {
      if (item.type === "range") {
        return createNumberArrayFromRange(item.range);
      }
      return [Number(item.numberLiteral)];
    });
    const deduplicateValues = [...new Set(values)];
    const sortedValues = deduplicateValues.sort((a, b) => a - b);
    return sortedValues;
  };
  const calculateRangeWrapper = function () {
    let attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : configurationAttribute.name;
    return calculateRange(attributeKey, remainingOptionsPerGroup, configurationAttribute);
  };
  const isRangeValidWrapper = function () {
    let attributeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : configurationAttribute.name;
    let value = arguments.length > 1 ? arguments[1] : undefined;
    return isRangeValid(attributeKey, remainingOptionsPerGroup, value);
  };
  const isValid = function (attributeName, valueName) {
    let type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "lov";
    let currentAttributeOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : remainingOptionsPerGroup;
    if (!currentAttributeOptions.length) {
      return true;
    }
    if (type === "lor") {
      return isRangeValidWrapper(attributeName, Number(valueName));
    }
    const valid = hasResolvedValue(currentAttributeOptions, attributeName, valueName);
    return valid;
  };
  const selectAttribute = params => {
    if (params.selectionType === "attribute") {
      var _params$shouldValidat;
      send({
        type: "Select attribute value",
        attributeSelection: {
          name: configurationAttribute.name,
          value: params.attributeValueName
        },
        shouldValidate: (_params$shouldValidat = params.shouldValidate) !== null && _params$shouldValidat !== void 0 ? _params$shouldValidat : true,
        valid: isValid(configurationAttribute.name, params.attributeValueName, params.type)
      });
      dispatchDataLayerEntry("selector", "click", {
        "element-type": configurationAttribute.template,
        "element-content": "attribute_value",
        "attribute-name": configurationAttribute.name,
        "attribute-value": params.attributeValueName
      });
    }
    if (params.selectionType === "attributeGroup") {
      var _params$shouldValidat2;
      send({
        type: "Select attribute value",
        groupedAttributes: params.groupedAttributes,
        shouldValidate: (_params$shouldValidat2 = params.shouldValidate) !== null && _params$shouldValidat2 !== void 0 ? _params$shouldValidat2 : true,
        valid: true,
        groupName: params.groupName
      });
    }
    if (params.selectionType === "group") {
      send({
        type: "Select attribute value",
        groupSelection: params.groupSelection,
        shouldValidate: params.shouldValidate || true,
        valid: true
      });
    }
  };
  const getExtraCosts = attributeValue => {
    if (Object.keys(pivotPrices).length) {
      var _pivotPrices$attribut, _price$totalNet$centA;
      const attributeKey = configurationAttribute.name === "Delivery Type" ? "EdoId" : configurationAttribute.name;
      const pivot = attributeValue.name;
      const price = (_pivotPrices$attribut = pivotPrices[attributeKey]) === null || _pivotPrices$attribut === void 0 ? void 0 : _pivotPrices$attribut[pivot];
      return Number((_price$totalNet$centA = price === null || price === void 0 ? void 0 : price.totalNet.centAmount) !== null && _price$totalNet$centA !== void 0 ? _price$totalNet$centA : 0);
    }
    const prices = alternativePrices.filter(price => Object.keys(price).find(key => {
      var _configurationAttribu;
      return (_configurationAttribu = configurationAttribute.values) === null || _configurationAttribu === void 0 ? void 0 : _configurationAttribu.find(value => value.name === key);
    }));
    const alternativePriceLength = prices.flatMap(price => Object.values(price).filter(value => value !== void 0)).length;
    if (alternativePriceLength < 2) {
      return void 0;
    }
    const extraCostPrice = alternativePrices.find(price => price[attributeValue.name]);
    if (extraCostPrice !== void 0) {
      return extraCostPrice[attributeValue.name];
    }
    return 0;
  };
  const getAttributeValue3 = attributeValue => {
    var _contentAttribute$val;
    return {
      attributeValue: contentAttribute === null || contentAttribute === void 0 || (_contentAttribute$val = contentAttribute.values) === null || _contentAttribute$val === void 0 ? void 0 : _contentAttribute$val.find(_ref269 => {
        let {
          pimAttributeValue
        } = _ref269;
        return pimAttributeValue === attributeValue.name;
      }),
      valid: isValid(configurationAttribute.name, attributeValue.name),
      extraCosts: getExtraCosts(attributeValue)
    };
  };
  const getAttributeValues = () => {
    var _configurationAttribu2;
    const mappedValues = (_configurationAttribu2 = configurationAttribute.values) === null || _configurationAttribu2 === void 0 ? void 0 : _configurationAttribu2.map(selectorAttributeValue => {
      const {
        valid,
        extraCosts,
        attributeValue
      } = getAttributeValue3(selectorAttributeValue);
      return {
        selectorAttributeValue,
        productAttributeValue: attributeValue,
        valid,
        extraCosts
      };
    });
    const attributeValues2 = mappedValues === null || mappedValues === void 0 ? void 0 : mappedValues.filter(value => {
      const rule = value.selectorAttributeValue.conditionalAttributeValueRules ? JSON.parse(value.selectorAttributeValue.conditionalAttributeValueRules) : "";
      const hasAppliedRule = applyLogic(rule, currentSelection);
      if (!value.selectorAttributeValue.enabled && !hasAppliedRule) {
        return false;
      }
      if (configurationAttribute.invalidValuesVisibility === "hidden" && !value.valid) {
        return false;
      }
      return true;
    });
    return attributeValues2 !== null && attributeValues2 !== void 0 ? attributeValues2 : [];
  };
  const isPricePivot = isExp1574 ? [...pricePivotAttributes, "Printing Colors"].includes(configurationAttribute.name) : pricePivotAttributes.includes(configurationAttribute.name);
  const attributeValues = getAttributeValues();
  const selectedValue = currentSelection[configurationAttribute.name];
  return {
    generateValues,
    calculateRange: calculateRangeWrapper,
    isRangeValid: isRangeValidWrapper,
    selectAttribute,
    getAttributeValue: getAttributeValue3,
    isPricePivot,
    attributeValues,
    selectedValue,
    getGrid,
    contentAttribute
  };
};

// src/helpers/slug.ts
var slugify = string => string.toString().trim().toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/_+/g, "-").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");

// src/components/selector/attribute-templates/QuantityGrid.tsx
import { useEffect as useEffect6, useState as useState6 } from "react";
import { dequal as isEqual2 } from "dequal/lite";
import { FormattedMessage as FormattedMessage4 } from "react-intl";
import { Button, LinkAsButton, Table as Table2, Alert as Alert2 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry2 } from "@printdeal/data-layer-manager";
import { configurationProvider as configurationProvider8 } from "@printdeal/configuration";

// src/components/selector/SizeTableModal.tsx
import { FormattedMessage, useIntl } from "react-intl";
import { Alert, Modal, RichText, Spinner } from "@printdeal/ui-library";
import { Suspense, lazy, useState as useState2 } from "react";

// src/hooks/content/useSizeTableContent.ts
import { useQuery } from "@tanstack/react-query";
var useSizeTableContent = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  return useQuery({
    queryKey: ["supportArticle", productPageId, locale],
    queryFn: async () => contentfulClient.getSizeTableContent(productPageId, locale),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/components/selector/SizeTableModal.tsx
import { Fragment, jsx as jsx3, jsxs } from "react/jsx-runtime";
var Markdown = lazy(() => import("@printdeal/markdown/react").then(module => ({
  default: module.Markdown
})));
var SizeTableFormId = "size-table-form";
var SizeTableModal = _ref270 => {
  let {
    productPageId
  } = _ref270;
  const intl = useIntl();
  const {
    locale
  } = intl;
  const [show, setShow] = useState2(false);
  const {
    data: sizeTable,
    status
  } = useSizeTableContent({
    productPageId,
    locale,
    enabled: show
  });
  const onSubmit = event => {
    event.preventDefault();
    setShow(true);
  };
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx3("form", {
      id: SizeTableFormId,
      "data-testid": SizeTableFormId,
      onSubmit
    }), /* @__PURE__ */jsxs(Modal, {
      title: intl.formatMessage({
        id: "selector.product.sizetable.modal.title",
        defaultMessage: "Size table"
      }),
      isOpen: show,
      onClose: () => setShow(false),
      size: "lg",
      dismissLabel: intl.formatMessage({
        id: "general.alert.dismiss",
        defaultMessage: "Dismiss"
      }),
      children: [status === "pending" && /* @__PURE__ */jsx3(Modal.Content, {
        "data-testid": "spinner",
        className: "pd:flex pd:h-96 pd:items-center pd:justify-center",
        children: /* @__PURE__ */jsx3(Spinner, {
          screenReaderLabel: intl.formatMessage({
            id: "selector.sizetable.modal.content.loading",
            defaultMessage: "Loading..."
          })
        })
      }), status === "success" && /* @__PURE__ */jsx3(Modal.Content, {
        className: "pd:p-4",
        children: sizeTable !== null && sizeTable !== void 0 && sizeTable.content ? /* @__PURE__ */jsx3(Suspense, {
          fallback: /* @__PURE__ */jsx3(Spinner, {
            screenReaderLabel: intl.formatMessage({
              id: "selector.sizetable.modal.content.loading",
              defaultMessage: "Loading..."
            })
          }),
          children: /* @__PURE__ */jsx3(RichText, {
            as: Markdown,
            children: sizeTable.content
          })
        }) : /* @__PURE__ */jsx3(Alert, {
          variant: "warning",
          children: /* @__PURE__ */jsx3(FormattedMessage, {
            id: "selector.product.sizetable.not.found",
            defaultMessage: "The does not seem to be a size table available for this product"
          })
        })
      })]
    })]
  });
};
var SizeTableModal_default = SizeTableModal;

// src/components/selector/attribute-templates/GridInput.tsx
import { useEffect as useEffect4, useState as useState4 } from "react";
import { Table, TextField, TextInput } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage3, useIntl as useIntl2 } from "react-intl";
import { dequal as isEqual } from "dequal/lite";
import { klona as cloneDeep } from "klona/lite";
import cx, { clsx } from "clsx";
import { configurationProvider as configurationProvider6 } from "@printdeal/configuration";

// src/components/selector/InventoryInfo.tsx
import { FormattedDate, FormattedMessage as FormattedMessage2 } from "react-intl";
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var InventoryInfo = _ref271 => {
  let {
    availability,
    range
  } = _ref271;
  return /* @__PURE__ */jsxs2(Fragment2, {
    children: [availability && range && availability.firstAvailable.inventory > range.maximum && /* @__PURE__ */jsx4("div", {
      className: "pd:mt-2 pd:text-xs pd:text-dim-600",
      children: /* @__PURE__ */jsx4(FormattedMessage2, {
        id: "selector.quantityGrid.firstavailable",
        values: {
          quantity: range.maximum
        },
        defaultMessage: "{quantity} pcs directly available"
      })
    }), availability && range && availability.firstAvailable.inventory < range.maximum && /* @__PURE__ */jsxs2(Fragment2, {
      children: [/* @__PURE__ */jsx4("div", {
        className: "pd:mt-2 pd:text-xs pd:text-dim-600",
        children: /* @__PURE__ */jsx4(FormattedMessage2, {
          id: "selector.quantityGrid.firstavailable",
          values: {
            quantity: availability.firstAvailable.inventory
          },
          defaultMessage: "{quantity} pcs directly available"
        })
      }), availability.nextAvailable && /* @__PURE__ */jsx4("div", {
        className: "pd:text-xs pd:text-dim-600",
        children: /* @__PURE__ */jsx4(FormattedMessage2, {
          id: "selector.quantityGrid.nextavailable",
          values: {
            quantity: availability.nextAvailable.inventory > range.maximum ? range.maximum : availability.nextAvailable.inventory,
            date: /* @__PURE__ */jsx4(FormattedDate, {
              value: availability.nextAvailable.date
            })
          },
          defaultMessage: "{quantity} pcs available on {date}"
        })
      })]
    })]
  });
};
var InventoryInfo_default = InventoryInfo;

// src/hooks/content/useSelectorContentById.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";
var useSelectorContentById = settings => {
  const {
    selectorId,
    locale,
    enabled = true
  } = settings;
  return useQuery2({
    queryKey: ["selectorContent", selectorId, locale],
    queryFn: async () => contentfulClient.getSelectorContent(selectorId, locale),
    enabled: enabled && Boolean(selectorId)
  });
};

// src/hooks/content/useSelectorContentByPageId.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import { useGetExperiment } from "@printdeal/feature-management/react";
var useSelectorContentByPageId = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  const getExperiment = useGetExperiment();
  return useQuery3({
    queryKey: ["productContent", productPageId, locale],
    queryFn: () => contentfulClient.getProductPageContent({
      productPageId,
      locale,
      getExperiment
    }),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/hooks/content/useNewSelector.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
var useNewSelector = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  return useQuery4({
    queryKey: ["useNewSelector", productPageId, locale],
    queryFn: async () => contentfulClient.getUseNewSelector(productPageId, locale),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/hooks/useSelectorState.ts
import { useEffect as useEffect2, useState as useState3 } from "react";
var useSelectorState = () => {
  const [status, setStatus] = useState3("loading");
  const isMachineErroring = useSelectorMachineContext(state => state.matches({
    STARTED: "ERRORING"
  }));
  const isPricesErroring = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "ERRORING"
      }
    }
  }));
  const isServicePricesErroring = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "SERVICE PRICES": "ERRORING"
      }
    }
  }));
  const isErroring = isMachineErroring || isPricesErroring || isServicePricesErroring;
  const isLoadingPrices = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }));
  const isLoadingPivotPrices = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const isLoadingServicePrices = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "SERVICE PRICES": "FETCHING SERVICE PRICES"
      }
    }
  }));
  const isLoadingArrivalDates = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        "ARRIVAL DATES": "FETCHING ARRIVAL DATES"
      }
    }
  }));
  const isLoadingMerchantRules = useSelectorMachineContext(state => state.matches({
    STARTED: "FETCHING MERCHANT RULES"
  }));
  const isValidating = useSelectorMachineContext(state => state.matches({
    STARTED: "VALIDATING"
  }));
  const isLoading = isLoadingPrices || isLoadingPivotPrices || isLoadingServicePrices || isLoadingArrivalDates || isLoadingMerchantRules || isValidating;
  const isIdle = !isErroring && !isLoading;
  useEffect2(() => {
    if (isIdle) {
      setStatus("idle");
    } else if (isLoading) {
      setStatus("loading");
    } else if (isErroring) {
      setStatus("error");
    }
  }, [isErroring, isLoading, isIdle]);
  return status;
};
var useMatchesState = condition => useSelectorMachineContext(state => state.matches(condition));

// src/hooks/useSyncSelectionToUrl.ts
import { useEffect as useEffect3 } from "react";
import { selectionToQueryParameter } from "@printdeal/product-code";
var useSyncSelectionToUrl = () => {
  const url = getCurrentUrl();
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const totalQuantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const selectedDeliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const groupSelection = useSelectorMachineContext(state => state.context.group);
  const attributes = useSelectorMachineContext(state => {
    var _state$context$produc;
    return (_state$context$produc = state.context.product) === null || _state$context$produc === void 0 ? void 0 : _state$context$produc.attributes;
  });
  const isStarted = useSelectorMachineContext(state => state.matches("STARTED"));
  useEffect3(() => {
    if (!isStarted || !attributes) return;
    const urlSelection = getSelectionFromUrl(url, attributes);
    if ((touchedAttributes.length || urlSelection) && Object.keys(selection).length > 0) {
      try {
        const selectionQueryParameter = selectionToQueryParameter(selection);
        if (selectionQueryParameter.length > 0) {
          setUrlParameters({
            selectionParameter: selectionQueryParameter
          });
        }
      } catch (_unused) {}
    } else {
      deleteSearchParameter("selection");
    }
  }, [JSON.stringify(selection), isStarted]);
  useEffect3(() => {
    if (!isStarted || !attributes) return;
    const urlSelection = getSelectionFromUrl(url, attributes);
    if ((touchedAttributes.length || urlSelection) && groupSelection.length > 0) {
      const group = groupSelection.filter(entry => entry.quantity > 0).map(entry => _objectSpread(_objectSpread({}, entry.attributes), {}, {
        quantity: entry.quantity
      }));
      if (group.length > 0) {
        setUrlParameters({
          comboSelectionParameter: encodeURIComponent(JSON.stringify(group))
        });
      }
    } else {
      deleteSearchParameter("comboSelection");
    }
  }, [JSON.stringify(groupSelection), isStarted]);
  useEffect3(() => {
    if (!isStarted || !attributes) return;
    const quantityParam = getParamFromUrl(url, "quantity");
    const deliveryOptionIdParam = getParamFromUrl(url, "deliveryOptionId");
    if ((touchedAttributes.length || quantityParam || deliveryOptionIdParam) && (totalQuantity || selectedDeliveryOption.id)) {
      try {
        if (totalQuantity) {
          setUrlParameters({
            quantityParameter: String(totalQuantity)
          });
        }
        if (selectedDeliveryOption.id) {
          setUrlParameters({
            deliveryOptionIdParameter: selectedDeliveryOption.id
          });
        }
      } catch (_unused2) {}
    } else {
      deleteSearchParameter("quantity");
      deleteSearchParameter("deliveryOptionId");
    }
  }, [totalQuantity, JSON.stringify(selectedDeliveryOption), isStarted]);
};

// src/components/selector/attribute-templates/GridInput.tsx
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var getGroupIndex = (groupSelection, group) => groupSelection.findIndex(_ref272 => {
  let {
    attributes
  } = _ref272;
  return isEqual(group.attributes, attributes);
});
var updateGroup = (groupSelection, group) => {
  const groupIndex = getGroupIndex(groupSelection, group);
  if (group.quantity === 0) {
    const clonedGroup = cloneDeep(groupSelection);
    clonedGroup.splice(groupIndex, 1);
    return clonedGroup;
  }
  if (groupIndex !== -1) {
    const clonedGroup = cloneDeep(groupSelection);
    clonedGroup[groupIndex] = group;
    return clonedGroup;
  }
  return [...groupSelection, group];
};
var GridInput = _ref273 => {
  let {
    columnValue,
    rowValue,
    grid,
    groupSelection,
    setGroupSelection,
    calculateRange: calculateRange2,
    isRangeValid: isRangeValid2,
    setAvailability,
    className
  } = _ref273;
  const intl = useIntl2();
  const isImpressto = configurationProvider6.getValue("STORE_KEY") === "impressto-fr";
  const inventory = useSelectorMachineContext(state => state.context.inventory);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const {
    row,
    column
  } = grid;
  const [showInventory, setShowInventory] = useState4(false);
  const inventoryInfo = inventory === null || inventory === void 0 ? void 0 : inventory.find(_ref274 => {
    let {
      groupAttribute: inventoryAttribute
    } = _ref274;
    return inventoryAttribute.every(_ref275 => {
      let {
        value
      } = _ref275;
      return value === columnValue.name || value === rowValue.name;
    });
  });
  const groupAttribute = groupSelection.find(_ref276 => {
    let {
      attributes
    } = _ref276;
    return attributes[row.name] === rowValue.name && attributes[column.name] === columnValue.name;
  });
  const {
    quantity
  } = groupAttribute || {
    quantity: 0
  };
  const valid = isGridCellValid({
    name: row.name,
    value: rowValue.name
  }, {
    name: column.name,
    value: columnValue.name
  }, remainingOptionsPerGroup);
  const range = calculateRange2("Quantity");
  const shouldValidateRange = range && range.minimum === range.maximum;
  const rangeIsValid = shouldValidateRange ? isRangeValid2("Quantity", quantity) : true;
  const minimum = range !== null && range !== void 0 && range.minimum && range.minimum > 1 ? range.minimum : 0;
  const isInputValid = Boolean(quantity === 0 || !range || quantity >= range.minimum && quantity <= range.maximum);
  const Group2 = isImpressto ? "div" : Table.Td;
  const Input2 = isImpressto ? TextInput : TextField;
  useEffect4(() => {
    if (isImpressto) {
      if (showInventory && setAvailability) {
        setAvailability(inventoryInfo === null || inventoryInfo === void 0 ? void 0 : inventoryInfo.availability);
      } else if (!showInventory && setAvailability) {
        setAvailability(void 0);
      }
    }
  }, [showInventory]);
  if (!valid && grid.invalidValuesVisibility === "hidden") {
    return /* @__PURE__ */jsx5(Table.Td, {
      className: "pd:border pd:border-dim-200 pd:p-4"
    }, columnValue.name);
  }
  return /* @__PURE__ */jsxs3(Group2, {
    className: clsx("pd:relative", className),
    children: [isImpressto && (!rangeIsValid || !isInputValid) &&
    // TODO: use proper Tooltip component
    // (https://styleguide.printdeal.cloud/packages/ui-library/7.19.0/?path=/docs/components-tooltip--docs)
    /* @__PURE__ */
    jsx5("div", {
      role: "tooltip",
      id: "tooltip-".concat(slugify(columnValue.name), "-").concat(slugify(rowValue.name)),
      className: "pd:tooltip__message--top pd:absolute pd:z-10 pd:block pd:h-auto pd:w-max pd:max-w-sm pd:overflow-visible pd:whitespace-normal pd:rounded pd:bg-dark pd:p-3 pd:text-center pd:text-sm pd:text-white pd:opacity-100",
      children: /* @__PURE__ */jsx5("span", {
        "data-cy": "max-quantity-error",
        children: /* @__PURE__ */jsx5(FormattedMessage3, {
          id: "selector.quantityGrid.maxQuantity",
          values: {
            maxQuantity: range === null || range === void 0 ? void 0 : range.maximum
          },
          defaultMessage: "Max {maxQuantity} pcs"
        })
      })
    }), /* @__PURE__ */jsx5(Input2, {
      type: "number",
      className: cx("pd:w-full ".concat(quantity > 0 ? "pd:text-dim-800" : "pd:text-dim-600")),
      "aria-describedby": isImpressto ? "tooltip-".concat(slugify(columnValue.name), "-").concat(slugify(rowValue.name)) : void 0,
      disabled: !valid,
      name: "".concat(columnValue.name, "-").concat(rowValue.name),
      id: "".concat(slugify(columnValue.name), "-").concat(slugify(rowValue.name)),
      "data-testid": "".concat(columnValue.name, "-").concat(rowValue.name),
      value: quantity > 0 ? quantity : "",
      onFocus: () => setShowInventory(true),
      onBlur: () => setShowInventory(false),
      suffix: !isImpressto ? intl.formatMessage({
        id: "selector.quantity.pieces",
        defaultMessage: "{quantity, plural, =0 {pc.} =1 {pc.} other {pcs.}}"
      }, {
        quantity
      }) : void 0,
      min: shouldValidateRange ? minimum : 0,
      max: shouldValidateRange ? range.maximum : void 0,
      onChange: event => setGroupSelection(updateGroup(groupSelection, {
        attributes: {
          [row.name]: rowValue.name,
          [column.name]: columnValue.name
        },
        quantity: Number(event.target.value),
        isValid: valid
      })),
      onWheel: event => {
        event.currentTarget.blur();
      },
      validation: !rangeIsValid || !isInputValid ? "error" : void 0,
      validationMessage: !isImpressto && (!rangeIsValid || !isInputValid) ? /* @__PURE__ */jsx5("span", {
        "data-cy": "max-quantity-error",
        children: /* @__PURE__ */jsx5(FormattedMessage3, {
          id: "selector.quantityGrid.maxQuantity",
          values: {
            maxQuantity: range === null || range === void 0 ? void 0 : range.maximum
          },
          defaultMessage: "Max {maxQuantity} pcs"
        })
      }) : void 0
    }), !isImpressto && showInventory && /* @__PURE__ */jsx5(InventoryInfo_default, {
      availability: inventoryInfo === null || inventoryInfo === void 0 ? void 0 : inventoryInfo.availability,
      range
    })]
  }, columnValue.name);
};
var GridInput_default = GridInput;

// src/components/selector/attribute-templates/ColumnGrid.tsx
import { useState as useState5 } from "react";

// src/hooks/useDebouncedSelection.ts
import { useEffect as useEffect5 } from "react";
import debounce from "lodash.debounce";
import { configurationProvider as configurationProvider7 } from "@printdeal/configuration";
var debouncedSelectAttribute = debounce((groupSelection, isRangeValid2, selectAttribute) => {
  const totalQuantity = getTotalQuantity2(groupSelection);
  const isValidRange = isRangeValid2("groupedQuantity", totalQuantity);
  selectAttribute({
    selectionType: "group",
    groupSelection,
    shouldValidate: isValidRange
  });
}, 1500);
var useDebouncedSelection = (groupSelection, isRangeValid2, selectAttribute) => {
  const isImpressto = configurationProvider7.getValue("STORE_KEY") === "impressto-fr";
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  useEffect5(() => {
    if (isImpressto && selectionMode === "default-values") {
      debouncedSelectAttribute(groupSelection, isRangeValid2, selectAttribute);
    }
    return () => {
      debouncedSelectAttribute.cancel();
    };
  }, [isImpressto, groupSelection]);
};

// src/components/selector/attribute-templates/ColumnGrid.tsx
import { jsx as jsx6, jsxs as jsxs4 } from "react/jsx-runtime";
var ColumnGrid = _ref277 => {
  var _columnProductAttribu, _row$values2;
  let {
    attribute,
    productAttributes,
    column,
    groupSelection,
    setGroupSelection
  } = _ref277;
  const [availability, setAvailability] = useState5();
  const productAttribute = getProductAttribute(productAttributes, attribute.name);
  const {
    selectAttribute,
    calculateRange: calculateRange2,
    isRangeValid: isRangeValid2,
    getGrid
  } = useSelectorAttribute(attribute, productAttribute);
  useDebouncedSelection(groupSelection, isRangeValid2, selectAttribute);
  const grid = getGrid();
  if (!grid) {
    return null;
  }
  const {
    row
  } = grid;
  const rowProductAttribute = getProductAttribute(productAttributes, row.name);
  const columnProductAttribute = getProductAttribute(productAttributes, column.name);
  const range = calculateRange2("Quantity");
  return /* @__PURE__ */jsxs4("div", {
    className: "pd:flex pd:flex-col pd:gap-4",
    children: [/* @__PURE__ */jsx6("h3", {
      className: "pd:font-medium pd:text-lg pd:text-dim-800",
      children: (columnProductAttribute === null || columnProductAttribute === void 0 || (_columnProductAttribu = columnProductAttribute.values) === null || _columnProductAttribu === void 0 || (_columnProductAttribu = _columnProductAttribu.find(attributeValue => attributeValue.pimAttributeValue === column.name)) === null || _columnProductAttribu === void 0 ? void 0 : _columnProductAttribu.attributeValueAlias) || column.name
    }), /* @__PURE__ */jsx6("div", {
      className: "pd:grid pd:grid-cols-[repeat(auto-fit,minmax(75px,1fr))] pd:gap-4",
      children: (_row$values2 = row.values) === null || _row$values2 === void 0 ? void 0 : _row$values2.map(rowValue => {
        var _rowProductAttribute$;
        return /* @__PURE__ */jsxs4("div", {
          className: "pd:flex pd:flex-col pd:gap-2",
          children: [/* @__PURE__ */jsx6(GridInput_default, {
            columnValue: column,
            rowValue,
            groupSelection,
            setGroupSelection,
            grid,
            calculateRange: calculateRange2,
            isRangeValid: isRangeValid2,
            setAvailability
          }, rowValue.name), /* @__PURE__ */jsx6("span", {
            className: "pd:font-medium pd:text-center pd:text-sm pd:text-dim-600",
            children: (rowProductAttribute === null || rowProductAttribute === void 0 || (_rowProductAttribute$ = rowProductAttribute.values) === null || _rowProductAttribute$ === void 0 || (_rowProductAttribute$ = _rowProductAttribute$.find(attributeValue => attributeValue.pimAttributeValue === rowValue.name)) === null || _rowProductAttribute$ === void 0 ? void 0 : _rowProductAttribute$.attributeValueAlias) || rowValue.name
          })]
        }, rowValue.name);
      })
    }), /* @__PURE__ */jsx6(InventoryInfo_default, {
      availability,
      range
    })]
  }, column.name);
};

// src/components/selector/attribute-templates/QuantityGrid.tsx
import { jsx as jsx7, jsxs as jsxs5 } from "react/jsx-runtime";
var QuantityGrid = _ref278 => {
  var _column$values2, _column$values3, _row$values3;
  let {
    attribute,
    productAttributes
  } = _ref278;
  const productAttribute = getProductAttribute(productAttributes, attribute.name);
  const groupSelectionFromMachine = useSelectorMachineContext(state => state.context.group);
  const attributes = useSelectorMachineContext(state => state.context.attributes);
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const [groupSelection, setGroupSelection] = useState6(groupSelectionFromMachine);
  const {
    selectAttribute,
    calculateRange: calculateRange2,
    isRangeValid: isRangeValid2,
    getGrid
  } = useSelectorAttribute(attribute, productAttribute);
  const grid = getGrid();
  const totalQuantity = getTotalQuantity2(groupSelection);
  const isImpressto = configurationProvider8.getValue("STORE_KEY") === "impressto-fr";
  useEffect6(() => {
    if (!isEqual2(groupSelectionFromMachine, groupSelection)) {
      setGroupSelection(groupSelectionFromMachine);
    }
  }, [groupSelectionFromMachine]);
  useEffect6(() => {
    if (isImpressto && groupSelectionFromMachine.length === 0 && selectionMode === "default-values") {
      const quantityFromSelection = parseInt(currentSelection.groupedQuantity, 10);
      const defaultGroupSelectionForImpressto = getDefaultGroup(attributes, quantityFromSelection, false, remainingOptionsPerGroup, true, "M");
      selectAttribute({
        selectionType: "group",
        groupSelection: defaultGroupSelectionForImpressto,
        shouldValidate: false
      });
    }
  }, [attributes, isImpressto, currentSelection, remainingOptionsPerGroup]);
  if (!grid) {
    return null;
  }
  const {
    row,
    column
  } = grid;
  const rowProductAttribute = getProductAttribute(productAttributes, row.name);
  const columnProductAttribute = getProductAttribute(productAttributes, column.name);
  const submitAmounts = () => {
    const valid = isRangeValid2("groupedQuantity", totalQuantity);
    selectAttribute({
      selectionType: "group",
      groupSelection,
      shouldValidate: valid
    });
  };
  const showConfirmQtyButton = !isImpressto || selectionMode !== "default-values";
  return /* @__PURE__ */jsxs5("section", {
    className: "pd:flex pd:flex-col pd:gap-4 pd:py-2",
    children: [attribute.hasSizesDiffer && /* @__PURE__ */jsx7(Alert2, {
      variant: "dim",
      children: /* @__PURE__ */jsx7(FormattedMessage4, {
        id: "selector.quantityGrid.sizesDiffer",
        defaultMessage: "This product runs small. We recommend that you choose one size larger."
      })
    }), /* @__PURE__ */jsx7(LinkAsButton, {
      type: "submit",
      form: SizeTableFormId,
      onClick: () => addDataLayerEntry2("click-on-view-size-table-button"),
      variant: "secondary",
      iconBefore: "info",
      className: "pd:mb-1",
      children: /* @__PURE__ */jsx7(FormattedMessage4, {
        id: "product.show.sizetable",
        defaultMessage: "Show sizetable"
      })
    }), isImpressto ? /* @__PURE__ */jsx7("div", {
      className: "pd:flex pd:flex-col pd:gap-6",
      children: (_column$values2 = column.values) === null || _column$values2 === void 0 ? void 0 : _column$values2.map(columnValue => /* @__PURE__ */jsx7(ColumnGrid, {
        attribute,
        productAttributes,
        column: columnValue,
        groupSelection,
        setGroupSelection
      }, columnValue.id))
    }) : /* @__PURE__ */jsxs5(Table2, {
      className: "pd:border-collapse",
      children: [/* @__PURE__ */jsx7(Table2.Thead, {
        children: /* @__PURE__ */jsxs5(Table2.Tr, {
          className: "pd:text-right",
          children: [/* @__PURE__ */jsx7(Table2.Th, {
            className: "pd:border pd:border-dim-200"
          }), (_column$values3 = column.values) === null || _column$values3 === void 0 ? void 0 : _column$values3.map(value => {
            var _columnProductAttribu2;
            return /* @__PURE__ */jsx7(Table2.Th, {
              className: "pd:border pd:border-dim-200",
              children: (columnProductAttribute === null || columnProductAttribute === void 0 || (_columnProductAttribu2 = columnProductAttribute.values) === null || _columnProductAttribu2 === void 0 || (_columnProductAttribu2 = _columnProductAttribu2.find(attributeValue => attributeValue.pimAttributeValue === value.name)) === null || _columnProductAttribu2 === void 0 ? void 0 : _columnProductAttribu2.attributeValueAlias) || value.name
            }, value.id);
          })]
        })
      }), /* @__PURE__ */jsx7(Table2.Tbody, {
        children: (_row$values3 = row.values) === null || _row$values3 === void 0 ? void 0 : _row$values3.map(rowValue => {
          var _rowProductAttribute$2, _column$values4;
          return /* @__PURE__ */jsxs5(Table2.Tr, {
            className: "pd:bg-white",
            children: [/* @__PURE__ */jsx7(Table2.Td, {
              className: "pd:border pd:border-dim-200 pd:text-right",
              children: (rowProductAttribute === null || rowProductAttribute === void 0 || (_rowProductAttribute$2 = rowProductAttribute.values) === null || _rowProductAttribute$2 === void 0 || (_rowProductAttribute$2 = _rowProductAttribute$2.find(attributeValue => attributeValue.pimAttributeValue === rowValue.name)) === null || _rowProductAttribute$2 === void 0 ? void 0 : _rowProductAttribute$2.attributeValueAlias) || rowValue.name
            }), (_column$values4 = column.values) === null || _column$values4 === void 0 ? void 0 : _column$values4.map(columnValue => /* @__PURE__ */jsx7(GridInput_default, {
              columnValue,
              rowValue,
              groupSelection,
              setGroupSelection,
              grid,
              calculateRange: calculateRange2,
              isRangeValid: isRangeValid2,
              className: "pd:border pd:border-dim-200"
            }, columnValue.name))]
          }, rowValue.name);
        })
      })]
    }), showConfirmQtyButton && /* @__PURE__ */jsx7("footer", {
      className: "pd:mt-2 pd:flex pd:items-center pd:justify-end",
      children: /* @__PURE__ */jsx7(Button, {
        "data-cy": "submit-quantity",
        onClick: submitAmounts,
        disabled: totalQuantity === 0,
        children: /* @__PURE__ */jsx7(FormattedMessage4, {
          id: "selector.quantity.confirm.amounts",
          defaultMessage: "Confirm amounts"
        })
      })
    })]
  });
};
var QuantityGrid_default = QuantityGrid;

// src/components/selector/attribute-templates/Color.tsx
import { RadioSwatchGroup } from "@printdeal/ui-library";

// src/hooks/useSelectAttribute.ts
import { useRef, useCallback } from "react";
function useKeyboardMouseSelect(selectAttribute) {
  const lastKeyPressedRef = useRef(null);
  const isNavigationKey = useCallback(key => ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(key !== null && key !== void 0 ? key : ""), []);
  const handleKeyDown = useCallback(event => {
    lastKeyPressedRef.current = event.key;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      selectAttribute({
        selectionType: "attribute",
        attributeValueName: event.currentTarget.value
      });
      lastKeyPressedRef.current = null;
    }
  }, [selectAttribute]);
  const handleChange = useCallback(event => {
    const lastKey = lastKeyPressedRef.current;
    if (lastKey === "Enter" || lastKey === " " || isNavigationKey(lastKey)) {
      lastKeyPressedRef.current = null;
      return;
    }
    lastKeyPressedRef.current = null;
    selectAttribute({
      selectionType: "attribute",
      attributeValueName: event.currentTarget.value
    });
  }, [selectAttribute, isNavigationKey]);
  return {
    handleKeyDown,
    handleChange
  };
}

// src/components/selector/attribute-templates/Color.tsx
import { jsx as jsx8 } from "react/jsx-runtime";
var filteredColors = (colors, invalidValuesVisibility) => {
  if (invalidValuesVisibility === "hidden") {
    return colors.filter(_ref279 => {
      let {
        valid
      } = _ref279;
      return valid === true;
    });
  }
  return colors;
};
var Color = _ref280 => {
  let {
    attribute,
    selectorAttribute
  } = _ref280;
  const device = useSelectorMachineContext(state => state.context.device);
  const MAX_VISIBLE_COLORS = device === "mobile" ? 4 : 6;
  const {
    selectAttribute,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const colors = filteredColors(attributeValues, attribute.invalidValuesVisibility);
  const totalColors = colors.length || 0;
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const handleShowAllClick = () => {
    dispatchDataLayerEntry("selector", "click", {
      "element-type": "input",
      "element-content": "show_all_colors"
    });
  };
  if (totalColors > 0) {
    return /* @__PURE__ */jsx8(RadioSwatchGroup, {
      id: slugify(attribute.id),
      name: attribute.name,
      maxItems: MAX_VISIBLE_COLORS,
      moreButton: /* @__PURE__ */jsx8(RadioSwatchGroup.MoreButton, {
        onClick: handleShowAllClick
      }),
      children: colors.map(color => {
        var _productAttributeValu;
        const {
          productAttributeValue,
          selectorAttributeValue
        } = color;
        const checked = selectedValue === selectorAttributeValue.name;
        const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
        return /* @__PURE__ */jsx8(RadioSwatchGroup.Field, {
          id: slugify(selectorAttributeValue.id),
          value: selectorAttributeValue.name,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          checked,
          label: title,
          image: (productAttributeValue === null || productAttributeValue === void 0 || (_productAttributeValu = productAttributeValue.attributeValueImage) === null || _productAttributeValu === void 0 ? void 0 : _productAttributeValu.url) && /* @__PURE__ */jsx8("img", {
            src: "".concat(productAttributeValue.attributeValueImage.url, "?w=64&h=64&q=70&fm=png"),
            alt: title,
            width: 64,
            loading: "eager"
          })
        }, selectorAttributeValue.id);
      })
    });
  }
  return null;
};
var Color_default = Color;

// src/components/selector/attribute-templates/DeliveryTime.tsx
import cx2 from "clsx";
import { FormattedMessage as FormattedMessage5, useIntl as useIntl5 } from "react-intl";
import { Grid, RadioCard } from "@printdeal/ui-library";

// src/components/prices/Money.tsx
import { useIntl as useIntl3 } from "react-intl";
var Money = _ref281 => {
  let {
    value,
    currency = "EUR",
    showCurrency = true,
    isDiscount = false
  } = _ref281;
  const intl = useIntl3();
  const money = intl.formatNumber(value / 100, {
    currency,
    style: "currency",
    currencyDisplay: showCurrency ? "symbol" : "code"
  });
  if (isDiscount || !showCurrency) {
    return money.replace(currency, "");
  }
  return money;
};

// src/components/selector/ValueLabel.tsx
import { Badge } from "@printdeal/ui-library";
import { defineMessages as defineMessages2, useIntl as useIntl4 } from "react-intl";
import { jsx as jsx9 } from "react/jsx-runtime";
var translations2 = defineMessages2({
  eco: {
    id: "selector.label.eco",
    defaultMessage: "Sustainable"
  },
  cheapest: {
    id: "selector.label.cheapest",
    defaultMessage: "Budget"
  },
  mostchosen: {
    id: "selector.label.mostchosen",
    defaultMessage: "Most chosen"
  },
  new: {
    id: "selector.label.new",
    defaultMessage: "New"
  },
  premium: {
    id: "selector.label.premium",
    defaultMessage: "Premium"
  },
  bestPrice: {
    id: "selector.label.bestPrice",
    defaultMessage: "Best price"
  }
});
var getLabelBadge = label => {
  switch (label.type) {
    case "eco":
      return {
        variant: "success-outline",
        translation: translations2.eco
      };
    case "cheapest":
      return {
        variant: "warning",
        translation: translations2.cheapest
      };
    case "most-chosen":
      return {
        variant: "info-outline",
        translation: translations2.mostchosen
      };
    case "new":
      return {
        variant: "primary",
        translation: translations2.new
      };
    case "premium":
      return {
        variant: "primary",
        translation: translations2.premium
      };
    case "best-price":
      return {
        variant: "primary-outline",
        translation: translations2.bestPrice
      };
    default:
      return null;
  }
};
var ValueLabel = _ref282 => {
  let {
    label
  } = _ref282;
  const intl = useIntl4();
  const labelBadge = getLabelBadge(label);
  if (!labelBadge) {
    return null;
  }
  return /* @__PURE__ */jsx9(Badge, {
    variant: labelBadge.variant,
    children: intl.formatMessage(labelBadge.translation)
  });
};

// src/components/selector/attribute-templates/DeliveryTime.tsx
import { Fragment as Fragment3, jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var DeliveryTime = _ref283 => {
  let {
    attribute,
    selectorAttribute
  } = _ref283;
  const {
    invalidValuesVisibility
  } = attribute;
  const arrivalDates = useSelectorMachineContext(state => state.context.arrivalDates);
  const {
    selectAttribute,
    isPricePivot,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const intl = useIntl5();
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  return /* @__PURE__ */jsx10(Grid, {
    className: "pd:grid-cols-1 pd:gap-4 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4",
    children: attributeValues.map(value => {
      var _arrivalDates$find;
      const {
        selectorAttributeValue,
        productAttributeValue,
        valid,
        extraCosts
      } = value;
      const checked = selectorAttributeValue.name === selectedValue;
      const arrivalDate = (_arrivalDates$find = arrivalDates.find(date => date.deliveryType === selectorAttributeValue.name)) === null || _arrivalDates$find === void 0 ? void 0 : _arrivalDates$find.date;
      const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
      return /* @__PURE__ */jsx10(Grid.Item, {
        children: /* @__PURE__ */jsx10(RadioCard, {
          name: selectorAttributeValue.name,
          id: slugify(selectorAttributeValue.id),
          value: selectorAttributeValue.name,
          checked,
          className: cx2("pd:h-full", {
            "pd:hidden": !valid && (isHidden || !arrivalDate)
          }),
          label: arrivalDate && Date.parse(arrivalDate) ? /* @__PURE__ */jsx10("span", {
            className: "pd:capitalize",
            children: intl.formatDate(arrivalDate, {
              weekday: "long",
              month: "short",
              day: "numeric"
            })
          }) : void 0,
          badge: selectorAttributeValue.label && /* @__PURE__ */jsx10(ValueLabel, {
            label: selectorAttributeValue.label
          }),
          description: /* @__PURE__ */jsx10("p", {
            "data-cy": "".concat(selectorAttributeValue.id, "-description"),
            className: "pd:font-normal",
            children: isPricePivot && extraCosts !== void 0 ? /* @__PURE__ */jsx10("span", {
              children: extraCosts === 0 ? /* @__PURE__ */jsx10("span", {
                className: "pd:text-success-500",
                children: /* @__PURE__ */jsx10(FormattedMessage5, {
                  id: "selector.delivery-time.free-shipping",
                  defaultMessage: "Free"
                })
              }) : /* @__PURE__ */jsxs6(Fragment3, {
                children: [extraCosts >= 0 ? "+ " : "- ", /* @__PURE__ */jsx10(Money, {
                  value: Math.abs(extraCosts),
                  currency: "EUR"
                })]
              })
            }) : /* @__PURE__ */jsx10("span", {
              className: "pd:text-success-500",
              children: /* @__PURE__ */jsx10(FormattedMessage5, {
                id: "selector.delivery-time.free-shipping",
                defaultMessage: "Free"
              })
            })
          }),
          secondaryAction: /* @__PURE__ */jsx10("span", {
            className: "pd:text-md pd:font-normal pd:text-dim-600",
            children: title
          }),
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          validation: !valid && isFaded ? "dim" : void 0,
          validationMessage: !valid && isFaded && /* @__PURE__ */jsx10(FormattedMessage5, {
            id: "product.configurator.notPossibleInCombination",
            defaultMessage: "Not possible in combination"
          })
        })
      }, selectorAttributeValue.id);
    })
  });
};
var DeliveryTime_default = DeliveryTime;

// src/components/selector/attribute-templates/Dropdown.tsx
import { Listbox, ListboxField } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage6 } from "react-intl";

// src/components/selector/attribute-templates/PivotPrice.tsx
import cx3 from "clsx";
import { Fragment as Fragment4, jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var PivotPrice = _ref284 => {
  let {
    extraCosts,
    pricesLoading
  } = _ref284;
  if (pricesLoading) return /* @__PURE__ */jsx11("span", {
    children: "\u2014,\u2014\u2014"
  });
  return /* @__PURE__ */jsxs7("span", {
    className: cx3({
      "pd:text-success-500": extraCosts < 0
    }),
    children: [extraCosts >= 0 ? /* @__PURE__ */jsx11(Fragment4, {
      children: " + "
    }) : /* @__PURE__ */jsxs7("span", {
      className: cx3({
        "pd:text-success-500": extraCosts < 0
      }),
      children: [" ", "-", " ", " "]
    }), /* @__PURE__ */jsx11(Money, {
      value: Math.abs(extraCosts),
      currency: "EUR"
    })]
  });
};

// src/components/selector/attribute-templates/Dropdown.tsx
import { jsx as jsx12, jsxs as jsxs8 } from "react/jsx-runtime";
var Dropdown = _ref285 => {
  let {
    attribute,
    selectorAttribute
  } = _ref285;
  const {
    invalidValuesVisibility,
    id,
    name
  } = attribute;
  const {
    selectAttribute,
    attributeValues,
    selectedValue,
    generateValues,
    isRangeValid: isRangeValid2,
    contentAttribute
  } = selectorAttribute;
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const translationKey = slugify(attribute.name || attribute.pimName);
  const message = translationKey && translations[translationKey];
  const handleChange = changedValue => {
    selectAttribute({
      selectionType: "attribute",
      attributeValueName: changedValue,
      type: attribute.type
    });
  };
  const generatedValues = generateValues();
  if (generatedValues && generatedValues.length) {
    return /* @__PURE__ */jsx12(ListboxField, {
      "data-cy": "dropdown-".concat(name),
      name,
      id,
      label: (contentAttribute === null || contentAttribute === void 0 ? void 0 : contentAttribute.attributeAlias) || attribute.name,
      value: selectedValue || "",
      onChange: option => handleChange(option),
      className: "pd:w-full pd:md:w-2/3",
      children: generatedValues.map(value => {
        const valid = isRangeValid2(attribute.name, value);
        return /* @__PURE__ */jsx12(ListboxField.Option, {
          "data-cy": value,
          value: String(value),
          disabled: !valid,
          children: message ? /* @__PURE__ */jsx12(FormattedMessage6, {
            id: message.id,
            defaultMessage: message.defaultMessage,
            values: {
              value
            }
          }) : value
        }, value);
      })
    });
  }
  return /* @__PURE__ */jsx12(Listbox, {
    "data-cy": "dropdown-".concat(name),
    name,
    id,
    value: selectedValue || "",
    onChange: handleChange,
    className: "pd:w-full pd:md:w-2/3",
    children: attributeValues.map(value => {
      var _pivotPrices$name;
      const {
        productAttributeValue,
        selectorAttributeValue,
        valid,
        extraCosts
      } = value;
      const disabled = !valid && invalidValuesVisibility === "hidden";
      const isFaded = invalidValuesVisibility === "faded";
      const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
      const hasPivotPrice = Boolean((_pivotPrices$name = pivotPrices[name]) === null || _pivotPrices$name === void 0 ? void 0 : _pivotPrices$name[selectorAttributeValue.name]);
      return /* @__PURE__ */jsx12(Listbox.Option, {
        "data-cy": title,
        value: selectorAttributeValue.name,
        disabled,
        validation: !valid && isFaded ? "dim" : void 0,
        validationMessage: !valid && isFaded && /* @__PURE__ */jsx12(FormattedMessage6, {
          id: "product.configurator.notPossibleInCombination",
          defaultMessage: "Not possible in combination"
        }),
        children: /* @__PURE__ */jsxs8("div", {
          className: "pd:flex pd:items-center pd:justify-start pd:gap-4",
          children: [/* @__PURE__ */jsx12("span", {
            children: title
          }), hasPivotPrice && extraCosts !== void 0 && /* @__PURE__ */jsx12("span", {
            "data-cy": "".concat(selectorAttributeValue.id, "-description"),
            "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
            className: "text-gray-600 pd:text-md pd:font-normal",
            children: /* @__PURE__ */jsx12(PivotPrice, {
              extraCosts,
              pricesLoading
            })
          })]
        })
      }, selectorAttributeValue.id);
    })
  });
};
var Dropdown_default = Dropdown;

// src/components/selector/attribute-templates/Input.tsx
import { useEffect as useEffect7, useRef as useRef2, useState as useState7 } from "react";
import { FormattedMessage as FormattedMessage7, useIntl as useIntl6 } from "react-intl";
import { Icon, LinkAsButton as LinkAsButton2, TextField as TextField2, ValidationMessage } from "@printdeal/ui-library";
import { configurationProvider as configurationProvider9 } from "@printdeal/configuration";
import cx4 from "clsx";
import { Fragment as Fragment5, jsx as jsx13, jsxs as jsxs9 } from "react/jsx-runtime";
var Input = _ref286 => {
  var _validationAttributes, _productAttribute$att;
  let {
    attribute,
    product,
    isGroup
  } = _ref286;
  const inputRef = useRef2(null);
  const {
    formatMessage
  } = useIntl6();
  const send = useSelectorMachineSend();
  const {
    openPanel
  } = useSelectorMachineContext(state2 => state2.context.panel);
  const touchedSelection = useSelectorMachineContext(state2 => state2.context.touchedAttributes);
  const isReviewPage = useSelectorMachineContext(state2 => state2.context.isReviewPage);
  const selectionMode = useSelectorMachineContext(state2 => state2.context.selectionMode);
  const touched = touchedSelection.includes(attribute.name);
  const defaultValue = Number(attribute.defaultValue) || "";
  const productAttribute = getProductAttribute(product.attributes, attribute.name);
  const validationAttributes = useSelectorMachineContext(state2 => state2.context.productAttributes);
  const state = useSelectorState();
  const unitOfMeasure = (_validationAttributes = validationAttributes.find(_ref287 => {
    let {
      key
    } = _ref287;
    return key === attribute.name;
  })) === null || _validationAttributes === void 0 ? void 0 : _validationAttributes.unitOfMeasure;
  const [value, setValue] = useState7(defaultValue);
  const {
    calculateRange: calculateRange2,
    selectedValue,
    selectAttribute,
    isRangeValid: isRangeValid2
  } = useSelectorAttribute(attribute);
  const range = calculateRange2();
  const isInputValid = isRangeValid2(attribute.name, Number(value));
  const isImpressto = configurationProvider9.getValue("STORE_KEY") === "impressto-fr";
  const shouldShowGrid = attribute.grid && selectionMode === "default-values" && !isImpressto;
  const translatedUnitOfMeasure = unitOfMeasure && formatMessage(translations[unitOfMeasure]);
  const validate = () => {
    if (!isInputValid) {
      return "error";
    }
    if (value && isGroup && (value !== defaultValue || touched)) {
      return "success";
    }
    return void 0;
  };
  const getSuffix = () => {
    if (translatedUnitOfMeasure) {
      return translatedUnitOfMeasure;
    }
    if (!isGroup || !range) {
      return formatMessage({
        id: "selector.quantity.pieces",
        defaultMessage: "{quantity, plural, =0 {pc.} =1 {pc.} other {pcs.}}"
      }, {
        quantity: value
      });
    }
    return "";
  };
  useEffect7(() => {
    setValue(Number(selectedValue) || defaultValue);
  }, [selectedValue, defaultValue, state]);
  useEffect7(() => {
    const inputElement = inputRef.current;
    if (inputElement) {
      const handleWheel = event => {
        event.preventDefault();
      };
      inputElement.addEventListener("wheel", handleWheel, {
        passive: false
      });
      return () => {
        inputElement.removeEventListener("wheel", handleWheel);
      };
    }
    return void 0;
  }, []);
  const handleBlur = event => {
    var _event$relatedTarget;
    const hasSubmitted = ((_event$relatedTarget = event.relatedTarget) === null || _event$relatedTarget === void 0 ? void 0 : _event$relatedTarget.id) === "group-submit-button";
    if (!hasSubmitted && value && isInputValid) {
      selectAttribute({
        selectionType: "attribute",
        attributeValueName: String(value),
        type: "lor"
      });
    }
  };
  const handleGrid = () => {
    send({
      type: "Toggle panel",
      panelName: "groupedQuantity"
    });
    if (!isReviewPage) {
      dispatchDataLayerEntry("selector", "click", {
        "element-type": "button",
        "element-content": "".concat(!openPanel ? "open" : "close", "_quantity_grid")
      });
    }
  };
  const suffix = getSuffix();
  const validationMessage = range && isGroup && /* @__PURE__ */jsx13("span", {
    className: cx4("pd:text-sm", {
      "pd:text-dim-600": isInputValid,
      "pd:text-error-500": !isInputValid
    }),
    children: /* @__PURE__ */jsx13(FormattedMessage7, {
      id: "selector.unitRange.minToMaxAndUnit",
      defaultMessage: "{rangeTotalMin} t/m {rangeTotalMax} {translatedUnitOfMeasure}",
      values: {
        rangeTotalMin: range.minimum,
        rangeTotalMax: range.maximum,
        translatedUnitOfMeasure: translatedUnitOfMeasure || ""
      }
    })
  });
  return /* @__PURE__ */jsxs9(Fragment5, {
    children: [/* @__PURE__ */jsxs9("div", {
      className: cx4("pd:flex", {
        "pd:items-stretch pd:w-full": isGroup
      }, {
        "pd:items-center": !isGroup
      }),
      children: [/* @__PURE__ */jsx13(TextField2, {
        "data-testid": attribute.id,
        ref: inputRef,
        type: "number",
        className: cx4({
          "pd:w-full": isGroup,
          "pd:w-40": !isGroup,
          "pd:hidden": attribute.grid && !shouldShowGrid
        }),
        name: attribute.name,
        id: attribute.id,
        value,
        label: isGroup ? (_productAttribute$att = productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.attributeAlias) !== null && _productAttribute$att !== void 0 ? _productAttribute$att : "" : "",
        suffix,
        min: range === null || range === void 0 ? void 0 : range.minimum,
        max: range === null || range === void 0 ? void 0 : range.maximum,
        step: range === null || range === void 0 ? void 0 : range.increment,
        onBlur: handleBlur,
        onChange: event => setValue(event.target.value ? Number(event.target.value) : ""),
        validation: validate(),
        validationMessage,
        "data-hj-allow": true
      }), shouldShowGrid && /* @__PURE__ */jsx13(LinkAsButton2, {
        "data-testid": "toggle-qty-grid",
        variant: "secondary",
        className: "pd:ml-3",
        onClick: handleGrid,
        iconBefore: /* @__PURE__ */jsx13(Icon, {
          icon: openPanel ? "minus" : "plus",
          size: "xl"
        }),
        children: openPanel ? /* @__PURE__ */jsx13(FormattedMessage7, {
          id: "selector.hideSizes",
          defaultMessage: "Hide sizes"
        }) : /* @__PURE__ */jsx13(FormattedMessage7, {
          id: "selector.chooseSizes",
          defaultMessage: "Choose sizes"
        })
      })]
    }), /* @__PURE__ */jsx13(ValidationMessage, {
      variant: "error",
      className: "pd:grid pd:py-1 pd:text-sm",
      children: !isInputValid && !isGroup && /* @__PURE__ */jsx13("span", {
        "data-cy": "max-qty-error",
        children: /* @__PURE__ */jsx13(FormattedMessage7, {
          id: "selector.quantity.maxQuantity",
          values: {
            maxQuantity: range === null || range === void 0 ? void 0 : range.maximum,
            minQuantity: range === null || range === void 0 ? void 0 : range.minimum
          },
          defaultMessage: "We handle a minimum of {minQuantity} and a maximum of {maxQuantity} pieces per order for this product selection"
        })
      })
    })]
  });
};
var Input_default = Input;

// src/components/selector/attribute-templates/Radio.tsx
import { useMemo, useState as useState8 } from "react";
import { FormattedMessage as FormattedMessage9 } from "react-intl";
import cx6 from "clsx";
import { RadioGroup, LinkAsButton as LinkAsButton3 } from "@printdeal/ui-library";
import { useExperiment as useExperiment2 } from "@printdeal/feature-management/react";

// src/components/selector/SupportArticleModal.tsx
import { Collapsible, Grid as Grid2, Heading, Link, Modal as Modal2, RichText as RichText2, Spinner as Spinner2, Gallery } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage8, useIntl as useIntl8 } from "react-intl";
import { Image, Source } from "@unpic/react";
import { Suspense as Suspense2, lazy as lazy2, useEffect as useEffect8 } from "react";
import cx5 from "clsx";
import { addDataLayerEntry as addDataLayerEntry3 } from "@printdeal/data-layer-manager";
import { ErrorBoundary } from "@printdeal/error-management/react";

// src/hooks/content/useSupportArticleContent.ts
import { useQuery as useQuery5 } from "@tanstack/react-query";
var useSupportArticleContent = settings => {
  const {
    supportArticleId,
    locale,
    enabled = true
  } = settings;
  return useQuery5({
    queryKey: ["supportArticle", supportArticleId, locale],
    queryFn: async () => contentfulClient.getSupportArticleContent(supportArticleId, locale),
    enabled: enabled && Boolean(supportArticleId)
  });
};

// src/hooks/content/useSystemPageContent.ts
import { useQuery as useQuery6 } from "@tanstack/react-query";
var useSystemPageContent = settings => {
  const {
    systemPageType,
    locale,
    enabled = true
  } = settings;
  return useQuery6({
    queryKey: ["systemPage", systemPageType, locale],
    queryFn: async () => contentfulClient.getSystemPageContent(systemPageType, locale),
    enabled: enabled && Boolean(systemPageType)
  });
};

// src/components/ErrorComponent.tsx
import { useIntl as useIntl7 } from "react-intl";
import { jsx as jsx14, jsxs as jsxs10 } from "react/jsx-runtime";
var ErrorComponent = _ref288 => {
  let {
    debugId
  } = _ref288;
  const intl = useIntl7();
  return /* @__PURE__ */jsxs10("div", {
    className: "pd:border-red-500 pd:bg-red-50 pd:text-red-700 pd:rounded-md pd:border pd:p-4",
    children: [/* @__PURE__ */jsx14("p", {
      className: "pd:font-medium",
      children: intl.formatMessage({
        id: "error.component.heading",
        defaultMessage: "We encountered an error"
      })
    }), /* @__PURE__ */jsxs10("p", {
      className: "pd:mt-1 pd:text-sm",
      children: [intl.formatMessage({
        id: "error.component.title",
        defaultMessage: "Please try again later or contact support with this Debug ID:"
      }), debugId]
    })]
  });
};

// src/components/selector/SupportArticleModal.tsx
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var Markdown2 = lazy2(() => import("@printdeal/markdown/react").then(module => ({
  default: module.Markdown
})));
var getSupportArticleUrl = (helpCenterSlug, categorySlug, slug, pathLocale) => {
  if (typeof window === "undefined" || !helpCenterSlug || !slug || !pathLocale) return void 0;
  const url = new URL(window.location.origin);
  if (categorySlug) {
    url.pathname = "".concat(pathLocale, "/").concat(helpCenterSlug, "/").concat(categorySlug, "/").concat(slug);
  } else {
    url.pathname = "".concat(pathLocale, "/").concat(helpCenterSlug, "/").concat(slug);
  }
  return url.toString();
};
var SupportArticleModal = _ref289 => {
  var _supportArticle$title;
  let {
    supportArticleId,
    show,
    onClose
  } = _ref289;
  const intl = useIntl8();
  const {
    locale
  } = intl;
  const {
    data: supportArticle,
    status
  } = useSupportArticleContent({
    supportArticleId,
    locale,
    enabled: show
  });
  const showReadMore = Boolean((supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.content) && supportArticle.slug);
  const {
    data: systemPage
  } = useSystemPageContent({
    locale,
    systemPageType: "helpCenterIndex",
    enabled: showReadMore && show
  });
  const fullArticleUrl = getSupportArticleUrl(systemPage === null || systemPage === void 0 ? void 0 : systemPage.slug, supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.categorySlug, supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.slug, locale.substring(0, 2));
  useEffect8(() => {
    if (show && supportArticleId) {
      addDataLayerEntry3("support-article-open", {
        supportArticleId
      });
    }
    return () => {
      if (show && supportArticleId) {
        addDataLayerEntry3("support-article-close", {
          supportArticleId
        });
      }
    };
  }, []);
  return /* @__PURE__ */jsxs11(Modal2, {
    size: "xl",
    title: (_supportArticle$title = supportArticle === null || supportArticle === void 0 ? void 0 : supportArticle.title) !== null && _supportArticle$title !== void 0 ? _supportArticle$title : intl.formatMessage({
      id: "selector.supportArticle.modal.title.loading",
      defaultMessage: "Loading..."
    }),
    onClose,
    isOpen: show,
    dismissLabel: intl.formatMessage({
      id: "general.alert.dismiss",
      defaultMessage: "Dismiss"
    }),
    children: [status === "pending" && /* @__PURE__ */jsx15(Modal2.Content, {
      className: "pd:flex pd:h-96 pd:items-center pd:justify-center",
      children: /* @__PURE__ */jsx15(Spinner2, {
        screenReaderLabel: intl.formatMessage({
          id: "selector.supportArticle.modal.content.loading",
          defaultMessage: "Loading..."
        })
      })
    }), status === "success" && supportArticle && /* @__PURE__ */jsx15(Modal2.Content, {
      children: /* @__PURE__ */jsx15(ErrorBoundary, {
        as: ErrorComponent,
        children: /* @__PURE__ */jsxs11(Grid2, {
          className: "pd:grid-cols-1 pd:gap-4 pd:lg:grid-cols-5",
          children: [supportArticle.gallery && supportArticle.gallery.images.length && /* @__PURE__ */jsx15(Grid2.Item, {
            className: "pd:col-span-2",
            children: /* @__PURE__ */jsxs11(Gallery, {
              id: supportArticle.gallery.id,
              prevButton: /* @__PURE__ */jsx15(Gallery.Button, {
                variant: "prev",
                screenReaderLabel: "Previous",
                onClick: () => addDataLayerEntry3("support-article-gallery-prev", {
                  supportArticleId
                })
              }),
              nextButton: /* @__PURE__ */jsx15(Gallery.Button, {
                variant: "next",
                screenReaderLabel: "Next",
                onClick: () => addDataLayerEntry3("support-article-gallery-next", {
                  supportArticleId
                })
              }),
              className: "pd:grid pd:gap-4",
              children: [/* @__PURE__ */jsx15(Gallery.Root, {
                children: supportArticle.gallery.images.map((image, index) => /* @__PURE__ */jsx15(Gallery.Item, {
                  children: /* @__PURE__ */jsxs11("picture", {
                    "data-zoom": image.url,
                    children: [["avif", "webp", null].map(format => /* @__PURE__ */jsx15(Source, {
                      type: format && "image/".concat(format),
                      src: image.url,
                      layout: "fullWidth",
                      breakpoints: [150, 260, 450, 740]
                    }, "support-article-gallery-img-".concat(format || "default"))), /* @__PURE__ */jsx15(Image, {
                      priority: index === 0,
                      alt: image.title,
                      src: image.url,
                      breakpoints: [150, 260, 450, 740],
                      layout: "fullWidth",
                      className: "pd:cover-parent"
                    })]
                  }, "support-article-gallery-img-".concat(image.url))
                }, image.id))
              }), /* @__PURE__ */jsx15(Gallery.Navigation, {
                maxItems: 4,
                className: "pd:mt-6",
                children: supportArticle.gallery.images.map((image, index) => /* @__PURE__ */jsx15(Gallery.Navigation.Item, {
                  children: /* @__PURE__ */jsx15(Image, {
                    className: "thumbs pd:cover-parent",
                    layout: "constrained",
                    src: image.url,
                    aspectRatio: 1,
                    alt: image.title,
                    priority: index < 4,
                    breakpoints: [48, 92],
                    width: image.width,
                    cdn: "contentful"
                  }, image.id)
                }, image.id))
              })]
            })
          }), supportArticle.heroImage && !supportArticle.gallery && /* @__PURE__ */jsx15(Grid2.Item, {
            className: "pd:col-span-2",
            children: /* @__PURE__ */jsx15(Image, {
              breakpoints: [200, 300, 400, 600, 700],
              priority: true,
              alt: supportArticle.heroImage.title,
              src: supportArticle.heroImage.url,
              width: supportArticle.heroImage.width,
              height: supportArticle.heroImage.height,
              layout: "constrained"
            })
          }), /* @__PURE__ */jsx15(Grid2.Item, {
            className: cx5("pd:lg:col-span-3", {
              "pd:lg:col-span-5": !supportArticle.heroImage && !supportArticle.gallery
            }),
            children: /* @__PURE__ */jsxs11(Grid2, {
              className: "pd:gap-2",
              children: [supportArticle.summary && /* @__PURE__ */jsx15(Grid2.Item, {
                children: /* @__PURE__ */jsx15(Suspense2, {
                  fallback: /* @__PURE__ */jsx15(Spinner2, {
                    screenReaderLabel: intl.formatMessage({
                      id: "selector.sizetable.modal.content.loading",
                      defaultMessage: "Loading..."
                    })
                  }),
                  children: /* @__PURE__ */jsx15(RichText2, {
                    as: Markdown2,
                    children: supportArticle.summary
                  })
                })
              }), showReadMore && /* @__PURE__ */jsx15(Grid2.Item, {
                children: /* @__PURE__ */jsx15(Link, {
                  variant: "primary",
                  href: fullArticleUrl,
                  onClick: () => addDataLayerEntry3("support-article-read-more", {
                    supportArticleId
                  }),
                  target: "_blank",
                  rel: "noreferrer",
                  children: /* @__PURE__ */jsx15(FormattedMessage8, {
                    id: "helpcenter.support.article.read.all",
                    defaultMessage: "Read full article"
                  })
                })
              }), supportArticle.faqs.length > 0 && /* @__PURE__ */jsx15(Grid2.Item, {
                children: /* @__PURE__ */jsxs11(Grid2, {
                  className: "pd:gap-2",
                  children: [/* @__PURE__ */jsx15(Grid2.Item, {
                    children: /* @__PURE__ */jsx15(Heading, {
                      as: "h5",
                      size: "2",
                      variant: "display",
                      children: /* @__PURE__ */jsx15(FormattedMessage8, {
                        id: "helpcenter.support.faq.title",
                        defaultMessage: "Frequently Asked Questions"
                      })
                    })
                  }), supportArticle.faqs.map(faq => /* @__PURE__ */jsx15(Grid2.Item, {
                    children: /* @__PURE__ */jsxs11(Collapsible, {
                      id: faq.id,
                      variant: "secondary",
                      children: [/* @__PURE__ */jsx15(Collapsible.Header, {
                        title: faq.title
                      }), /* @__PURE__ */jsx15(Collapsible.Panel, {
                        children: /* @__PURE__ */jsx15(Suspense2, {
                          fallback: /* @__PURE__ */jsx15(Spinner2, {
                            screenReaderLabel: intl.formatMessage({
                              id: "selector.sizetable.modal.content.loading",
                              defaultMessage: "Loading..."
                            })
                          }),
                          children: /* @__PURE__ */jsx15(RichText2, {
                            as: Markdown2,
                            children: faq.content
                          })
                        })
                      })]
                    }, faq.id)
                  }))]
                })
              })]
            })
          })]
        })
      })
    })]
  });
};

// src/components/selector/attribute-templates/Radio.tsx
import { Fragment as Fragment6, jsx as jsx16, jsxs as jsxs12 } from "react/jsx-runtime";
var RadioValue = _ref290 => {
  let {
    title,
    checked,
    value,
    handleChange,
    handleKeyDown,
    invalidValuesVisibility,
    pricesLoading,
    hasPivotPrice,
    isCheapest,
    isInExperimentVariant
  } = _ref290;
  const [showSupportArticleModal, setShowSupportArticleModal] = useState8(false);
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  const {
    selectorAttributeValue,
    productAttributeValue,
    valid,
    extraCosts
  } = value;
  const bestPriceLabel = isCheapest && isInExperimentVariant ? {
    type: "best-price"
  } : void 0;
  const badgeLabel = bestPriceLabel || selectorAttributeValue.label;
  const badge = badgeLabel ? /* @__PURE__ */jsx16(ValueLabel, {
    label: badgeLabel
  }) : void 0;
  return /* @__PURE__ */jsx16(RadioGroup.Field, {
    id: slugify(selectorAttributeValue.id),
    value: selectorAttributeValue.name,
    className: cx6({
      "pd:hidden": !valid && isHidden
    }),
    label: title,
    description: hasPivotPrice && extraCosts !== void 0 && /* @__PURE__ */jsx16("p", {
      "data-testid": "".concat(selectorAttributeValue.id, "-description"),
      children: /* @__PURE__ */jsx16("span", {
        "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
        className: "text-gray-600 pd:text-md pd:font-normal",
        children: /* @__PURE__ */jsx16(PivotPrice, {
          extraCosts,
          pricesLoading
        })
      })
    }),
    badge,
    secondaryAction: (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.supportArticle) && /* @__PURE__ */jsxs12(Fragment6, {
      children: [/* @__PURE__ */jsx16(LinkAsButton3, {
        variant: "secondary",
        iconBefore: "info",
        onClick: () => setShowSupportArticleModal(true),
        children: /* @__PURE__ */jsx16(FormattedMessage9, {
          id: "general.selector.moreInfo",
          defaultMessage: "More info"
        })
      }), showSupportArticleModal && /* @__PURE__ */jsx16(SupportArticleModal, {
        supportArticleId: productAttributeValue.supportArticle.id,
        show: showSupportArticleModal,
        onClose: () => setShowSupportArticleModal(false)
      })]
    }),
    checked,
    onChange: handleChange,
    onKeyDown: handleKeyDown,
    validation: !valid && isFaded ? "dim" : void 0,
    validationMessage: !valid && isFaded && /* @__PURE__ */jsx16(FormattedMessage9, {
      id: "product.configurator.notPossibleInCombination",
      defaultMessage: "Not possible in combination"
    })
  });
};
var Radio = _ref291 => {
  let {
    attribute,
    selectorAttribute
  } = _ref291;
  const {
    invalidValuesVisibility,
    disablePopularOptions,
    id,
    name
  } = attribute;
  const {
    selectAttribute,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const isPopularOptionsDisabled = disablePopularOptions || selectionMode === "default-values";
  const {
    isInitialized,
    experiment
  } = useExperiment2("exp1928_ppag_printing_colors_best_option", () => {});
  const isInExperimentVariant = Boolean(isInitialized && experiment.variation === "variant");
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const cheapestOptionName = useMemo(() => findCheapestOption(attribute.name, attributeValues), [attribute.name, attributeValues]);
  return /* @__PURE__ */jsx16(RadioGroup, {
    id: "".concat(slugify(id), "-radio-group"),
    name: "".concat(name, "-radio-group"),
    maxItems: isPopularOptionsDisabled ? attributeValues.length : 4,
    moreButton: /* @__PURE__ */jsx16(RadioGroup.MoreButton, {
      children: /* @__PURE__ */jsx16(FormattedMessage9, {
        id: "general.selector.showMore",
        defaultMessage: "Show more"
      })
    }),
    children: attributeValues.map(value => {
      var _pivotPrices$name2;
      const {
        productAttributeValue,
        selectorAttributeValue
      } = value;
      const checked = selectedValue === selectorAttributeValue.name;
      const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
      const hasPivotPrice = Boolean((_pivotPrices$name2 = pivotPrices[name]) === null || _pivotPrices$name2 === void 0 ? void 0 : _pivotPrices$name2[selectorAttributeValue.name]);
      const isCheapest = selectorAttributeValue.name === cheapestOptionName;
      return /* @__PURE__ */jsx16(RadioValue, {
        value,
        checked,
        handleChange,
        handleKeyDown,
        invalidValuesVisibility,
        title,
        pricesLoading,
        hasPivotPrice,
        isCheapest,
        isInExperimentVariant
      }, selectorAttributeValue.id);
    })
  });
};
var Radio_default = Radio;

// src/components/selector/attribute-templates/Thumbnail.tsx
import { useMemo as useMemo2, useState as useState9 } from "react";
import { FormattedMessage as FormattedMessage10, useIntl as useIntl9 } from "react-intl";
import cx7 from "clsx";
import { LinkAsButton as LinkAsButton4, RadioCardGroup } from "@printdeal/ui-library";
import { Image as Image2 } from "@unpic/react";
import { useExperiment as useExperiment3 } from "@printdeal/feature-management/react";
import { Fragment as Fragment7, jsx as jsx17, jsxs as jsxs13 } from "react/jsx-runtime";
var ThumbnailValue = _ref292 => {
  var _productAttributeValu2;
  let {
    title,
    checked,
    isPricePivot,
    hasPivotPrice,
    value,
    invalidValuesVisibility,
    pricesLoading,
    handleChange,
    isCheapest,
    isInExperimentVariant,
    handleKeyDown
  } = _ref292;
  const {
    formatMessage
  } = useIntl9();
  const [showSupportArticleModal, setShowSupportArticleModal] = useState9(false);
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  const toggleModal = () => setShowSupportArticleModal(!showSupportArticleModal);
  const {
    selectorAttributeValue,
    productAttributeValue,
    valid,
    extraCosts
  } = value;
  const cheapestLabel = isCheapest && isInExperimentVariant ? {
    type: "best-price"
  } : void 0;
  const badgeLabel = cheapestLabel || selectorAttributeValue.label;
  const badge = badgeLabel ? /* @__PURE__ */jsx17(ValueLabel, {
    label: badgeLabel
  }) : void 0;
  return /* @__PURE__ */jsxs13(Fragment7, {
    children: [/* @__PURE__ */jsx17(RadioCardGroup.Field, {
      id: slugify(selectorAttributeValue.id),
      value: selectorAttributeValue.name,
      className: cx7({
        "pd:hidden": !valid && isHidden
      }),
      label: /* @__PURE__ */jsx17("span", {
        "data-invalid-message": formatMessage({
          id: "product.configurator.notPossibleInCombination",
          defaultMessage: "Not possible in combination"
        }),
        children: title
      }),
      image: (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueImage) && /* @__PURE__ */jsx17(Image2, {
        loading: "eager",
        layout: "constrained",
        src: productAttributeValue.attributeValueImage.url,
        alt: title,
        width: Math.max(productAttributeValue.attributeValueImage.width, 200),
        height: Math.max(productAttributeValue.attributeValueImage.height, 200),
        breakpoints: [260, 315, 360],
        cdn: "contentful"
      }),
      badge,
      description: (isPricePivot || hasPivotPrice) && extraCosts !== void 0 && /* @__PURE__ */jsx17("p", {
        "data-testid": "".concat(selectorAttributeValue.id, "-description"),
        children: /* @__PURE__ */jsx17("span", {
          "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
          className: "text-gray-600 pd:text-md pd:font-normal",
          children: /* @__PURE__ */jsx17(PivotPrice, {
            extraCosts,
            pricesLoading
          })
        })
      }),
      secondaryAction: (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.supportArticle) && /* @__PURE__ */jsx17(LinkAsButton4, {
        variant: "secondary",
        iconBefore: "info",
        onClick: toggleModal,
        children: /* @__PURE__ */jsx17(FormattedMessage10, {
          id: "general.selector.moreInfo",
          defaultMessage: "More info"
        })
      }),
      checked,
      onChange: handleChange,
      onKeyDown: handleKeyDown,
      validation: !valid && !isPricePivot && isFaded ? "dim" : void 0,
      validationMessage: !valid && !isPricePivot && isFaded && /* @__PURE__ */jsx17(FormattedMessage10, {
        id: "product.configurator.notPossibleInCombination",
        defaultMessage: "Not possible in combination"
      })
    }), showSupportArticleModal && /* @__PURE__ */jsx17(SupportArticleModal, {
      supportArticleId: productAttributeValue === null || productAttributeValue === void 0 || (_productAttributeValu2 = productAttributeValue.supportArticle) === null || _productAttributeValu2 === void 0 ? void 0 : _productAttributeValu2.id,
      show: showSupportArticleModal,
      onClose: () => setShowSupportArticleModal(false)
    })]
  });
};
var Thumbnail = _ref293 => {
  let {
    attribute,
    selectorAttribute
  } = _ref293;
  const {
    invalidValuesVisibility,
    disablePopularOptions,
    name
  } = attribute;
  const {
    selectAttribute,
    isPricePivot,
    attributeValues,
    selectedValue
  } = selectorAttribute;
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const isExp1574 = useSelectorMachineContext(state => state.context.isExp1574);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const isPopularOptionsDisabled = disablePopularOptions || selectionMode === "default-values";
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const {
    isInitialized,
    experiment
  } = useExperiment3("exp1928_ppag_printing_colors_best_option", () => {});
  const isInExperimentVariant = Boolean(isInitialized && experiment.variation === "variant");
  const cheapestOptionName = useMemo2(() => findCheapestOption(attribute.name, attributeValues), [attribute.name, attributeValues]);
  return /* @__PURE__ */jsx17(RadioCardGroup, {
    id: "".concat(slugify(attribute.id), "-radio-group"),
    name: "".concat(attribute.name, "-radio-group"),
    maxItems: isPopularOptionsDisabled ? attributeValues.length : 4,
    moreButton: /* @__PURE__ */jsx17(RadioCardGroup.MoreButton, {
      children: /* @__PURE__ */jsx17(FormattedMessage10, {
        id: "general.selector.showMore",
        defaultMessage: "Show more"
      })
    }),
    children: /* @__PURE__ */jsx17(RadioCardGroup.Fields, {
      className: cx7("pd:grid-cols-1 pd:gap-4", {
        // EXP1574 - selector on printing colors.
        "pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4": !isPricePivot || attribute.name === "Printing Colors",
        "pd:@xs:grid-cols-2": isPricePivot
      }),
      children: attributeValues.map(value => {
        var _pivotPrices$name3;
        const {
          selectorAttributeValue,
          productAttributeValue
        } = value;
        const checked = selectedValue === selectorAttributeValue.name;
        const title = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
        const {
          experimentProductAttributeValue
        } = value;
        const hasRenamedAttributeValue = isExp1574 && experimentProductAttributeValue;
        const isCheapest = value.selectorAttributeValue.name === cheapestOptionName;
        const hasPivotPrice = Boolean((_pivotPrices$name3 = pivotPrices[name]) === null || _pivotPrices$name3 === void 0 ? void 0 : _pivotPrices$name3[selectorAttributeValue.name]);
        return /* @__PURE__ */jsx17(ThumbnailValue, {
          title: hasRenamedAttributeValue ? experimentProductAttributeValue : title,
          checked,
          isPricePivot,
          hasPivotPrice,
          value,
          invalidValuesVisibility,
          pricesLoading,
          handleChange,
          isCheapest,
          isInExperimentVariant,
          handleKeyDown
        }, selectorAttributeValue.id);
      })
    })
  });
};
var Thumbnail_default = Thumbnail;

// src/components/selector/attribute-templates/Group.tsx
import { Button as Button2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage11 } from "react-intl";

// src/components/selector/attribute-templates/GroupItem.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
var GroupItem = _ref294 => {
  let {
    groupItemAttribute,
    product
  } = _ref294;
  const productAttribute = getProductAttribute(product.attributes, groupItemAttribute.name);
  const selectorAttribute = useSelectorAttribute(groupItemAttribute, productAttribute);
  return /* @__PURE__ */jsx18(AttributeTemplate, {
    configurationAttribute: groupItemAttribute,
    selectorAttribute,
    product,
    isGroup: true
  });
};

// src/components/selector/attribute-templates/Group.tsx
import { jsx as jsx19, jsxs as jsxs14 } from "react/jsx-runtime";
var Group = _ref295 => {
  let {
    attribute,
    product
  } = _ref295;
  const state = useSelectorState();
  const {
    selectAttribute
  } = useSelectorAttribute(attribute);
  if (attribute.type !== "group") return null;
  const attributes = attribute.attributes.filter(groupedAttribute => groupedAttribute.template !== "hidden");
  const handleSubmit = event => {
    event.preventDefault();
    const formValid = attributes.every(groupAttribute => {
      const element = event.currentTarget[groupAttribute.name];
      return element.value && !(element.ariaInvalid === "true");
    });
    if (formValid) {
      const groupedAttributes = attributes.reduce((validAttributes, validAttribute) => _objectSpread(_objectSpread({}, validAttributes), {}, {
        [validAttribute.name]: event.currentTarget[validAttribute.name].value
      }), {});
      selectAttribute({
        selectionType: "attributeGroup",
        groupedAttributes,
        groupName: attribute.name
      });
    }
  };
  return /* @__PURE__ */jsxs14("form", {
    "data-cy": "group-form",
    onSubmit: handleSubmit,
    children: [/* @__PURE__ */jsx19("div", {
      className: "pd:flex pd:gap-5",
      children: attributes.map(groupItemAttribute => /* @__PURE__ */jsx19(GroupItem, {
        groupItemAttribute,
        product
      }, groupItemAttribute.id))
    }), /* @__PURE__ */jsx19("footer", {
      className: "pd:mb-3 pd:mt-4 pd:flex pd:w-full pd:justify-end",
      children: /* @__PURE__ */jsx19(Button2, {
        type: "submit",
        id: "group-submit-button",
        isLoading: state === "loading",
        children: /* @__PURE__ */jsx19(FormattedMessage11, {
          id: "product.configurator.btn.calculate",
          defaultMessage: "Calculate"
        })
      })
    })]
  });
};
var Group_default = Group;

// src/components/selector/attribute-templates/Scene.tsx
import { useMemo as useMemo3 } from "react";
import { RadioCardGroup as RadioCardGroup2 } from "@printdeal/ui-library";
import cx8 from "clsx";
import { FormattedMessage as FormattedMessage13 } from "react-intl";

// src/hooks/useScenePreviews.ts
import { usePreviews } from "@printdeal/previews";
var useScenePreview = _ref296 => {
  let {
    productId,
    currentColor,
    attributeName
  } = _ref296;
  const shouldReturnPreviews = Boolean(productId && currentColor);
  const defaultSelection = useSelectorMachineContext(state => state.context.selection);
  const {
    data,
    error,
    isLoading
  } = usePreviews({
    mcpSku: productId,
    mcpAttributes: _objectSpread(_objectSpread({}, defaultSelection), {}, {
      [attributeName]: currentColor
    }),
    variant: "scene"
  });
  if (!shouldReturnPreviews) {
    return {
      preview: null,
      isLoading: false,
      error: null
    };
  }
  return {
    preview: error || !(data !== null && data !== void 0 && data[0]) ? null : data[0],
    isLoading,
    error
  };
};

// src/components/selector/attribute-templates/ScenePreview.tsx
import { Preview } from "@printdeal/previews";
import { FormattedMessage as FormattedMessage12 } from "react-intl";
import { jsx as jsx20 } from "react/jsx-runtime";
var PreviewSkeleton = () => /* @__PURE__ */jsx20("div", {
  className: "pd:w-full pd:animate-pulse pd:rounded-md pd:bg-dim-200",
  style: {
    aspectRatio: "1/1",
    minHeight: "120px"
  },
  "aria-label": "Loading preview..."
});
var DOCUMENT_REFERENCE_URL = "https://uds.documents.cimpress.io/v3/documents/6284ca9a-0b04-4346-9039-5256838b8e9f/docref";
var ScenePreview = _ref297 => {
  let {
    isLoading,
    preview,
    error
  } = _ref297;
  if (isLoading) {
    return /* @__PURE__ */jsx20(PreviewSkeleton, {});
  }
  if (preview) {
    return /* @__PURE__ */jsx20(Preview, {
      documentReferenceUrl: DOCUMENT_REFERENCE_URL,
      view: preview
    });
  }
  if (error) {
    return /* @__PURE__ */jsx20("div", {
      className: "pd:text-gray-500 pd:p-4 pd:text-sm",
      children: /* @__PURE__ */jsx20(FormattedMessage12, {
        id: "selector.scene.previewUnavailable",
        defaultMessage: "Preview unavailable"
      })
    });
  }
  return /* @__PURE__ */jsx20("div", {
    className: "pd:text-gray-500 pd:p-4 pd:text-sm",
    children: /* @__PURE__ */jsx20(FormattedMessage12, {
      id: "selector.scene.noPreviewAvailable",
      defaultMessage: "No preview available"
    })
  });
};

// src/components/selector/attribute-templates/Scene.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var SceneCard = _ref298 => {
  var _attributeValue$produ, _attributeValue$produ2;
  let {
    title,
    checked,
    onChange,
    onKeyDown,
    hasPivotPrice,
    attributeValue,
    attributeName,
    product,
    invalidValuesVisibility,
    pricesLoading
  } = _ref298;
  const {
    selectorAttributeValue,
    valid,
    extraCosts
  } = attributeValue;
  const isFaded = invalidValuesVisibility === "faded";
  const isHidden = invalidValuesVisibility === "hidden";
  const productId = product.isPimProduct ? product.key : product.mcpSku;
  const {
    preview,
    isLoading,
    error
  } = useScenePreview({
    productId,
    currentColor: (_attributeValue$produ = (_attributeValue$produ2 = attributeValue.productAttributeValue) === null || _attributeValue$produ2 === void 0 ? void 0 : _attributeValue$produ2.pimAttributeValue) !== null && _attributeValue$produ !== void 0 ? _attributeValue$produ : "",
    attributeName
  });
  return /* @__PURE__ */jsx21(RadioCardGroup2.Field, {
    id: slugify("".concat(attributeName, "-").concat(selectorAttributeValue.id)),
    className: cx8({
      "pd:hidden": !valid && isHidden
    }),
    value: selectorAttributeValue.name,
    onChange,
    onKeyDown,
    checked,
    label: title,
    image: /* @__PURE__ */jsx21(ScenePreview, {
      isLoading,
      preview,
      error
    }),
    description: hasPivotPrice && extraCosts !== void 0 && /* @__PURE__ */jsx21("p", {
      "data-testid": "".concat(selectorAttributeValue.id, "-description"),
      children: /* @__PURE__ */jsx21("span", {
        "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
        className: "text-gray-600 pd:text-md pd:font-normal",
        children: /* @__PURE__ */jsx21(PivotPrice, {
          extraCosts,
          pricesLoading
        })
      })
    }),
    validation: !valid && isFaded ? "dim" : void 0,
    validationMessage: !valid && isFaded && /* @__PURE__ */jsx21(FormattedMessage13, {
      id: "product.configurator.notPossibleInCombination",
      defaultMessage: "Not possible in combination"
    })
  });
};
var Scene = _ref299 => {
  let {
    attribute,
    selectorAttribute,
    product
  } = _ref299;
  const {
    invalidValuesVisibility,
    name
  } = attribute;
  const {
    selectAttribute,
    attributeValues,
    selectedValue,
    contentAttribute
  } = selectorAttribute;
  const {
    handleKeyDown,
    handleChange
  } = useKeyboardMouseSelect(selectAttribute);
  const filteredColors2 = useMemo3(() => attribute.invalidValuesVisibility === "hidden" ? attributeValues.filter(_ref300 => {
    let {
      valid
    } = _ref300;
    return valid;
  }) : attributeValues, [attribute.invalidValuesVisibility, attributeValues]);
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  return /* @__PURE__ */jsx21(RadioCardGroup2, {
    id: "".concat(attribute.id, "-scene-group"),
    name: "".concat(attribute.name, "-scene-group"),
    children: /* @__PURE__ */jsx21(RadioCardGroup2.Fields, {
      className: "pd:grid-cols-1 pd:gap-4 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4",
      children: filteredColors2.map(colorAttributeValue => {
        var _pivotPrices$name4;
        const {
          selectorAttributeValue,
          productAttributeValue
        } = colorAttributeValue;
        const colorName = (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.attributeValueAlias) || (productAttributeValue === null || productAttributeValue === void 0 ? void 0 : productAttributeValue.pimAttributeValue) || selectorAttributeValue.name;
        const hasPivotPrice = Boolean((_pivotPrices$name4 = pivotPrices[name]) === null || _pivotPrices$name4 === void 0 ? void 0 : _pivotPrices$name4[selectorAttributeValue.name]);
        return /* @__PURE__ */jsx21(SceneCard, {
          attributeValue: colorAttributeValue,
          attributeName: contentAttribute === null || contentAttribute === void 0 ? void 0 : contentAttribute.pimAttributeName,
          product,
          invalidValuesVisibility,
          title: colorName,
          hasPivotPrice,
          checked: selectedValue === selectorAttributeValue.name,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          pricesLoading
        }, selectorAttributeValue.id);
      })
    })
  });
};
var Scene_default = Scene;

// src/components/selector/attribute-templates/AttributeTemplate.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var AttributeTemplate = _ref301 => {
  let {
    configurationAttribute,
    selectorAttribute,
    product,
    /* This prop is used to recursively use this component in case of a group */
    isGroup = false
  } = _ref301;
  switch (configurationAttribute.template) {
    case "radio":
      return /* @__PURE__ */jsx22(Radio_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "thumbnail":
      return /* @__PURE__ */jsx22(Thumbnail_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "color":
      return /* @__PURE__ */jsx22(Color_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "dropdown":
      return /* @__PURE__ */jsx22(Dropdown_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "deliveryDate":
      return /* @__PURE__ */jsx22(DeliveryTime_default, {
        attribute: configurationAttribute,
        selectorAttribute
      });
    case "group":
      return /* @__PURE__ */jsx22(Group_default, {
        attribute: configurationAttribute,
        product
      });
    case "input":
      return /* @__PURE__ */jsx22(Input_default, {
        attribute: configurationAttribute,
        product,
        isGroup
      });
    case "scene":
      return /* @__PURE__ */jsx22(Scene_default, {
        attribute: configurationAttribute,
        product,
        selectorAttribute
      });
    default:
      return null;
  }
};

// src/helpers/attribute.ts
var removeSpecialCharacters = inputString => inputString.replace(/[^a-zA-Z0-9]/g, "").toLowerCase() || "";
var getAttributeValuesObject = featureConfig => Object.fromEntries(Object.entries(featureConfig || {}).map(_ref302 => {
  let [key, value] = _ref302;
  return [removeSpecialCharacters(key), value];
}));
var getRenamedSelectedValue = (selectedValueName, featureConfig) => {
  const strippedSelectedValue = removeSpecialCharacters(selectedValueName);
  const attributeValues = getAttributeValuesObject(featureConfig);
  return attributeValues[strippedSelectedValue];
};
var getRenamedAttributeValues = (attributeValues, configOptions) => attributeValues.map(attributeValue => {
  var _attributeValue$produ3;
  const strippedAttributeValue = removeSpecialCharacters(((_attributeValue$produ3 = attributeValue.productAttributeValue) === null || _attributeValue$produ3 === void 0 ? void 0 : _attributeValue$produ3.pimAttributeValue) || "");
  if (strippedAttributeValue in configOptions) {
    return _objectSpread(_objectSpread({}, attributeValue), {}, {
      experimentProductAttributeValue: configOptions[strippedAttributeValue]
    });
  }
  return attributeValue;
});
var getConfigSupportArticles = (attributeValues, configSupportArticles) => attributeValues.map(attributeValue => {
  if (attributeValue.productAttributeValue && attributeValue.productAttributeValue.pimAttributeValue && configSupportArticles[attributeValue.productAttributeValue.pimAttributeValue]) {
    return _objectSpread(_objectSpread({}, attributeValue), {}, {
      productAttributeValue: _objectSpread(_objectSpread({}, attributeValue.productAttributeValue), {}, {
        supportArticle: {
          id: configSupportArticles[attributeValue.productAttributeValue.pimAttributeValue]
        }
      })
    });
  }
  return attributeValue;
});

// src/components/selector/Attribute.tsx
import { jsx as jsx23, jsxs as jsxs15 } from "react/jsx-runtime";
var Attribute = _ref303 => {
  var _attribute$groupTitle, _featureConfigVariabl;
  let {
    attribute,
    product,
    index,
    filteredAttributes,
    hasPrefilledSelection
  } = _ref303;
  const {
    locale
  } = useIntl10();
  const isIdle = useSelectorState() === "idle";
  const productAttribute = useMemo4(() => getProductAttribute(product.attributes, attribute.name), [product.attributes, attribute.name]);
  const isImpressto = configurationProvider10.getValue("STORE_KEY") === "impressto-fr";
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const {
    showMessage,
    openPanel,
    panelName,
    values,
    variant,
    message
  } = useSelectorMachineContext(state => state.context.panel);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const price = useSelectorMachineContext(state => state.context.price);
  const totalQuantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const showPricePerPiece = attribute.name === "groupedQuantity" && price && totalQuantity && isIdle;
  const {
    selectedValue,
    selectedProductValue
  } = getSelectedValue(currentSelection, attribute, productAttribute);
  const showQuantityGrid = Boolean(attribute.grid) && (openPanel || isImpressto || selectionMode === "step-by-step");
  const [showSupportArticleModal, setShowSupportArticleModal] = useState10(false);
  const selectorAttribute = useSelectorAttribute(attribute, productAttribute);
  const translationKey = slugify(attribute.name || attribute.pimName);
  const valueMessage = translationKey && translations[translationKey];
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes,
    attributeName: attribute.name,
    attributeIndex: index,
    selectedValue,
    hasPrefilledSelection
  });
  const title = (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.attributeAlias) || (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.pimAttributeName) || ((_attribute$groupTitle = attribute.groupTitle) === null || _attribute$groupTitle === void 0 ? void 0 : _attribute$groupTitle[locale]);
  const attributeName = (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.pimAttributeName) || attribute.name;
  const collapsibleVariant = selectionMode === "step-by-step" ? "primary" : "secondary";
  const isExp1574 = useSelectorMachineContext(state => state.context.isExp1574);
  const {
    featureConfig: renameAttributeValuesConfig
  } = useFeatureConfig("rename_attribute_values");
  const featureConfigVariables = renameAttributeValuesConfig.variables;
  const renamedSelectedAttributeValue = selectedValue && featureConfigVariables[attribute.name] && getRenamedSelectedValue(selectedValue.name, (_featureConfigVariabl = featureConfigVariables[attribute.name]) === null || _featureConfigVariabl === void 0 ? void 0 : _featureConfigVariabl[locale]);
  const {
    featureConfig: supportArticlesConfig
  } = useFeatureConfig("exp1574_support_articles_on_printing_colors");
  const supportArticlesConfigVariables = supportArticlesConfig.variables;
  const experimentSelectorAttribute = klona(selectorAttribute);
  if (isExp1574 && featureConfigVariables[attribute.name]) {
    var _featureConfigVariabl2;
    const attributeValuesObject = getAttributeValuesObject((_featureConfigVariabl2 = featureConfigVariables[attribute.name]) === null || _featureConfigVariabl2 === void 0 ? void 0 : _featureConfigVariabl2[locale]);
    experimentSelectorAttribute.attributeValues = getRenamedAttributeValues(selectorAttribute.attributeValues, attributeValuesObject);
    if (attribute.id === "Printing_Colors___LOV") {
      experimentSelectorAttribute.attributeValues = getConfigSupportArticles(experimentSelectorAttribute.attributeValues, supportArticlesConfigVariables);
    }
  }
  const alertRef = useRef3(null);
  useEffect9(() => {
    if (message) {
      var _alertRef$current;
      (_alertRef$current = alertRef.current) === null || _alertRef$current === void 0 || _alertRef$current.scrollIntoView({
        behavior: "smooth"
      });
    }
  }, [message]);
  return /* @__PURE__ */jsx23("section", {
    "data-cy": "template-content",
    children: /* @__PURE__ */jsxs15(Collapsible2, {
      id: "selector-attribute",
      "data-testid": attributeName,
      variant: collapsibleVariant,
      isOpen: open,
      defaultOpen: open,
      children: [/* @__PURE__ */jsx23(Collapsible2.Header, {
        "data-cy": "".concat(attributeName, "-collapsible-header"),
        title,
        secondaryAction: (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.supportArticle) && /* @__PURE__ */jsx23(LinkAsButton5, {
          variant: "secondary",
          onClick: () => setShowSupportArticleModal(true),
          iconBefore: "info",
          screenReaderLabel: "View more information"
        }),
        button: /* @__PURE__ */jsx23(Collapsible2.Button, {
          "data-testid": "collapse-".concat(attributeName),
          onClick: () => setOpen(!open)
        }),
        children: /* @__PURE__ */jsxs15("div", {
          className: "pd:flex pd:items-center pd:justify-between",
          children: [/* @__PURE__ */jsx23("span", {
            children: isExp1574 && renamedSelectedAttributeValue || (selectedProductValue === null || selectedProductValue === void 0 ? void 0 : selectedProductValue.attributeValueAlias) || (valueMessage && selectedValue !== null && selectedValue !== void 0 && selectedValue.name ? /* @__PURE__ */jsx23(FormattedMessage14, {
              id: valueMessage.id,
              defaultMessage: valueMessage.defaultMessage,
              values: {
                value: selectedValue.name
              }
            }) : selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.name)
          }), showPricePerPiece && isImpressto && /* @__PURE__ */jsxs15("span", {
            className: "pd:text-sm",
            children: [/* @__PURE__ */jsx23(FormattedMessage14, {
              id: "selector.attribute.groupedQuantity.price.per.piece",
              defaultMessage: "Price per piece:"
            }), " ", /* @__PURE__ */jsx23("span", {
              className: "pd:font-bold pd:text-dim-800",
              children: /* @__PURE__ */jsx23(Money, {
                value: price.totalGross.centAmount / totalQuantity,
                showCurrency: false
              })
            })]
          })]
        })
      }), /* @__PURE__ */jsxs15(Collapsible2.Panel, {
        "data-cy": "".concat(attribute.name, "-collapsible-panel"),
        children: [attribute.name === panelName && showMessage && variant && message && /* @__PURE__ */jsx23(Alert3, {
          ref: alertRef,
          variant,
          className: "pd:my-3",
          children: /* @__PURE__ */jsx23(FormattedMessage14, {
            id: message.id,
            defaultMessage: message.defaultMessage,
            values
          })
        }), /* @__PURE__ */jsx23(AttributeTemplate, {
          configurationAttribute: attribute,
          selectorAttribute: experimentSelectorAttribute,
          product
        }), showQuantityGrid && /* @__PURE__ */jsx23(QuantityGrid_default, {
          attribute,
          productAttributes: product.attributes
        })]
      }), (productAttribute === null || productAttribute === void 0 ? void 0 : productAttribute.supportArticle) && showSupportArticleModal && /* @__PURE__ */jsx23(SupportArticleModal, {
        show: showSupportArticleModal,
        onClose: () => setShowSupportArticleModal(false),
        supportArticleId: productAttribute.supportArticle.id
      })]
    })
  });
};
var Attribute_default = memo(Attribute);

// src/components/selector/attribute-templates/Prices.tsx
import { FormattedMessage as FormattedMessage15, useIntl as useIntl11 } from "react-intl";
import { Collapsible as Collapsible3, Listbox as Listbox2 } from "@printdeal/ui-library";
import { jsx as jsx24, jsxs as jsxs16 } from "react/jsx-runtime";
var ATTRIBUTE_NAME = "Quantity";
var Prices = _ref304 => {
  let {
    filteredAttributes,
    index,
    hasPrefilledSelection
  } = _ref304;
  const intl = useIntl11();
  const send = useSelectorMachineSend();
  const currentSelection = useSelectorMachineContext(state => state.context.selection);
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const quantities = useSelectorMachineContext(state => state.context.pricesPerQuantity);
  const selectedQuantity = currentSelection[ATTRIBUTE_NAME];
  const collapsibleVariant = selectionMode === "step-by-step" ? "primary" : "secondary";
  const setQuantity2 = value => {
    send({
      type: "Select attribute value",
      attributeSelection: {
        name: "Quantity",
        value
      },
      shouldValidate: true,
      valid: true
    });
  };
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes,
    attributeName: ATTRIBUTE_NAME,
    attributeIndex: index,
    selectedValue: {
      name: selectedQuantity
    },
    hasPrefilledSelection
  });
  return /* @__PURE__ */jsx24("section", {
    children: /* @__PURE__ */jsxs16(Collapsible3, {
      id: "quantity",
      variant: collapsibleVariant,
      isOpen: open,
      defaultOpen: open,
      className: "pd:mb-4",
      children: [/* @__PURE__ */jsx24(Collapsible3.Header, {
        "data-cy": "quantity-collapsible-header",
        title: intl.formatMessage({
          id: "selector.quantity.title",
          defaultMessage: "Quantity"
        }),
        button: /* @__PURE__ */jsx24(Collapsible3.Button, {
          onClick: () => setOpen(!open)
        }),
        children: /* @__PURE__ */jsx24(FormattedMessage15, {
          id: "selector.quantity.suffix",
          defaultMessage: "{value} pieces",
          values: {
            value: selectedQuantity
          }
        })
      }), /* @__PURE__ */jsx24(Collapsible3.Panel, {
        "data-cy": "quantity-collapsible-panel",
        children: /* @__PURE__ */jsx24(Listbox2, {
          "data-testid": "Quantity",
          name: "Quantity",
          value: selectedQuantity || "",
          onChange: changedQuantity => setQuantity2(changedQuantity),
          className: "pd:w-full pd:md:w-2/3",
          children: quantities.map(_ref305 => {
            let {
              quantity,
              deliveryType
            } = _ref305;
            return /* @__PURE__ */jsxs16(Listbox2.Option, {
              "data-cy": quantity,
              value: String(quantity),
              children: [quantity, " ", "-", " ", deliveryType.price && intl.formatNumber(getPriceAmount("totalNet", deliveryType.price, deliveryType.discountedPrice) / 100, {
                style: "currency",
                currencyDisplay: "symbol",
                currency: deliveryType.price.totalNet.currencyCode
              })]
            }, quantity);
          })
        })
      })]
    })
  });
};
var Prices_default = Prices;

// src/components/selector/attribute-templates/LoadingTemplate.tsx
import clsx2 from "clsx";
import { jsx as jsx25 } from "react/jsx-runtime";
var LoadingTemplate = _ref306 => {
  let {
    isGrid
  } = _ref306;
  return /* @__PURE__ */jsx25("div", {
    className: clsx2("pd:w-full pd:rounded-md pd:bg-dim-200", {
      "pd:h-[800px]": isGrid,
      "pd:h-[300px]": !isGrid
    })
  });
};

// src/components/selector/UnsetModal.tsx
import { Alert as Alert4, Button as Button3, DescriptionList, Modal as Modal3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage16, useIntl as useIntl12 } from "react-intl";
import { useEffect as useEffect10, useState as useState11 } from "react";
import { dequal as dequal4 } from "dequal";
import { jsx as jsx26, jsxs as jsxs17 } from "react/jsx-runtime";
var getAttributeTranslation = (attributes, attributeName, attributeValueName) => {
  var _getAttributeValue;
  if (!attributeName || !attributeValueName) return {};
  const attribute = getProductAttribute(attributes, attributeName);
  return {
    name: attribute === null || attribute === void 0 ? void 0 : attribute.attributeAlias,
    value: (_getAttributeValue = getAttributeValue(attributeValueName, attribute === null || attribute === void 0 ? void 0 : attribute.values)) === null || _getAttributeValue === void 0 ? void 0 : _getAttributeValue.attributeValueAlias
  };
};
var createChanges = (selection, attributes, configurationAttributes, validationResult) => {
  if (!validationResult || validationResult.state === "unresolvable" && !validationResult.violatedAttributes.length) {
    return [];
  }
  const changedAttributes = validationResult.violatedAttributes.length > 0 ? validationResult.violatedAttributes.filter(violatedAttribute => attributes.find(attribute => attribute.pimAttributeName === violatedAttribute)).map(violatedAttribute => getProductAttribute(attributes, violatedAttribute)) : attributes.filter(_ref307 => {
    let {
      pimAttributeName
    } = _ref307;
    return !pricePivotAttributes.includes(pimAttributeName);
  });
  return changedAttributes.map(attribute => {
    if (attribute) {
      var _configurationAttribu3;
      const {
        pimAttributeName,
        values,
        attributeAlias
      } = attribute;
      const defaultValue = (_configurationAttribu3 = configurationAttributes.find(_ref308 => {
        let {
          name
        } = _ref308;
        return name === pimAttributeName;
      })) === null || _configurationAttribu3 === void 0 ? void 0 : _configurationAttribu3.defaultValue;
      const currentValue = getAttributeValue(selection[pimAttributeName], values);
      const remainingOption = getResolvedAttribute(validationResult.remainingOptions, pimAttributeName);
      const newValue = (remainingOption === null || remainingOption === void 0 ? void 0 : remainingOption.values.length) === 1 && remainingOption.values[0].type === "stringLiteral" ? getAttributeValue(remainingOption.values[0].stringLiteral, values) : getAttributeValue(defaultValue, values);
      if (!dequal4(currentValue === null || currentValue === void 0 ? void 0 : currentValue.attributeValueAlias, newValue === null || newValue === void 0 ? void 0 : newValue.attributeValueAlias)) {
        return {
          attributeName: attributeAlias || pimAttributeName || void 0,
          currentValue: (currentValue === null || currentValue === void 0 ? void 0 : currentValue.attributeValueAlias) || (currentValue === null || currentValue === void 0 ? void 0 : currentValue.pimAttributeValue) || void 0,
          newValue: (newValue === null || newValue === void 0 ? void 0 : newValue.attributeValueAlias) || (newValue === null || newValue === void 0 ? void 0 : newValue.pimAttributeValue) || void 0
        };
      }
    }
    return void 0;
  }).filter(Boolean);
};
var UnsetModal = _ref309 => {
  let {
    product
  } = _ref309;
  const intl = useIntl12();
  const {
    attributes,
    key,
    isPimProduct,
    productVersion
  } = product;
  const selection = useSelectorMachineContext(state => state.context.selection);
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  const invalidSelection = useSelectorMachineContext(state => state.context.invalidSelection);
  const send = useSelectorMachineSend();
  const [validationResult, setValidationResult] = useState11();
  const changes = createChanges(selection, attributes, configurationAttributes, validationResult);
  const waitForUserConfirmation = useSelectorMachineContext(state => state.matches({
    STARTED: "WAIT FOR USER CONFIRMATION"
  }));
  const hasInvalidSelection = Object.entries(invalidSelection).length;
  const [invalidName, invalidValue] = hasInvalidSelection ? Object.entries(invalidSelection)[0] : [];
  const selectedAttribute = getAttributeTranslation(attributes, invalidName, invalidValue);
  const hasChanges = changes.length > 0;
  const validateSelection2 = async () => {
    const {
      data
    } = await validationClient.validate(key, selection, invalidSelection, {
      "x-filename": "unsetModal.tsx"
    }, isPimProduct, productVersion);
    setValidationResult(data);
  };
  const handleConfirm = () => {
    if (invalidName && invalidValue) {
      send({
        type: "Select attribute value",
        attributeSelection: {
          name: invalidName,
          value: invalidValue
        },
        shouldValidate: true,
        valid: false
      });
      dispatchDataLayerEntry("confirm-unset", "click");
    }
  };
  useEffect10(() => {
    if (waitForUserConfirmation) {
      validateSelection2();
      dispatchDataLayerEntry("show unset modal", "display", selectedAttribute);
    }
    if (waitForUserConfirmation && validationResult && validationResult.state === "unresolvable" && !validationResult.violatedAttributes.length && !hasChanges) {
      handleConfirm();
    }
  }, [waitForUserConfirmation, JSON.stringify(validationResult), hasChanges]);
  const handleCancel = () => {
    send({
      type: "Cancel unset"
    });
    dispatchDataLayerEntry("cancel-unset", "click");
  };
  if (!waitForUserConfirmation || !hasChanges) {
    return null;
  }
  return /* @__PURE__ */jsxs17(Modal3, {
    size: "lg",
    title: intl.formatMessage({
      id: "selector.product.unset.modal.title",
      defaultMessage: "This combination is not possible"
    }),
    isOpen: true,
    onClose: handleCancel,
    dismissLabel: intl.formatMessage({
      id: "general.alert.dismiss",
      defaultMessage: "Dismiss"
    }),
    children: [/* @__PURE__ */jsxs17(Modal3.Content, {
      className: "pd:grid pd:grid-cols-1 pd:gap-4",
      children: [/* @__PURE__ */jsx26(Alert4, {
        variant: "warning",
        children: /* @__PURE__ */jsx26(FormattedMessage16, {
          id: "selector.product.unset.modal.warning.message",
          defaultMessage: "The selected option is not possible with your current selection."
        })
      }), /* @__PURE__ */jsx26(FormattedMessage16, {
        id: "selector.product.unset.modal.message",
        defaultMessage: "The option that you selected {option} is not possible with your current selection. We created the following automatic selection for you:",
        values: {
          option: "(".concat(selectedAttribute.name, ": ").concat(selectedAttribute.value, ")")
        }
      }), changes.map((attribute, index) => /* @__PURE__ */jsxs17("div", {
        children: [/* @__PURE__ */jsxs17(DescriptionList, {
          children: [/* @__PURE__ */jsx26(DescriptionList.Title, {
            children: /* @__PURE__ */jsx26(FormattedMessage16, {
              id: "selector.product.unset.modal.current.message",
              defaultMessage: "{attributeName} (current selection)",
              values: {
                attributeName: attribute === null || attribute === void 0 ? void 0 : attribute.attributeName
              }
            })
          }), /* @__PURE__ */jsx26(DescriptionList.Content, {
            children: attribute !== null && attribute !== void 0 && attribute.currentValue ? attribute.currentValue : /* @__PURE__ */jsx26(FormattedMessage16, {
              id: "selector.product.unset.modal.noselect.message",
              defaultMessage: "- (Not selected)"
            })
          }), /* @__PURE__ */jsx26(DescriptionList.Title, {
            children: /* @__PURE__ */jsx26(FormattedMessage16, {
              id: "selector.product.unset.modal.new.message",
              defaultMessage: "{attributeName} (new selection)",
              values: {
                attributeName: attribute === null || attribute === void 0 ? void 0 : attribute.attributeName
              }
            })
          }), /* @__PURE__ */jsx26(DescriptionList.Content, {
            children: attribute !== null && attribute !== void 0 && attribute.newValue ? attribute.newValue : /* @__PURE__ */jsx26(FormattedMessage16, {
              id: "selector.product.unset.modal.select.message",
              defaultMessage: "- (Select again)"
            })
          })]
        }), changes.length - 1 !== index && /* @__PURE__ */jsx26("hr", {})]
      }, attribute === null || attribute === void 0 ? void 0 : attribute.attributeName))]
    }), /* @__PURE__ */jsx26(Modal3.Footer, {
      children: /* @__PURE__ */jsxs17("div", {
        className: "pd:flex pd:justify-end pd:gap-3",
        children: [/* @__PURE__ */jsx26(Button3, {
          variant: "secondary",
          onClick: handleCancel,
          children: /* @__PURE__ */jsx26(FormattedMessage16, {
            id: "selector.product.unset.modal.cancel",
            defaultMessage: "Cancel"
          })
        }), /* @__PURE__ */jsx26(Button3, {
          onClick: handleConfirm,
          children: /* @__PURE__ */jsx26(FormattedMessage16, {
            id: "selector.product.unset.modal.confirm",
            defaultMessage: "confirm new selections"
          })
        })]
      })
    })]
  });
};
var UnsetModal_default = UnsetModal;

// src/hooks/content/useSelectorExperiment.ts
import { useQuery as useQuery7 } from "@tanstack/react-query";
var useSelectorExperiment = settings => {
  const {
    productPageId,
    locale,
    enabled = true
  } = settings;
  return useQuery7({
    queryKey: ["useSelectorExperiment", productPageId, locale],
    queryFn: async () => contentfulClient.getExperimentContent(productPageId, locale),
    enabled: enabled && Boolean(productPageId)
  });
};

// src/components/selector/EasyAndAdvancedOptions.tsx
import { Grid as Grid5, Icon as Icon2, LinkAsButton as LinkAsButton7, ToggleField } from "@printdeal/ui-library";
import { useIntl as useIntl14 } from "react-intl";
import { useState as useState13 } from "react";

// src/components/selector/EasyOptions.tsx
import { Collapsible as Collapsible4, Grid as Grid4 } from "@printdeal/ui-library";
import { useIntl as useIntl13 } from "react-intl";

// src/components/selector/EasyOptionCard.tsx
import { useState as useState12 } from "react";
import { FormattedMessage as FormattedMessage17 } from "react-intl";
import { Grid as Grid3, RadioCard as RadioCard2, LinkAsButton as LinkAsButton6 } from "@printdeal/ui-library";
import { Image as Image3 } from "@unpic/react";
import { dequal as isEqual3 } from "dequal";
import { jsx as jsx27, jsxs as jsxs18 } from "react/jsx-runtime";
var EasyOptionCard = _ref310 => {
  let {
    easyOption,
    excludeAttributes,
    productAttributes,
    setSelectedEasyOption
  } = _ref310;
  const send = useSelectorMachineSend();
  const selection = useSelectorMachineContext(state => state.context.selection);
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const [showSupportArticleModal, setShowSupportArticleModal] = useState12(false);
  const excludedAttributesSelection = excludeAttributes.reduce((acc, excludeAttribute) => {
    if (excludeAttribute !== "group") {
      return _objectSpread(_objectSpread({}, acc), {}, {
        [excludeAttribute]: selection[excludeAttribute]
      });
    }
    return acc;
  }, {});
  const selectionFromUrl = getSelectionFromUrl(easyOption.selectionUrl, productAttributes);
  const groupSelectionFromUrl = getGroupFromUrl(easyOption.selectionUrl);
  const easyOptionSelection = _objectSpread(_objectSpread({}, selectionFromUrl), excludedAttributesSelection);
  const selectionAttributes = getSelectionAttributes(selection);
  const easyOptionSelectionAttributes = getSelectionAttributes(easyOptionSelection);
  const areSelectionOptionsEqual = isEqual3(selectionAttributes, easyOptionSelectionAttributes);
  const urlSelection = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, selectionFromUrl), excludedAttributesSelection), selection["Delivery Type"] && {
    "Delivery Type": selection["Delivery Type"]
  }), selection.Quantity && {
    Quantity: selection.Quantity
  });
  if (areSelectionOptionsEqual) {
    setSelectedEasyOption(easyOption.name);
  }
  const onEasyOptionSelection = () => {
    send({
      type: "Select product route",
      selection: urlSelection,
      groupSelection: groupSelectionFromUrl,
      totalQuantity: Number(urlSelection.Quantity),
      touchedAttributes: [...touchedAttributes, ...excludeAttributes]
    });
    setSelectedEasyOption(easyOption.name);
    dispatchDataLayerEntry("easy_option", "click", {
      name: easyOption.name,
      imageUrl: easyOption.image.url,
      url: easyOption.selectionUrl
    });
  };
  const handleSupportArticleModalClick = () => {
    setShowSupportArticleModal(true);
    dispatchDataLayerEntry("easy_option_more_info", "click", {
      name: easyOption.name
    });
  };
  return /* @__PURE__ */jsxs18(Grid3.Item, {
    children: [/* @__PURE__ */jsx27(RadioCard2, {
      "data-testid": "easy-option-card",
      className: "pd:h-full",
      checked: areSelectionOptionsEqual,
      id: easyOption.selectionUrl,
      name: "easy-option-".concat(easyOption.name),
      label: /* @__PURE__ */jsx27("span", {
        children: easyOption.name
      }),
      image: /* @__PURE__ */jsx27(Image3, {
        layout: "fullWidth",
        height: 200,
        src: easyOption.image.url,
        alt: easyOption.image.title
      }),
      onChange: onEasyOptionSelection,
      secondaryAction: easyOption.supportArticleId && /* @__PURE__ */jsx27(LinkAsButton6, {
        variant: "secondary",
        onClick: handleSupportArticleModalClick,
        iconBefore: "info",
        screenReaderLabel: "View more information",
        children: /* @__PURE__ */jsx27(FormattedMessage17, {
          id: "general.selector.moreInfo",
          defaultMessage: "More info"
        })
      })
    }), easyOption.supportArticleId && showSupportArticleModal && /* @__PURE__ */jsx27(SupportArticleModal, {
      show: showSupportArticleModal,
      onClose: () => setShowSupportArticleModal(false),
      supportArticleId: easyOption.supportArticleId
    })]
  });
};

// src/components/selector/EasyOptions.tsx
import { jsx as jsx28, jsxs as jsxs19 } from "react/jsx-runtime";
var EasyOptions = _ref311 => {
  let {
    easyOptions,
    excludeAttributes,
    productAttributes,
    selectedEasyOption,
    setSelectedEasyOption
  } = _ref311;
  const intl = useIntl13();
  return /* @__PURE__ */jsxs19(Collapsible4, {
    id: "price-cards-collapsible",
    isOpen: true,
    children: [/* @__PURE__ */jsx28(Collapsible4.Header, {
      title: intl.formatMessage({
        id: "selector.easyOptions.header.title",
        defaultMessage: "Type"
      }),
      children: selectedEasyOption
    }), /* @__PURE__ */jsx28(Collapsible4.Panel, {
      children: /* @__PURE__ */jsx28(Grid4, {
        className: "pd:grid-cols-1 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4 pd:gap-4",
        children: easyOptions.filter(_ref312 => {
          let {
            selectionUrl
          } = _ref312;
          return selectionUrl && productAttributes.length > 0;
        }).map(easyOption => /* @__PURE__ */jsx28(EasyOptionCard, {
          easyOption,
          excludeAttributes,
          productAttributes,
          setSelectedEasyOption
        }, easyOption.name))
      })
    })]
  });
};

// src/components/selector/EasyAndAdvancedOptions.tsx
import { Fragment as Fragment8, jsx as jsx29, jsxs as jsxs20 } from "react/jsx-runtime";
var EasyAndAdvancedOptions = _ref313 => {
  let {
    product,
    easyOptions,
    excludeAttributes,
    filteredAdvancedAttributes,
    hasPrefilledSelection,
    supportArticleId = void 0
  } = _ref313;
  const intl = useIntl14();
  const [selectedEasyOption, setSelectedEasyOption] = useState13("");
  const [showSupportArticleModal, setShowSupportArticleModal] = useState13(false);
  const [selectorOption, setselectorOption] = useState13("Easy");
  const onOptionChange = option => {
    setselectorOption(option);
    if (option === "Advanced") {
      setSelectedEasyOption("");
    }
    dispatchDataLayerEntry("change_selector_option", "click", {
      option
    });
  };
  return /* @__PURE__ */jsxs20(Fragment8, {
    children: [/* @__PURE__ */jsx29(ToggleField, {
      id: "show-advanced-options-toggle",
      name: "show-advanced-options-toggle",
      "data-cy": "show-advanced-options-toggle",
      className: "pd:justify-self-end",
      label: intl.formatMessage({
        id: "selector.showAdvancedOptions.toggle.title",
        defaultMessage: "Show advanced options"
      }),
      checked: selectorOption === "Advanced",
      onChange: checked => onOptionChange(checked ? "Advanced" : "Easy"),
      secondaryAction: supportArticleId && /* @__PURE__ */jsx29(LinkAsButton7, {
        variant: "secondary",
        onClick: () => setShowSupportArticleModal(true),
        iconBefore: /* @__PURE__ */jsx29(Icon2, {
          icon: "info",
          className: "pd:text-dim-800"
        }),
        screenReaderLabel: intl.formatMessage({
          id: "general.selector.moreInfo",
          defaultMessage: "More info"
        })
      })
    }), supportArticleId && /* @__PURE__ */jsx29(SupportArticleModal, {
      show: showSupportArticleModal,
      onClose: () => setShowSupportArticleModal(false),
      supportArticleId
    }), selectorOption === "Easy" && /* @__PURE__ */jsx29(EasyOptions, {
      easyOptions,
      excludeAttributes,
      productAttributes: product.attributes,
      selectedEasyOption,
      setSelectedEasyOption
    }), selectorOption === "Advanced" && /* @__PURE__ */jsx29(Grid5, {
      className: "pd:gap-4",
      children: filteredAdvancedAttributes.map((attribute, index) => /* @__PURE__ */jsx29(Grid5.Item, {
        children: /* @__PURE__ */jsx29(Attribute_default, {
          index,
          attribute,
          product,
          filteredAttributes: filteredAdvancedAttributes,
          hasPrefilledSelection
        })
      }, attribute.id))
    })]
  });
};

// src/components/selector/PrintingColorPricingExperiment.tsx
import { Experiment, useFeatureConfig as useFeatureConfig2 } from "@printdeal/feature-management/react";

// src/components/selector/Pricing.tsx
import { Badge as Badge2, Collapsible as Collapsible5, Heading as Heading3, RadioField, Spinner as Spinner5, TextField as TextField3, Icon as Icon3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage18, useIntl as useIntl17 } from "react-intl";
import { useContext as useContext2, useEffect as useEffect12, useState as useState15, useMemo as useMemo6 } from "react";
import cx9 from "clsx";

// src/contexts/VatModeContext.tsx
import { createContext as createContext2, useEffect as useEffect11, useMemo as useMemo5, useState as useState14 } from "react";
import { useConsent } from "@printdeal/consent-management/react";
import { jsx as jsx30 } from "react/jsx-runtime";
var STORAGE_KEY2 = "vatMode";
var VatModeContext = createContext2({
  vatMode: "totalNet",
  vatModeFromUrl: void 0,
  setVatMode: () => {}
});
var getVatModeFromUrl = () => {
  if (typeof window === "undefined") return void 0;
  const url = window.location.href;
  const location = new URL(url);
  const vatUrlValue = location.searchParams.get("vat");
  if (vatUrlValue === "excl") return "totalNet";
  if (vatUrlValue === "incl") return "totalGross";
  return void 0;
};
var VatModeProvider = _ref314 => {
  let {
    children
  } = _ref314;
  const vatModeFromUrl = getVatModeFromUrl();
  const consent = useConsent();
  const vatModeFromLocalStorage = getFromLocalStorage(STORAGE_KEY2);
  const [vatMode, setVatMode] = useState14(vatModeFromUrl || vatModeFromLocalStorage || "totalNet");
  useEffect11(() => {
    if (consent.preferences) {
      saveToLocalStorage(STORAGE_KEY2, vatMode);
    }
  }, [vatMode, consent.preferences]);
  const vatModeContext = useMemo5(() => ({
    vatMode,
    vatModeFromUrl,
    setVatMode
  }), [vatMode]);
  return /* @__PURE__ */jsx30(VatModeContext.Provider, {
    value: vatModeContext,
    children
  });
};

// src/components/prices/table/PriceTableLoading.tsx
import { Heading as Heading2, Spinner as Spinner3 } from "@printdeal/ui-library";
import { useIntl as useIntl15 } from "react-intl";
import { jsx as jsx31, jsxs as jsxs21 } from "react/jsx-runtime";
var PriceTableLoading = _ref315 => {
  let {
    showCards
  } = _ref315;
  const intl = useIntl15();
  return /* @__PURE__ */jsxs21("div", {
    "data-testid": "price-table-loading",
    className: "pd:overflow-hidden pd:rounded-md pd:border-1 pd:border-dim-200",
    children: [/* @__PURE__ */jsx31("div", {
      className: "pd:bg-dim-100 pd:p-5",
      children: /* @__PURE__ */jsx31("div", {
        className: "pd:flex pd:justify-between",
        children: /* @__PURE__ */jsxs21("div", {
          className: "pd:pr-4",
          children: [/* @__PURE__ */jsx31(Heading2, {
            as: "div",
            size: "3",
            children: "\xA0"
          }), "\xA0"]
        })
      })
    }), showCards ? /* @__PURE__ */jsx31("div", {
      className: "pd:flex pd:h-40 pd:w-full pd:items-center pd:justify-center pd:p-4",
      children: /* @__PURE__ */jsx31(Spinner3, {
        size: "lg",
        screenReaderLabel: intl.formatMessage({
          id: "uilib.spinner.loading",
          defaultMessage: "Loading..."
        })
      })
    }) : /* @__PURE__ */jsx31("table", {
      className: "pd:mb-0 pd:w-full pd:text-center",
      children: /* @__PURE__ */jsx31("tbody", {
        children: /* @__PURE__ */jsx31("tr", {
          children: /* @__PURE__ */jsx31("td", {
            className: "pd:flex pd:h-60 pd:w-full pd:items-center pd:justify-center pd:p-4",
            children: /* @__PURE__ */jsx31(Spinner3, {
              size: "lg",
              screenReaderLabel: intl.formatMessage({
                id: "uilib.spinner.loading",
                defaultMessage: "Loading..."
              })
            })
          })
        })
      })
    })]
  });
};

// src/components/selector/DeliveryDate.tsx
import { FormattedDate as FormattedDate2, useIntl as useIntl16 } from "react-intl";
import { Spinner as Spinner4 } from "@printdeal/ui-library";
import { jsx as jsx32, jsxs as jsxs22 } from "react/jsx-runtime";
var DeliveryDate = _ref316 => {
  var _deliveryDates$find;
  let {
    deliveryType
  } = _ref316;
  const intl = useIntl16();
  const deliveryDates = useSelectorMachineContext(state => state.context.deliveryDates);
  const isLoadingDeliveryDates = useMatchesState({
    STARTED: {
      "FETCHING DATA": {
        "FETCH DELIVERY DATES": "FETCHING DELIVERY DATES"
      }
    }
  });
  const deliveryDate = (_deliveryDates$find = deliveryDates.find(date => date.name === deliveryType)) === null || _deliveryDates$find === void 0 ? void 0 : _deliveryDates$find.date;
  if (isLoadingDeliveryDates) {
    return /* @__PURE__ */jsx32(Spinner4, {
      "data-testid": "spinner",
      size: "sm",
      variant: "dim",
      screenReaderLabel: intl.formatMessage({
        id: "uilib.spinner.loading",
        defaultMessage: "Loading..."
      })
    });
  }
  if (deliveryDate && Date.parse(deliveryDate)) {
    return /* @__PURE__ */jsxs22("div", {
      children: [/* @__PURE__ */jsx32("span", {
        className: "pd:mr-1",
        children: /* @__PURE__ */jsx32(FormattedDate2, {
          weekday: "short",
          value: deliveryDate
        })
      }), /* @__PURE__ */jsx32("span", {
        children: /* @__PURE__ */jsx32(FormattedDate2, {
          month: "short",
          day: "numeric",
          value: deliveryDate
        })
      })]
    });
  }
  return null;
};

// src/components/selector/Pricing.tsx
import { jsx as jsx33, jsxs as jsxs23 } from "react/jsx-runtime";
var INITIAL_QUANTITIES_TO_SHOW = 6;
var Pricing = _ref317 => {
  let {
    hasPrefilledSelection = false
  } = _ref317;
  const intl = useIntl17();
  const send = useSelectorMachineSend();
  const selectorPrices = useSelectorMachineContext(state => state.context.prices);
  const isLoadingPrices = useMatchesState({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  });
  const selectionMode = useSelectorMachineContext(state => state.context.selectionMode);
  const selectedDeliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const deliveryDates = useSelectorMachineContext(state => state.context.deliveryDates);
  const totalQuantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const pricesPerQuantity = useSelectorMachineContext(state => state.context.pricesPerQuantity);
  const attributes = useSelectorMachineContext(state => state.context.attributes);
  const remainingOptionsPerGroup = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const range = calculateRange("Quantity", remainingOptionsPerGroup);
  const minimumQuantity = range === null || range === void 0 ? void 0 : range.minimum;
  const maximumQuantity = range === null || range === void 0 ? void 0 : range.maximum;
  const {
    vatMode
  } = useContext2(VatModeContext);
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes: attributes,
    attributeName: "Pricing",
    attributeIndex: attributes.length + 1,
    selectedValue: {
      name: selectedDeliveryOption.name
    },
    hasPrefilledSelection
  });
  const [value, setValue] = useState15(0);
  const [showAllQuantities, setShowAllQuantities] = useState15(false);
  const isInputValid = value ? isRangeValid("Quantity", remainingOptionsPerGroup, value) : true;
  const validationMessage = intl.formatMessage({
    id: "selector.quantity.maxQuantity",
    defaultMessage: "We handle a minimum of {minQuantity} and a maximum of {maxQuantity} pieces per order for this product selection"
  }, {
    minQuantity: minimumQuantity,
    maxQuantity: maximumQuantity
  });
  const isStepByStep2 = selectionMode === "step-by-step";
  const quantityPricePerDeliveryOption = pricesPerQuantity.filter(quantity => quantity.deliveryType.name === selectedDeliveryOption.name);
  const visibleQuantities = useMemo6(() => {
    const quantities = quantityPricePerDeliveryOption;
    const index = quantities.findIndex(_ref318 => {
      let {
        quantity
      } = _ref318;
      return quantity === totalQuantity;
    });
    if (!showAllQuantities) {
      if (index >= INITIAL_QUANTITIES_TO_SHOW) {
        return quantities;
      }
      return quantities.slice(0, INITIAL_QUANTITIES_TO_SHOW);
    }
    return quantities;
  }, [quantityPricePerDeliveryOption, showAllQuantities, totalQuantity]);
  useEffect12(() => {
    const quantities = quantityPricePerDeliveryOption;
    const index = quantities.findIndex(_ref319 => {
      let {
        quantity
      } = _ref319;
      return quantity === totalQuantity;
    });
    if (!showAllQuantities && index >= INITIAL_QUANTITIES_TO_SHOW) {
      setShowAllQuantities(true);
    }
  }, [quantityPricePerDeliveryOption, totalQuantity, showAllQuantities]);
  const handleToggleQuantityList = () => {
    setShowAllQuantities(!showAllQuantities);
    dispatchDataLayerEntry("selector", "click", {
      "element-type": "button",
      "element-content": showAllQuantities ? "show_less_quantities" : "show_more_quantities",
      "quantities-visible": showAllQuantities ? INITIAL_QUANTITIES_TO_SHOW : quantityPricePerDeliveryOption.length
    });
  };
  useEffect12(() => {
    if (quantityPricePerDeliveryOption.length > 0) {
      dispatchDataLayerEntry("price_overview", "display");
    }
  }, [quantityPricePerDeliveryOption.length]);
  const validate = () => {
    if (!isInputValid) {
      return "error";
    }
    return void 0;
  };
  const fetchPriceForCustomQuantity = () => {
    if (!value || !isInputValid) return;
    send({
      type: "Set custom quantity",
      customQuantity: value
    });
    setValue(0);
    setShowAllQuantities(true);
  };
  const handleSubmit = event => {
    event.preventDefault();
    fetchPriceForCustomQuantity();
    const deliveryOptionLowerCased = selectedDeliveryOption.name.toLowerCase().replace(/ /g, "_");
    dispatchDataLayerEntry("price_overview", "add_custom_quantity", {
      "element-type": "custom_quantity_priceoverview",
      "element-content": "priceoverview_custom_quantity_input",
      "element-context": "priceoverview_custom_quantity_input_".concat(deliveryOptionLowerCased),
      "delivery-type": selectedDeliveryOption.name,
      quantity: value
    });
  };
  useEffect12(() => {
    if (totalQuantity && selectedDeliveryOption.id) {
      var _quantityPricePerDeli;
      const foundPrice = (_quantityPricePerDeli = quantityPricePerDeliveryOption.find(_ref320 => {
        let {
          quantity,
          deliveryType
        } = _ref320;
        return quantity === totalQuantity && deliveryType.name === selectedDeliveryOption.name;
      })) === null || _quantityPricePerDeli === void 0 ? void 0 : _quantityPricePerDeli.deliveryType.price;
      if (foundPrice) {
        send({
          type: "Set price",
          price: foundPrice
        });
      }
    }
  }, [totalQuantity, quantityPricePerDeliveryOption.length, JSON.stringify(selectedDeliveryOption)]);
  if (isLoadingPrices && isStepByStep2) {
    return /* @__PURE__ */jsx33(PriceTableLoading, {
      showCards: false
    });
  }
  if (hasGroupedQuantity(attributes) || !selectorPrices.length && isStepByStep2) {
    return null;
  }
  const handlePriceSelection = (price, deliveryOption, quantity) => {
    send({
      type: "Set price",
      price
    });
    send({
      type: "Set quantity",
      quantity: Number(quantity)
    });
    const deliveryDate = deliveryDates.find(date => date.name === deliveryOption);
    const deliveryOptionLowerCased = deliveryOption.toLowerCase().replace(/ /g, "_");
    const formattedPrice = intl.formatNumber(price[vatMode].centAmount / 100, {
      currency: price[vatMode].currencyCode
    });
    if (!deliveryDate) return;
    if (isStepByStep2) {
      send({
        type: "Set delivery option",
        deliveryOption: deliveryDate
      });
      dispatchDataLayerEntry("price_table", "click", {
        "element-type": "button_pricetable",
        "element-content": "pricetable_price_cell",
        "element-context": "pricetable_column_".concat(deliveryOptionLowerCased),
        "delivery-type": deliveryOption,
        quantity,
        price: formattedPrice
      });
    } else {
      dispatchDataLayerEntry("price_overview", "click", {
        "element-type": "radio_priceoverview",
        "element-content": "priceoverview_price_radio",
        "element-context": "priceoverview_radio_".concat(deliveryOptionLowerCased),
        "delivery-type": deliveryOption,
        quantity,
        price: formattedPrice
      });
    }
  };
  const [prices] = selectorPrices;
  if (isStepByStep2) {
    return /* @__PURE__ */jsxs23("div", {
      "data-cy": "price-table",
      className: "pd:rounded-md pd:border-1",
      children: [/* @__PURE__ */jsx33("div", {
        className: "pd:rounded-t-md pd:bg-dim-100 pd:px-5 pd:pb-2 pd:pt-5",
        children: /* @__PURE__ */jsx33("div", {
          className: "pd:flex pd:items-stretch pd:justify-between",
          children: /* @__PURE__ */jsx33("div", {
            className: "pd:flex pd:flex-wrap pd:gap-2",
            children: /* @__PURE__ */jsx33(Heading3, {
              variant: "display",
              size: "3",
              children: intl.formatMessage(translations.headerFlag)
            })
          })
        })
      }), /* @__PURE__ */jsxs23("table", {
        className: "pd:w-full pd:border-collapse pd:text-center",
        children: [/* @__PURE__ */jsx33("thead", {
          className: "pd:border-b-2",
          children: /* @__PURE__ */jsxs23("tr", {
            children: [/* @__PURE__ */jsx33("th", {
              className: "pd:border pd:p-2 pd:align-bottom pd:font-bold",
              children: intl.formatMessage(translations.quantity)
            }), prices.deliveryTypes.map(deliveryType => /* @__PURE__ */jsx33("th", {
              className: "pd:border pd:p-2",
              children: /* @__PURE__ */jsxs23("div", {
                className: "pd:flex pd:flex-col pd:items-center pd:gap-2",
                children: [/* @__PURE__ */jsx33(Badge2, {
                  variant: getBadgeVariant(deliveryType),
                  children: intl.formatMessage(translations[deliveryType])
                }), /* @__PURE__ */jsx33(DeliveryDate, {
                  deliveryType
                })]
              })
            }, deliveryType))]
          })
        }), /* @__PURE__ */jsx33("tbody", {
          children: prices.quantities.map(_ref321 => {
            let {
              quantity,
              deliveryTypes: deliveries
            } = _ref321;
            return /* @__PURE__ */jsxs23("tr", {
              className: "pd:border",
              children: [/* @__PURE__ */jsx33("td", {
                children: quantity
              }), deliveries.map(_ref322 => {
                let {
                  name,
                  price,
                  discountedPrice
                } = _ref322;
                const selected = quantity === totalQuantity && selectedDeliveryOption.name === name;
                return price ? /* @__PURE__ */jsx33("td", {
                  className: "pd:m-0 pd:border pd:border-x-dim-200 pd:p-0",
                  children: /* @__PURE__ */jsxs23("button", {
                    "aria-label": "".concat(name, "-").concat(quantity),
                    "data-testid": "price-table-button",
                    type: "button",
                    className: cx9("pd:group pd:p-3 pd:w-full pd:hover:bg-primary-500 pd:hover:text-white", {
                      "pd:bg-primary-500 pd:text-white": selected
                    }),
                    onClick: () => handlePriceSelection(price, name, quantity),
                    children: [/* @__PURE__ */jsx33("span", {
                      className: "pd:block",
                      children: /* @__PURE__ */jsx33(Money, {
                        value: getPriceAmount(vatMode, price, discountedPrice),
                        showCurrency: false
                      })
                    }), /* @__PURE__ */jsx33("span", {
                      className: "pd:block",
                      children: /* @__PURE__ */jsx33(FormattedMessage18, {
                        id: translations[vatMode].id,
                        defaultMessage: translations[vatMode].defaultMessage
                      })
                    })]
                  })
                }, name) : /* @__PURE__ */jsx33("td", {});
              })]
            }, quantity);
          })
        })]
      })]
    });
  }
  return /* @__PURE__ */jsx33("section", {
    children: /* @__PURE__ */jsxs23(Collapsible5, {
      id: "quantity",
      variant: "secondary",
      isOpen: open,
      defaultOpen: true,
      className: "pd:mb-4",
      children: [/* @__PURE__ */jsx33(Collapsible5.Header, {
        "data-cy": "quantity-collapsible-header",
        title: intl.formatMessage({
          id: "selector.quantity.title",
          defaultMessage: "Quantity"
        }),
        button: /* @__PURE__ */jsx33(Collapsible5.Button, {
          onClick: () => setOpen(!open)
        }),
        children: /* @__PURE__ */jsx33(FormattedMessage18, {
          id: "selector.quantity.suffix",
          defaultMessage: "{value} pieces",
          values: {
            value: totalQuantity
          }
        })
      }), /* @__PURE__ */jsxs23(Collapsible5.Panel, {
        children: [visibleQuantities.map(_ref323 => {
          let {
            quantity,
            deliveryType
          } = _ref323;
          return /* @__PURE__ */jsx33(RadioField, {
            id: "".concat(slugify(deliveryType.name), "-").concat(quantity),
            "data-testid": "quantity-option-radio",
            name: "quantity",
            checked: quantity === totalQuantity,
            label: /* @__PURE__ */jsx33(FormattedMessage18, {
              id: "selector.quantityGrid.label",
              defaultMessage: "{quantity} pieces",
              values: {
                quantity
              }
            }),
            onChange: () => {
              if (deliveryType.price) {
                handlePriceSelection(deliveryType.price, deliveryType.name, quantity);
              }
            },
            className: "pd:mb-3",
            description: /* @__PURE__ */jsx33(FormattedMessage18, {
              id: "selector.quantityGrid.description",
              defaultMessage: "{value} per piece",
              values: {
                value: deliveryType.unitPrice && intl.formatNumber(getPriceAmount("totalNet", deliveryType.unitPrice, deliveryType.discountedUnitPrice) / 100, {
                  style: "currency",
                  currencyDisplay: "symbol",
                  currency: deliveryType.unitPrice.totalNet.currencyCode
                })
              }
            }),
            suffix: deliveryType.percentageSavings !== 0 && /* @__PURE__ */jsx33("span", {
              className: "pd:text-success-600",
              children: /* @__PURE__ */jsx33(FormattedMessage18, {
                id: "selector.quantityGrid.suffix",
                defaultMessage: "Save {value}%",
                values: {
                  value: deliveryType.percentageSavings
                }
              })
            })
          }, "".concat(deliveryType.name, "-").concat(quantity));
        }), !isLoadingPrices && /* @__PURE__ */jsx33("form", {
          id: "custom-quantity-form",
          onSubmit: handleSubmit,
          children: /* @__PURE__ */jsx33(TextField3, {
            "data-testid": "custom-quantity",
            type: "number",
            name: "customQuantity",
            min: minimumQuantity,
            max: maximumQuantity,
            id: "customQuantity",
            validation: validate(),
            validationMessage: isInputValid ? "" : validationMessage,
            description: intl.formatMessage({
              id: "selector.quantityGrid.customQuantityDescription",
              defaultMessage: "Enter your own quantity"
            }),
            suffix: intl.formatMessage({
              id: "selector.quantityGrid.customQuantitySuffix",
              defaultMessage: "pieces"
            }),
            onBlur: fetchPriceForCustomQuantity,
            onChange: event => setValue(event.target.value ? Number(event.target.value) : 0)
          })
        }), quantityPricePerDeliveryOption.length > INITIAL_QUANTITIES_TO_SHOW && /* @__PURE__ */jsxs23("button", {
          "data-testid": "show-more-quantities",
          type: "button",
          onClick: handleToggleQuantityList,
          className: "pd:flex pd:w-full pd:items-center pd:justify-center pd:gap-2 pd:py-2 pd:text-sm pd:font-bold",
          children: [/* @__PURE__ */jsx33(Icon3, {
            icon: showAllQuantities ? "arrow-up" : "arrow-down"
          }), showAllQuantities ? intl.formatMessage(translations.showLessQuantities) : intl.formatMessage(translations.showMoreQuantities)]
        }), isLoadingPrices && /* @__PURE__ */jsx33("div", {
          className: "pd:border pd:p-2",
          children: /* @__PURE__ */jsx33("div", {
            className: "pd:flex pd:w-full pd:justify-center",
            children: /* @__PURE__ */jsx33(Spinner5, {
              "data-testid": "custom-quantity-spinner",
              variant: "dim",
              screenReaderLabel: intl.formatMessage({
                id: "uilib.spinner.loading",
                defaultMessage: "Loading..."
              })
            })
          })
        })]
      })]
    })
  });
};

// src/components/selector/PrintingColorPricingExperiment.tsx
import { jsx as jsx34 } from "react/jsx-runtime";
var shouldShowExperiment = (pageLayout, attributeName, selectionMode, defaultSelection, isPageIncluded) => pageLayout === "PPAG" && ["Deco 1 Technology", "Printing Process"].includes(attributeName) && selectionMode === "default-values" && !Number(defaultSelection.groupedQuantity) && !isPageIncluded;
var PrintingColorPricingExperiment = _ref324 => {
  var _exp1928config$variab;
  let {
    prefilledSelection,
    pageLayout,
    productPageId,
    attribute,
    selectionMode,
    defaultSelection
  } = _ref324;
  const {
    featureConfig: exp1928config
  } = useFeatureConfig2("exp1928_ppag_printing_colors_best_option_config");
  const isPageIncluded = exp1928config === null || exp1928config === void 0 || (_exp1928config$variab = exp1928config.variables) === null || _exp1928config$variab === void 0 || (_exp1928config$variab = _exp1928config$variab.contentfulIds) === null || _exp1928config$variab === void 0 ? void 0 : _exp1928config$variab.includes(productPageId || "");
  if (!shouldShowExperiment(pageLayout, attribute.name, selectionMode, defaultSelection, isPageIncluded)) {
    return null;
  }
  return /* @__PURE__ */jsx34(Experiment, {
    id: "exp1928_ppag_printing_colors_best_option",
    children: /* @__PURE__ */jsx34(Experiment.Variant, {
      children: /* @__PURE__ */jsx34(Pricing, {
        hasPrefilledSelection: Boolean(prefilledSelection)
      })
    })
  });
};

// src/components/selector/Selector.tsx
import { jsx as jsx35, jsxs as jsxs24 } from "react/jsx-runtime";
var Selector = _ref325 => {
  let {
    productPageId,
    selector,
    customerGroupId,
    isReviewPage = false,
    shippingAddress = {
      CountryCode: "NL",
      PostalCode: "7418 ET"
    },
    prefilledSelection = void 0,
    serviceKeys = [],
    deliveryOptionId,
    quantity,
    pageLayout
  } = _ref325;
  const {
    locale
  } = useIntl18();
  const isMobile = useMediaQuery("(max-width: 768px)");
  const send = useSelectorMachineSend();
  const updatedAttributes = useSelectorMachineContext(state => state.context.attributes);
  const [filteredAttributes, setFilteredAttributes] = useState16();
  const [isSelectorLoaded, setSelectorLoaded] = useState16(false);
  const {
    configuration,
    product,
    selectionMode
  } = selector;
  const attributes = updatedAttributes.length ? updatedAttributes : configuration.attributes;
  const touchedAttributes = useSelectorMachineContext(state => state.context.touchedAttributes);
  const [selectionInteractionStarted, setSelectionInteractionStarted] = useState16(false);
  const {
    status,
    data: selectorExperiment
  } = useSelectorExperiment({
    productPageId,
    locale,
    enabled: Boolean(productPageId)
  });
  const isSelectorExperiment = status === "success" && Boolean(selectorExperiment);
  const {
    isInitialized,
    experiment: exp1574
  } = useExperiment4("ninjas_exp1574_selector_on_printing_colors", () => {});
  useEffect13(() => {
    const defaultSelection2 = getDefaultSelection(attributes);
    const url = getCurrentUrl();
    const urlSelection = getSelectionFromUrl(url, product.attributes);
    const urlGroupSelection = getGroupFromUrl(url);
    const {
      selection: selection2,
      groupSelection
    } = formatPrefilledSelection(configuration.attributes, prefilledSelection || urlSelection);
    const quantityParam = getParamFromUrl(url, "quantity");
    const deliveryOptionIdParam = getParamFromUrl(url, "deliveryOptionId");
    send({
      type: "Start machine",
      attributes,
      selection: selection2 || defaultSelection2,
      group: groupSelection || urlGroupSelection,
      groupAttributes: getGroupAttributes(attributes),
      panel: {
        panelName: "groupedQuantity",
        openPanel: isReviewPage
      },
      totalQuantity: getTotalQuantity({
        quantity,
        quantityParam,
        urlSelection,
        defaultSelection: defaultSelection2
      }),
      productKey: product.key,
      serviceKeys,
      mcpSku: product.mcpSku,
      shippingAddress,
      customerGroupId,
      device: isMobile ? "mobile" : "desktop",
      isReviewPage,
      selectionMode,
      product: selector.product,
      selectedDeliveryOptionId: deliveryOptionId || deliveryOptionIdParam
    });
    return () => {
      send({
        type: "Reset machine"
      });
    };
  }, []);
  useEffect13(() => {
    send({
      type: "Set device",
      device: isMobile ? "mobile" : "desktop"
    });
  }, [isMobile]);
  useEffect13(() => {
    if (isSelectorExperiment && selectionMode === "default-values" && isInitialized && exp1574.variation) {
      addDataLayerEntry4("experimentation", {
        experiment_name: "Experiment - ".concat(exp1574.id),
        experiment_variant: "Variation - ".concat(exp1574.variation)
      });
      send({
        type: "Exp1574",
        isExp1574: exp1574.variation === "variant"
      });
    }
  }, [isSelectorExperiment, isInitialized, exp1574.variation, selectionMode]);
  const remainingOptions = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const selection = useSelectorMachineContext(state => state.context.selection);
  const selectorState = useSelectorState();
  const isIdle = selectorState === "idle";
  useEffect13(() => {
    if (isReviewPage && (Object.keys(selection).length === 0 || remainingOptions.length === 0)) return;
    setFilteredAttributes(filterAttributes(attributes, remainingOptions, isReviewPage, selection, selectionMode));
    setSelectorLoaded(true);
  }, [attributes, remainingOptions, isReviewPage, selection]);
  const getExperiment = useGetExperiment2();
  const exp1698 = getExperiment("ninjas_exp1698_easy_and_advanced_selector_options", () => {}).experiment;
  const {
    featureConfig: exp1698FeatureConfig
  } = useFeatureConfig3("exp1698_easy_and_advanced_selector_options");
  const featureConfigVariables = exp1698FeatureConfig.variables;
  const easyAndAdvancedOptionsConfig = productPageId ? featureConfigVariables[productPageId] : void 0;
  const hasEasyAndAdvancedOptions = exp1698.variation === "variant" && Boolean(easyAndAdvancedOptionsConfig);
  const {
    excludeAttributes = [],
    easyOptions = []
  } = easyAndAdvancedOptionsConfig || {};
  const {
    filteredExcludedAttributes,
    filteredAdvancedAttributes
  } = useMemo7(() => getEasyAndAdvancedFilteredAttributes({
    hasEasyAndAdvancedOptions,
    filteredAttributes: filteredAttributes || [],
    excludeAttributes
  }), [filteredAttributes, excludeAttributes, hasEasyAndAdvancedOptions]);
  const showEasyAndAdvancedOptions = hasEasyAndAdvancedOptions && easyOptions.length > 0 && filteredAdvancedAttributes.length > 0;
  const defaultSelection = useMemo7(() => getDefaultSelection(attributes), [attributes]);
  useEffect13(() => {
    if (isInitialized && exp1698.variation && Boolean(easyAndAdvancedOptionsConfig)) {
      trackExperimentVariation(exp1698);
    }
  }, [isInitialized, exp1698.variation, easyAndAdvancedOptionsConfig]);
  if (isReviewPage && (!isSelectorLoaded || !filteredAttributes)) {
    const reviewAttributes = attributes.filter(attribute => attribute.onReviewPage);
    return /* @__PURE__ */jsx35("div", {
      className: "pd:grid pd:animate-pulse pd:gap-6",
      children: reviewAttributes.map(reviewAttribute => /* @__PURE__ */jsx35(LoadingTemplate, {
        isGrid: !!reviewAttribute.grid
      }, reviewAttribute.id))
    });
  }
  if (touchedAttributes.length === 1 && !selectionInteractionStarted) {
    dispatchDataLayerEntry("selector", "selector_interaction_start", {
      contentful_id: productPageId
    });
    setSelectionInteractionStarted(true);
  }
  return /* @__PURE__ */jsxs24(Grid6, {
    className: "pd:@container pd:relative pd:z-10 pd:gap-4",
    "data-test": isIdle ? "machine-idle" : "machine-loading",
    children: [filteredExcludedAttributes.map((attribute, index) => /* @__PURE__ */jsxs24(Grid6.Item, {
      className: clsx3("pd:relative", index > 0 ? "pd:-z-".concat(index) : "pd:z-0"),
      children: [attribute.name === "Delivery Type" && selectionMode === "default-values" && !Number(defaultSelection.groupedQuantity) && /* @__PURE__ */jsx35(Prices_default, {
        filteredAttributes: filteredExcludedAttributes,
        index,
        hasPrefilledSelection: Boolean(prefilledSelection)
      }), /* @__PURE__ */jsx35(PrintingColorPricingExperiment, {
        prefilledSelection,
        pageLayout,
        productPageId,
        attribute,
        selectionMode,
        defaultSelection
      }), /* @__PURE__ */jsx35(Attribute_default, {
        index,
        attribute,
        product: selector.product,
        filteredAttributes: filteredExcludedAttributes,
        hasPrefilledSelection: Boolean(prefilledSelection)
      })]
    }, attribute.id)), showEasyAndAdvancedOptions && /* @__PURE__ */jsx35(EasyAndAdvancedOptions, {
      product,
      easyOptions,
      excludeAttributes,
      filteredAdvancedAttributes,
      supportArticleId: featureConfigVariables.supportArticleId,
      hasPrefilledSelection: Boolean(prefilledSelection)
    }), /* @__PURE__ */jsx35(SizeTableModal_default, {
      productPageId
    }), /* @__PURE__ */jsx35(UnsetModal_default, {
      product: selector.product
    })]
  });
};

// src/components/prices/Prices.tsx
import { useEffect as useEffect17, useMemo as useMemo10 } from "react";
import { useExperiment as useExperiment5, useFeatureConfig as useFeatureConfig4 } from "@printdeal/feature-management/react";
import { addDataLayerEntry as addDataLayerEntry5 } from "@printdeal/data-layer-manager";

// src/components/prices/cards/PriceCards.tsx
import { useContext as useContext3, useEffect as useEffect14 } from "react";
import { FormattedMessage as FormattedMessage19, useIntl as useIntl20 } from "react-intl";
import { Collapsible as Collapsible6, Grid as Grid7, RadioCard as RadioCard3 } from "@printdeal/ui-library";

// src/components/prices/ArrivalDate.tsx
import { FormattedDate as FormattedDate3, useIntl as useIntl19 } from "react-intl";
import { Spinner as Spinner6 } from "@printdeal/ui-library";

// src/statemachines/prices/prices.machine.selectors.ts
var selectArrivalDates = state => state.context.arrivalDates;
var selectSelectedPriceAttributes = state => state.context.selectedPriceAttributes;
var selectCustomQuantities = state => state.context.customQuantities;
var selectPrices = state => state.context.prices;
var selectCustomQuantityPrices = state => state.context.customQuantityPrices;
var selectPriceAttributes = state => state.context.selectedPriceAttributes;

// src/components/prices/ArrivalDate.tsx
import { jsx as jsx36, jsxs as jsxs25 } from "react/jsx-runtime";
var ArrivalDate = _ref326 => {
  let {
    deliveryType,
    printingProcess
  } = _ref326;
  const intl = useIntl19();
  const isLoadingArrivalDates = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Arrival dates": "Loading arrival dates"
    }
  }));
  const arrivalDates = usePricesMachineContext(selectArrivalDates);
  const arrivalDate = getArrivalDate(arrivalDates, deliveryType, printingProcess);
  if (isLoadingArrivalDates) {
    return /* @__PURE__ */jsx36(Spinner6, {
      "data-testid": "spinner",
      size: "sm",
      variant: "dim",
      screenReaderLabel: intl.formatMessage({
        id: "uilib.spinner.loading",
        defaultMessage: "Loading..."
      })
    });
  }
  if (arrivalDate && Date.parse(arrivalDate)) {
    return /* @__PURE__ */jsxs25("div", {
      children: [/* @__PURE__ */jsx36("span", {
        className: "pd:mr-1",
        children: /* @__PURE__ */jsx36(FormattedDate3, {
          weekday: "short",
          value: arrivalDate
        })
      }), /* @__PURE__ */jsx36("span", {
        children: /* @__PURE__ */jsx36(FormattedDate3, {
          month: "short",
          day: "numeric",
          value: arrivalDate
        })
      })]
    });
  }
  return null;
};

// src/components/prices/cards/PriceCards.tsx
import { jsx as jsx37, jsxs as jsxs26 } from "react/jsx-runtime";
var PriceCards = _ref327 => {
  let {
    printingProcessPrice
  } = _ref327;
  const intl = useIntl20();
  const {
    vatMode
  } = useContext3(VatModeContext);
  const selectedPriceAttributes = usePricesMachineContext(selectSelectedPriceAttributes);
  const selectedPrice = usePricesMachineContext(state => {
    var _state$context$select;
    return (_state$context$select = state.context.selectedPrice) === null || _state$context$select === void 0 ? void 0 : _state$context$select.discountedPrice;
  });
  const selectorMachineSend = useSelectorMachineSend();
  const priceMachineSend = usePricesMachineSend();
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  useEffect14(() => {
    if (selectedPrice && selectedPriceAttributes) {
      selectorMachineSend({
        type: "Select attribute value",
        groupedAttributes: _objectSpread(_objectSpread({}, getSelectedPriceAttributes(configurationAttributes, selectedPriceAttributes)), {}, {
          Quantity: String(selectedPriceAttributes.Quantity)
        }),
        shouldValidate: true,
        valid: true
      });
      selectorMachineSend({
        type: "Set price",
        price: selectedPrice
      });
    }
  }, [JSON.stringify(selectedPrice), JSON.stringify(selectedPriceAttributes)]);
  return /* @__PURE__ */jsx37("section", {
    "data-cy": "price-cards",
    children: /* @__PURE__ */jsxs26(Collapsible6, {
      id: "price-cards-collapsible",
      isOpen: true,
      children: [/* @__PURE__ */jsx37(Collapsible6.Header, {
        "data-cy": "price-cards-collapsible-header",
        title: /* @__PURE__ */jsx37(FormattedMessage19, {
          id: "account.order.delivery.title",
          defaultMessage: "Delivery"
        })
      }), /* @__PURE__ */jsx37(Collapsible6.Panel, {
        "data-testid": "price-cards-collapsible-panel",
        children: /* @__PURE__ */jsx37(Grid7, {
          className: "pd:grid-cols-2 pd:gap-4",
          children: printingProcessPrice.quantities.map(_ref328 => {
            let {
              deliveryTypes,
              quantity
            } = _ref328;
            return deliveryTypes.map(_ref329 => {
              let {
                name,
                price,
                discountedPrice
              } = _ref329;
              const priceAttributes = _objectSpread(_objectSpread(_objectSpread({}, getPriceAttribute(configurationAttributes, printingProcessPrice.name)), getPriceAttribute(configurationAttributes, name)), quantity && {
                Quantity: quantity
              });
              if (!price) {
                return null;
              }
              const handlePriceSelection = () => {
                priceMachineSend({
                  type: "Select price",
                  selectedPrice: {
                    price,
                    discountedPrice
                  },
                  selectedPriceAttributes: priceAttributes
                });
              };
              const selected = selectedPriceAttributes && isSelectedPrice(selectedPriceAttributes, priceAttributes);
              return /* @__PURE__ */jsx37(RadioCard3, {
                id: slugify("price-card-".concat(name)),
                name: "price-card-".concat(name),
                onChange: handlePriceSelection,
                checked: selected,
                label: /* @__PURE__ */jsx37(ArrivalDate, {
                  deliveryType: name,
                  printingProcess: printingProcessPrice.name
                }),
                description: /* @__PURE__ */jsxs26(Grid7, {
                  className: "pd:font-normal",
                  children: [/* @__PURE__ */jsx37(Grid7.Item, {
                    children: /* @__PURE__ */jsx37(Money, {
                      value: getPriceAmount(vatMode, price, discountedPrice)
                    })
                  }), /* @__PURE__ */jsx37(Grid7.Item, {
                    children: /* @__PURE__ */jsx37("span", {
                      children: intl.formatMessage(translations[vatMode])
                    })
                  }), /* @__PURE__ */jsxs26(Grid7.Item, {
                    children: [name === "Next Day" && /* @__PURE__ */jsx37(FormattedMessage19, {
                      id: "general.selector.pricetable.deliverymethod.nextDay",
                      defaultMessage: "Next day delivery"
                    }), name === "Express" && /* @__PURE__ */jsx37(FormattedMessage19, {
                      id: "general.selector.pricetable.deliverymethod.express",
                      defaultMessage: "Express delivery"
                    }), name === "Normal" && /* @__PURE__ */jsx37(FormattedMessage19, {
                      id: "general.selector.pricetable.deliverymethod.normal",
                      defaultMessage: "Normal delivery"
                    })]
                  })]
                })
              }, name);
            });
          })
        })
      })]
    })
  });
};

// src/components/prices/table/PriceTable.tsx
import { useContext as useContext5, useMemo as useMemo9 } from "react";
import { FormattedMessage as FormattedMessage22, useIntl as useIntl23 } from "react-intl";
import { Badge as Badge3, Heading as Heading4 } from "@printdeal/ui-library";

// src/components/prices/table/PriceCell.tsx
import { useContext as useContext4, useEffect as useEffect15 } from "react";
import { useIntl as useIntl21 } from "react-intl";
import { Spinner as Spinner7 } from "@printdeal/ui-library";

// src/components/prices/table/PriceToolTip.tsx
import { Tooltip } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage20 } from "react-intl";
import { jsx as jsx38, jsxs as jsxs27 } from "react/jsx-runtime";
var PriceTooltip = _ref330 => {
  let {
    vatMode,
    price,
    children
  } = _ref330;
  const handleTooltipHover = () => {
    dispatchDataLayerEntry("price_table_tooltip", "display");
  };
  return /* @__PURE__ */jsxs27(Tooltip, {
    placement: "top",
    className: "pd:w-full",
    onMouseEnter: handleTooltipHover,
    trigger: /* @__PURE__ */jsx38(Tooltip.Trigger, {
      className: "pd:w-full",
      as: "div",
      children
    }),
    children: [/* @__PURE__ */jsx38(FormattedMessage20, {
      id: "general.product.reseller.tooltip.text",
      defaultMessage: "Regular Price:"
    }), " ", /* @__PURE__ */jsx38(Money, {
      value: getPriceAmount(vatMode, price),
      showCurrency: true
    })]
  });
};

// src/components/prices/table/PriceButton.tsx
import { FormattedMessage as FormattedMessage21 } from "react-intl";
import cx10 from "clsx";
import { jsx as jsx39, jsxs as jsxs28 } from "react/jsx-runtime";
var PriceButton = _ref331 => {
  let {
    vatMode,
    price,
    discountedPrice,
    selected,
    handleClick
  } = _ref331;
  return (
    // The contents of the button are the label, so we don't need an aria-label
    // eslint-disable-next-line jsx-a11y/control-has-associated-label
    /* @__PURE__ */
    jsxs28("button", {
      "data-testid": "price-table-button",
      type: "button",
      className: cx10("pd:p-3 pd:w-full pd:hover:bg-primary-500 pd:hover:text-white", {
        "pd:bg-primary-500 pd:text-white": selected
      }),
      onClick: handleClick,
      children: [/* @__PURE__ */jsx39("span", {
        className: "pd:block",
        children: /* @__PURE__ */jsx39(Money, {
          value: getPriceAmount(vatMode, price, discountedPrice),
          showCurrency: false
        })
      }), /* @__PURE__ */jsx39("span", {
        className: "pd:block",
        children: /* @__PURE__ */jsx39(FormattedMessage21, {
          id: translations[vatMode].id,
          defaultMessage: translations[vatMode].defaultMessage
        })
      })]
    })
  );
};

// src/components/prices/table/PriceCell.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var PriceCell = _ref332 => {
  let {
    price,
    discountedPrice,
    isLoading,
    priceAttributes,
    isReseller = false
  } = _ref332;
  const intl = useIntl21();
  const {
    vatMode
  } = useContext4(VatModeContext);
  const selectorMachineSend = useSelectorMachineSend();
  const priceMachineSend = usePricesMachineSend();
  const selectedPrice = usePricesMachineContext(state => {
    var _state$context$select2;
    return (_state$context$select2 = state.context.selectedPrice) === null || _state$context$select2 === void 0 ? void 0 : _state$context$select2.discountedPrice;
  });
  const selectedPriceAttributes = usePricesMachineContext(state => state.context.selectedPriceAttributes);
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  const handlePriceSelection = () => {
    if (price && priceAttributes) {
      priceMachineSend({
        type: "Select price",
        selectedPrice: {
          price,
          discountedPrice
        },
        selectedPriceAttributes: priceAttributes
      });
      const deliveryType = String(priceAttributes["Delivery Type"]);
      const deliveryTypeLowerCased = deliveryType.toLowerCase().replace(/ /g, "_");
      const formattedPrice = intl.formatNumber(price[vatMode].centAmount / 100, {
        currency: price[vatMode].currencyCode
      });
      dispatchDataLayerEntry("price_table", "click", {
        "element-type": "button_pricetable",
        "element-content": "pricetable_price_cell",
        "element-context": "pricetable_column_".concat(deliveryTypeLowerCased),
        "delivery-type": deliveryType,
        quantity: priceAttributes.Quantity,
        price: formattedPrice
      });
    }
  };
  const selected = selectedPriceAttributes && priceAttributes && isSelectedPrice(selectedPriceAttributes, priceAttributes);
  useEffect15(() => {
    if (selectedPrice && selectedPriceAttributes) {
      selectorMachineSend({
        type: "Select attribute value",
        groupedAttributes: _objectSpread(_objectSpread({}, getSelectedPriceAttributes(configurationAttributes, selectedPriceAttributes)), {}, {
          Quantity: String(selectedPriceAttributes.Quantity)
        }),
        shouldValidate: true,
        valid: true
      });
      selectorMachineSend({
        type: "Set price",
        price: selectedPrice
      });
    }
  }, [JSON.stringify(selectedPrice), JSON.stringify(selectedPriceAttributes)]);
  if (!price) {
    if (isLoading) {
      return /* @__PURE__ */jsx40("td", {
        className: "pd:border",
        children: /* @__PURE__ */jsx40("div", {
          className: "pd:flex pd:w-full pd:justify-center",
          children: /* @__PURE__ */jsx40(Spinner7, {
            variant: "dim",
            screenReaderLabel: intl.formatMessage({
              id: "uilib.spinner.loading",
              defaultMessage: "Loading..."
            })
          })
        })
      });
    }
    return /* @__PURE__ */jsx40("td", {});
  }
  return /* @__PURE__ */jsx40("td", {
    className: "pd:m-0 pd:border-1 pd:border-x-dim-200 pd:p-0",
    children: isReseller ? /* @__PURE__ */jsx40(PriceTooltip, {
      vatMode,
      price,
      children: /* @__PURE__ */jsx40(PriceButton, {
        vatMode,
        price,
        discountedPrice,
        selected,
        handleClick: handlePriceSelection
      })
    }) : /* @__PURE__ */jsx40(PriceButton, {
      vatMode,
      price,
      discountedPrice,
      selected,
      handleClick: handlePriceSelection
    })
  });
};

// src/components/prices/table/CustomQuantities.tsx
import { useEffect as useEffect16, useMemo as useMemo8, useState as useState17 } from "react";

// src/components/prices/table/SelectCustomQuantity.tsx
import { Listbox as Listbox3 } from "@printdeal/ui-library";
import { useIntl as useIntl22 } from "react-intl";
import { jsx as jsx41 } from "react/jsx-runtime";
var SelectCustomQuantity = _ref333 => {
  let {
    quantities,
    onChange,
    selectedQuantity
  } = _ref333;
  const intl = useIntl22();
  return /* @__PURE__ */jsx41(Listbox3, {
    id: "customQuantity",
    name: "customQuantity",
    onChange: value => onChange(Number(value)),
    placeholder: intl.formatMessage({
      id: "pricetable.customQuantities.placeholder",
      defaultMessage: "Higher quantities"
    }),
    value: String(selectedQuantity),
    children: quantities.map(quantity => /* @__PURE__ */jsx41(Listbox3.Option, {
      value: String(quantity),
      children: quantity
    }, quantity))
  });
};

// src/components/prices/table/CustomQuantities.tsx
import { jsx as jsx42, jsxs as jsxs29 } from "react/jsx-runtime";
var addEmptyPrices = (columns, deliveryTypes) => columns.map(column => {
  const present = deliveryTypes.find(deliveryType => deliveryType.name === column.name);
  if (present) {
    return present;
  }
  return column;
});
var CustomQuantities = _ref334 => {
  let {
    printingProcess,
    quantities,
    columns,
    isReseller = false
  } = _ref334;
  const send = usePricesMachineSend();
  const loadingCustomQuantities = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Custom quantities": {
        "Showing custom quantities": "Loading custom quantity prices"
      }
    }
  }));
  const prices = usePricesMachineContext(selectCustomQuantityPrices);
  const selectedPriceAttributes = usePricesMachineContext(selectPriceAttributes);
  const [deliveryTypes, setDeliveryTypes] = useState17(columns);
  const [selectedQuantity, setSelectedQuantity] = useState17(Number(selectedPriceAttributes === null || selectedPriceAttributes === void 0 ? void 0 : selectedPriceAttributes.Quantity));
  const configurationAttributes = useSelectorMachineContext(selectorState => selectorState.context.attributes);
  useEffect16(() => {
    if (selectedPriceAttributes !== null && selectedPriceAttributes !== void 0 && selectedPriceAttributes.Quantity && quantities.includes(Number(selectedPriceAttributes.Quantity))) {
      send({
        type: "Select custom quantity",
        quantity: [Number(selectedPriceAttributes.Quantity)]
      });
    }
  }, [selectedPriceAttributes === null || selectedPriceAttributes === void 0 ? void 0 : selectedPriceAttributes.Quantity]);
  useEffect16(() => {
    if (prices !== null && prices !== void 0 && prices.length) {
      const printingProcessPrice = prices.find(process => process.name === printingProcess);
      if (printingProcessPrice) {
        const [quantity] = printingProcessPrice.quantities;
        setDeliveryTypes(addEmptyPrices(columns, quantity.deliveryTypes));
      }
    }
    return () => {
      setDeliveryTypes(columns);
    };
  }, [prices]);
  const memoizedPriceAttributesMap = useMemo8(() => generatePriceAttributesMap(configurationAttributes, printingProcess, deliveryTypes, selectedQuantity), [configurationAttributes, printingProcess, deliveryTypes, selectedQuantity]);
  return /* @__PURE__ */jsxs29("tr", {
    className: "pd:border-1",
    children: [/* @__PURE__ */jsx42("td", {
      width: "200",
      className: "pd:border-1 pd:p-2",
      children: /* @__PURE__ */jsx42(SelectCustomQuantity, {
        quantities,
        selectedQuantity,
        onChange: quantity => {
          setSelectedQuantity(quantity);
          setDeliveryTypes(columns);
          send({
            type: "Select custom quantity",
            quantity: [quantity]
          });
        }
      })
    }), deliveryTypes.map(deliveryType => {
      const priceAttributes = memoizedPriceAttributesMap.get("".concat(selectedQuantity, "-").concat(deliveryType.name));
      return /* @__PURE__ */jsx42(PriceCell, {
        price: deliveryType.price,
        discountedPrice: deliveryType.discountedPrice,
        isLoading: loadingCustomQuantities,
        priceAttributes,
        isReseller
      }, deliveryType.name);
    })]
  });
};

// src/components/prices/table/PriceTable.tsx
import { jsx as jsx43, jsxs as jsxs30 } from "react/jsx-runtime";
var getValue2 = (values, name) => values === null || values === void 0 ? void 0 : values.find(value => value.pimAttributeValue === name);
var getAttributeValue2 = (attributes, name) => {
  const productAttribue = attributes.find(_ref335 => {
    let {
      values
    } = _ref335;
    return getValue2(values, name);
  });
  return getValue2(productAttribue === null || productAttribue === void 0 ? void 0 : productAttribue.values, name);
};
var getCustomQuantityAmounts = (customQuantities, printingProcess) => {
  if (!customQuantities) {
    return [];
  }
  if (printingProcess) {
    var _customQuantities$pri;
    return (_customQuantities$pri = customQuantities[printingProcess]) !== null && _customQuantities$pri !== void 0 ? _customQuantities$pri : [];
  }
  if (Array.isArray(customQuantities.quantities)) {
    return customQuantities.quantities;
  }
  return [];
};
var PriceTable = _ref336 => {
  var _prices$0$quantities$;
  let {
    product,
    printingProcessPrice,
    isReseller = false,
    productDiscounts,
    expCustomQuantities = {}
  } = _ref336;
  const intl = useIntl23();
  const {
    vatMode
  } = useContext5(VatModeContext);
  const customQuantities = usePricesMachineContext(selectCustomQuantities);
  const attributeValue = getAttributeValue2(product.attributes, printingProcessPrice.name);
  const configurationAttributes = useSelectorMachineContext(state => state.context.attributes);
  const selectedPrice = usePricesMachineContext(state => state.context.selectedPrice);
  const prices = usePricesMachineContext(state => state.context.prices);
  const firstAvailablePrice = prices && prices.length > 0 ? (_prices$0$quantities$ = prices[0].quantities[0]) === null || _prices$0$quantities$ === void 0 || (_prices$0$quantities$ = _prices$0$quantities$.deliveryTypes) === null || _prices$0$quantities$ === void 0 ? void 0 : _prices$0$quantities$[0] : void 0;
  const discountExist = selectedPrice && hasDiscount(vatMode, selectedPrice.price, selectedPrice.discountedPrice) || firstAvailablePrice && firstAvailablePrice.price && firstAvailablePrice.discountedPrice && hasDiscount(vatMode, firstAvailablePrice.price, firstAvailablePrice.discountedPrice);
  const showDiscountBadge = discountExist && isReseller;
  const isNextDayDisabled = false;
  const deliveryTypesPrices = useMemo9(
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  () => isNextDayDisabled ? printingProcessPrice.deliveryTypes.filter(deliveryType => deliveryType !== "Next Day") : printingProcessPrice.deliveryTypes, [JSON.stringify(printingProcessPrice.deliveryTypes), isNextDayDisabled]);
  const quantities = useMemo9(
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  () => isNextDayDisabled ? printingProcessPrice.quantities.map(quantity => {
    const filterDeliveryTypes = quantity.deliveryTypes.filter(deliveryType => deliveryType.name !== "Next Day");
    return _objectSpread(_objectSpread({}, quantity), {}, {
      deliveryTypes: filterDeliveryTypes
    });
  }) : printingProcessPrice.quantities, [JSON.stringify(printingProcessPrice.quantities), isNextDayDisabled]);
  const memoizedPriceAttributesMap = useMemo9(() => {
    const map = /* @__PURE__ */new Map();
    quantities.forEach(_ref337 => {
      let {
        quantity,
        deliveryTypes
      } = _ref337;
      const deliveryTypesMap = generatePriceAttributesMap(configurationAttributes, printingProcessPrice.name, deliveryTypes, quantity);
      deliveryTypesMap.forEach((value, key2) => map.set(key2, value));
    });
    return map;
  }, [quantities, product.attributes, printingProcessPrice.name]);
  const customQuantitiesAmounts = getCustomQuantityAmounts(_objectSpread(_objectSpread({}, customQuantities), expCustomQuantities), printingProcessPrice.name);
  const key = printingProcessPrice.name ? printingProcessPrice.name.toLowerCase().replace(/\s/g, "") : "unknown";
  const titleTranslation = translations["printingType_".concat(key)];
  const descriptionTranslation = translations["description_".concat(key)];
  return /* @__PURE__ */jsxs30("div", {
    "data-testid": "price-table",
    className: "pd:rounded-md pd:border-t-1",
    children: [/* @__PURE__ */jsx43("div", {
      className: "pd:rounded-t-md pd:border-x-1 pd:bg-dim-100 pd:px-5 pd:pb-2 pd:pt-5",
      children: /* @__PURE__ */jsx43("div", {
        className: "pd:flex pd:items-stretch pd:justify-between",
        children: /* @__PURE__ */jsxs30("div", {
          className: "pd:flex pd:flex-wrap pd:gap-2",
          children: [/* @__PURE__ */jsx43(Heading4, {
            variant: "display",
            size: "3",
            children: intl.formatMessage(translations.headerFlag)
          }), /* @__PURE__ */jsxs30("div", {
            className: "pd:text-lg pd:font-normal pd:text-dim-600",
            children: [(attributeValue === null || attributeValue === void 0 ? void 0 : attributeValue.attributeValueAlias) || titleTranslation && intl.formatMessage(titleTranslation), descriptionTranslation && " (".concat(intl.formatMessage(descriptionTranslation), ")"), productDiscounts && productDiscounts.length > 0 && /* @__PURE__ */jsxs30(Badge3, {
              className: "pd:sm:ml-2",
              variant: "warning",
              children: ["".concat(productDiscounts[0].discountValue.percentage, "% "), /* @__PURE__ */jsx43(FormattedMessage22, {
                id: "product.discount-calculated",
                defaultMessage: "discount calculated"
              })]
            }), showDiscountBadge && /* @__PURE__ */jsx43(Badge3, {
              className: "pd:sm:ml-2",
              variant: "warning",
              children: /* @__PURE__ */jsx43(FormattedMessage22, {
                id: "general.discounts.reseller.text",
                defaultMessage: "Partner pro discount calculated"
              })
            })]
          })]
        })
      })
    }), /* @__PURE__ */jsxs30("table", {
      className: "pd:w-full pd:border-collapse pd:text-center",
      children: [/* @__PURE__ */jsx43("thead", {
        children: /* @__PURE__ */jsxs30("tr", {
          className: "pd:border-1",
          children: [/* @__PURE__ */jsx43("th", {
            className: "pd:border-1 pd:p-2 pd:align-bottom pd:font-bold",
            children: intl.formatMessage(translations.quantity)
          }), deliveryTypesPrices.map(deliveryType => /* @__PURE__ */jsx43("th", {
            className: "pd:border-1 pd:p-2",
            children: /* @__PURE__ */jsxs30("div", {
              className: "pd:flex pd:flex-col pd:items-center pd:gap-2",
              children: [/* @__PURE__ */jsx43(Badge3, {
                variant: getBadgeVariant(deliveryType),
                children: intl.formatMessage(translations[deliveryType])
              }), /* @__PURE__ */jsx43(ArrivalDate, {
                deliveryType,
                printingProcess: printingProcessPrice.name
              })]
            })
          }, deliveryType))]
        })
      }), /* @__PURE__ */jsxs30("tbody", {
        children: [quantities.map(_ref338 => {
          let {
            quantity,
            deliveryTypes: deliveries
          } = _ref338;
          return /* @__PURE__ */jsxs30("tr", {
            className: "pd:border-1",
            children: [/* @__PURE__ */jsx43("td", {
              children: quantity
            }), deliveries.map(deliveryType => {
              const priceAttributes = memoizedPriceAttributesMap.get("".concat(quantity, "-").concat(deliveryType.name));
              return /* @__PURE__ */jsx43(PriceCell, {
                price: deliveryType.price,
                discountedPrice: deliveryType.discountedPrice,
                priceAttributes,
                isReseller
              }, "".concat(quantity, "-").concat(deliveryType.name));
            })]
          }, quantity);
        }), customQuantitiesAmounts.length > 0 && /* @__PURE__ */jsx43(CustomQuantities, {
          quantities: customQuantitiesAmounts,
          printingProcess: printingProcessPrice.name,
          columns: deliveryTypesPrices.map(deliveryType => ({
            name: deliveryType
          })),
          isReseller
        })]
      })]
    })]
  });
};

// src/components/prices/Prices.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var PricesComponent = _ref339 => {
  let {
    selectionAttributes,
    group,
    quantity,
    product,
    shippingAddress,
    sort,
    preselectedPriceAttributes,
    customerGroupId,
    inventoryCheckEnabled,
    merchandisedQuantities,
    contentfulId,
    isReseller = false,
    productDiscounts
  } = _ref339;
  const quantityList = quantity ? [quantity] : [];
  const requestedQuantity = merchandisedQuantities !== null && merchandisedQuantities !== void 0 && merchandisedQuantities.length ? merchandisedQuantities : quantityList;
  const showCards = Boolean(quantity) || group.length;
  const send = usePricesMachineSend();
  const loadingPrices = usePricesMachineContext(state => state.matches("Loading prices"));
  const isShowingPrices = usePricesMachineContext(state => state.matches("Showing Prices"));
  const prices = usePricesMachineContext(selectPrices);
  const isShowingArrivalDates = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Arrival dates": "Showing arrival dates"
    }
  }));
  const waitingForCustomQuantitySelection = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Custom quantities": {
        "Showing custom quantities": "Waiting for quantity selection"
      }
    }
  }));
  const showingCustomQuantityPrices = usePricesMachineContext(state => state.matches({
    "Showing Prices": {
      "Custom quantities": {
        "Showing custom quantities": "Showing custom quantity prices"
      }
    }
  }));
  const isIdle = isShowingArrivalDates && (waitingForCustomQuantitySelection || showingCustomQuantityPrices);
  const remainingOptions = useSelectorMachineContext(state => state.context.remainingOptionsPerGroup);
  const {
    isInitialized,
    experiment
  } = useExperiment5("exp1929_reduce_print_volumes_in_the_price_table_of_brochures_geniet", () => {});
  const {
    featureConfig: exp1929Config
  } = useFeatureConfig4("reduce_print_volumes_in_the_price_table_of_brochures_geniet");
  const expVariables = exp1929Config.variables;
  const expVariable = contentfulId ? expVariables[contentfulId] : void 0;
  const isExp1929 = Boolean(isInitialized && experiment.variation === "variant" && expVariable);
  useEffect17(() => {
    send({
      type: "Start machine",
      mcpSku: product.mcpSku,
      productKey: product.key,
      selectionAttributes,
      shippingAddress,
      group,
      customerGroupId,
      quantity: requestedQuantity,
      preselectedPriceAttributes,
      sort,
      inventoryCheckEnabled,
      merchandisedQuantities,
      remainingOptions
    });
    return () => {
      send({
        type: "Reset"
      });
    };
  }, []);
  useEffect17(() => {
    send({
      type: "Get prices",
      selectionAttributes,
      group,
      quantity: requestedQuantity,
      customerGroupId
    });
  }, [JSON.stringify(selectionAttributes), customerGroupId, JSON.stringify(group)]);
  useEffect17(() => {
    if (isShowingPrices) {
      dispatchDataLayerEntry("price_table", "display", {
        contentful_id: contentfulId
      });
    }
  }, [isShowingPrices]);
  useEffect17(() => {
    if (isInitialized && isShowingPrices && experiment.variation && expVariable) {
      addDataLayerEntry5("experimentation", {
        experiment_name: "Experiment - ".concat(experiment.id),
        experiment_variant: "Variation - ".concat(experiment.variation)
      });
    }
  }, [isInitialized, experiment.variation, isShowingPrices, expVariable]);
  const {
    prices: experimentPrices,
    expCustomQuantities
  } = useMemo10(() => getExperimentPrices(prices !== null && prices !== void 0 ? prices : [], isExp1929, expVariable), [prices, isExp1929, expVariable]);
  if (loadingPrices) {
    return /* @__PURE__ */jsx44(PriceTableLoading, {
      showCards
    });
  }
  if (isShowingPrices) {
    return /* @__PURE__ */jsx44("div", {
      "data-test": isIdle ? "machine-idle" : "machine-loading",
      className: "pd:flex pd:flex-col pd:gap-5",
      children: experimentPrices.map(printingProcessPrice => {
        if (showCards) {
          return /* @__PURE__ */jsx44(PriceCards, {
            printingProcessPrice
          }, printingProcessPrice.name);
        }
        return /* @__PURE__ */jsx44(PriceTable, {
          printingProcessPrice,
          product,
          isReseller,
          productDiscounts,
          expCustomQuantities
        }, printingProcessPrice.name);
      })
    });
  }
  return null;
};

// src/components/selector/DeliveryOptions.tsx
import { useIntl as useIntl24 } from "react-intl";
import { Collapsible as Collapsible7, Grid as Grid8, RadioCard as RadioCard4, Spinner as Spinner8 } from "@printdeal/ui-library";
import { jsx as jsx45, jsxs as jsxs31 } from "react/jsx-runtime";
var DeliveryOptions = _ref340 => {
  let {
    hasPrefilledSelection = false
  } = _ref340;
  const intl = useIntl24();
  const send = useSelectorMachineSend();
  const pricesLoading = useSelectorMachineContext(state => state.matches({
    STARTED: {
      "FETCHING DATA": {
        PRICES: "FETCHING PRICES"
      }
    }
  }) || state.matches({
    STARTED: {
      "FETCHING DATA": {
        "PIVOT PRICES": "FETCHING PIVOT PRICES"
      }
    }
  }));
  const deliveryOptions = useSelectorMachineContext(state => state.context.deliveryDates);
  const pivotPrices = useSelectorMachineContext(state => state.context.pivotPrices);
  const selectedDeliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const attributes = useSelectorMachineContext(state => state.context.attributes);
  const isLoadingDeliveryDates = useMatchesState({
    STARTED: {
      "FETCHING DATA": {
        "FETCH DELIVERY DATES": "FETCHING DELIVERY DATES"
      }
    }
  });
  const {
    open,
    setOpen
  } = useCollapseLogic({
    filteredAttributes: attributes,
    attributeName: "Delivery Options",
    attributeIndex: attributes.length + 1,
    selectedValue: {
      name: selectedDeliveryOption.name
    },
    hasPrefilledSelection
  });
  const handleChange = deliveryOption => {
    send({
      type: "Set delivery option",
      deliveryOption
    });
  };
  const deliveryDateLoading = isLoadingDeliveryDates && /* @__PURE__ */jsx45(Spinner8, {
    "data-testid": "spinner",
    size: "sm",
    variant: "dim",
    screenReaderLabel: intl.formatMessage({
      id: "uilib.spinner.loading",
      defaultMessage: "Loading..."
    })
  });
  return /* @__PURE__ */jsxs31(Collapsible7, {
    "data-testid": "Delivery Options",
    id: "DeliveryOptions",
    variant: "secondary",
    isOpen: open,
    defaultOpen: true,
    className: "pd:@container pd:mb-4",
    children: [/* @__PURE__ */jsx45(Collapsible7.Header, {
      "data-cy": "DeliveryOptions-collapsible-header",
      title: intl.formatMessage({
        id: "selector.deliveryoption.title",
        defaultMessage: "Delivery option"
      }),
      button: /* @__PURE__ */jsx45(Collapsible7.Button, {
        onClick: () => setOpen(!open)
      }),
      children: /* @__PURE__ */jsx45("div", {
        className: "pd:flex pd:items-center pd:justify-between",
        children: intl.formatMessage(translations[selectedDeliveryOption.name])
      })
    }), /* @__PURE__ */jsx45(Collapsible7.Panel, {
      "data-cy": "DeliveryOptions-collapsible-panel",
      children: /* @__PURE__ */jsx45(Grid8, {
        className: "pd:grid-cols-1 pd:@xs:grid-cols-2 pd:@md:grid-cols-3 pd:@2xl:grid-cols-4 pd:gap-4",
        children: deliveryOptions.map(_ref341 => {
          var _pivotPrices$EdoId, _pivotPrices$EdoId2;
          let {
            id,
            name,
            date,
            cutofftime
          } = _ref341;
          return /* @__PURE__ */jsx45(Grid8.Item, {
            children: /* @__PURE__ */jsx45(RadioCard4, {
              name,
              id: slugify(name),
              value: id,
              checked: id === selectedDeliveryOption.id,
              className: "pd:h-full",
              label: deliveryDateLoading || (date && Date.parse(date) ? /* @__PURE__ */jsx45("span", {
                className: "pd:capitalize",
                children: intl.formatDate(date, {
                  weekday: "long",
                  month: "short",
                  day: "numeric"
                })
              }) : void 0),
              secondaryAction: /* @__PURE__ */jsx45("span", {
                className: "pd:text-md pd:font-normal pd:text-dim-600",
                children: intl.formatMessage(translations[name])
              }),
              onChange: () => handleChange({
                id,
                name,
                date,
                cutofftime
              }),
              description: Boolean(!deliveryDateLoading && ((_pivotPrices$EdoId = pivotPrices.EdoId) === null || _pivotPrices$EdoId === void 0 ? void 0 : _pivotPrices$EdoId[name])) && /* @__PURE__ */jsx45("p", {
                "data-testid": "".concat(id, "-description"),
                children: /* @__PURE__ */jsx45("span", {
                  "data-testid": pricesLoading ? "prices-loading" : "prices-loaded",
                  className: "pd:text-dim-600 pd:text-md pd:font-normal",
                  children: /* @__PURE__ */jsx45(PivotPrice, {
                    extraCosts: ((_pivotPrices$EdoId2 = pivotPrices.EdoId) === null || _pivotPrices$EdoId2 === void 0 || (_pivotPrices$EdoId2 = _pivotPrices$EdoId2[name]) === null || _pivotPrices$EdoId2 === void 0 ? void 0 : _pivotPrices$EdoId2.totalNet.centAmount) || 0,
                    pricesLoading
                  })
                })
              })
            })
          }, id);
        })
      })
    })]
  });
};

// src/components/prices/SelectVatMode.tsx
import { useContext as useContext6 } from "react";
import { useIntl as useIntl25 } from "react-intl";
import { ToggleField as ToggleField2 } from "@printdeal/ui-library";
import { jsx as jsx46 } from "react/jsx-runtime";
var SelectVatMode = _ref342 => {
  let {
    className = ""
  } = _ref342;
  const intl = useIntl25();
  const {
    vatMode,
    setVatMode
  } = useContext6(VatModeContext);
  const handleVatModeChange = mode => {
    setVatMode(mode);
    dispatchDataLayerEntry("change_vat_mode", "click", {
      vatMode: mode === "totalGross" ? "incl." : "excl."
    });
  };
  return /* @__PURE__ */jsx46(ToggleField2, {
    id: "vat-toggle",
    name: "vat-toggle",
    "data-testid": "vat-toggle",
    className,
    label: intl.formatMessage({
      id: "pricetable.pricemode.gross",
      defaultMessage: "Incl. VAT"
    }),
    checked: vatMode === "totalGross",
    onChange: checked => handleVatModeChange(checked ? "totalGross" : "totalNet")
  });
};
export { DeliveryOptions, Money, PricesComponent, PricesContextProvider, Pricing, SelectVatMode, Selector, SelectorContextProvider, SizeTableFormId, SupportArticleModal, VatModeContext, VatModeProvider, contentfulClient, generateSelectionParameters, getAttributes, getGroupFromUrl, getPriceGroups, getPricePivot, getProductAttribute, getResolvedAttribute, getResolvedNumericAttribute, getResolvedStringAttribute, getSelectedPriceAttributes, getSelectionFromUrl, getTotalPrice, hasDiscount, hasGroupedQuantity, pricePivotAttributes, productClient, useMatchesState, useNewSelector, usePricesMachineContext, usePricesMachineSend, useSelectorContentById, useSelectorContentByPageId, useSelectorMachineContext, useSelectorMachineSend, useSelectorState, useSyncSelectionToUrl, validationClient };